/**
 * Generated by orval 🍺
 * Do not edit manually.
 * qcs control-plane
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuditOut,
  AvailabilityDayCloseOut,
  AvailabilityPlatform,
  AvailabilityRebuildRequest,
  BodyBulkUploadV1BrandsBulkUploadPost,
  BodyCreateImportV1SnapshotsImportsPost,
  BodyImportJobsV1JobsImportPost,
  BodyImportPreflightV1SnapshotsImportsPreflightPost,
  BodyImportTreeV1TaxonomyImportPost,
  BrandBulkDelete,
  BrandBulkDeleteResult,
  BrandCandidateCreate,
  BrandCandidateOut,
  BrandCandidateUpdate,
  BrandCreate,
  BrandMatches,
  BrandOut,
  BrandRename,
  BrandRenameResult,
  BrandSetEnabled,
  BrandSetForceAllStores,
  BrandSetPriority,
  BrandSkusExportCountV1BrandsSkusExportCountGetParams,
  BrandSkusExportV1BrandsSkusExportGetParams,
  BrandSkusV1BrandsSkusGetParams,
  BrandSweepLaunch,
  BrandSweepLaunchResult,
  BrandUpdate,
  BulkCommitRequest,
  BulkCommitResult,
  BulkUploadOut,
  BurnRow,
  CatalogOut,
  CategoryOut,
  CategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetParams,
  CategoryShelfV1RankCategoriesPlatformShelfGetParams,
  CompareHandoffV1RunsCompareHandoffGetParams,
  CompareRunsV1RunsCompareGetParams,
  CompareStoreDiffV1RunsCompareStoreDiffGetParams,
  DaysV1AvailabilityDaysGetParams,
  DeadSubnetRow,
  DeleteNodeV1TaxonomyNodesNodeIdDeleteParams,
  DeleteSettingV1SettingsKeyDeleteParams,
  EnabledUpdate,
  EventsV1ProxyEventsGetParams,
  ExportRequest,
  FleetRightsizingOut,
  HTTPValidationError,
  HealthV1AvailabilityHealthGetParams,
  HealthzHealthzGet200,
  ImportJobsV1JobsImportPostParams,
  ImportTreeV1TaxonomyImportPostParams,
  IndiaBoundary,
  JobCreate,
  JobImportResult,
  JobKnobDescriptor,
  JobOut,
  JobUpdate,
  KeywordCreate,
  KeywordOut,
  KeywordShelfRunsV1RankKeywordsKeywordRunsGetParams,
  KeywordShelfV1RankKeywordsKeywordShelfGetParams,
  LifecycleV1StoresLifecycleGet200,
  LifecycleV1StoresLifecycleGetParams,
  ListAuditV1AuditGetParams,
  ListCategoriesV1RankCategoriesGetParams,
  ListJobKnobsV1JobsKnobsGetParams,
  ListJobsV1JobsGetParams,
  ListRunsV1RunsGetParams,
  LowConfidenceCountsV1BrandsMatchesLowConfidenceGet200,
  MatchMoveRequest,
  MatchMoveResult,
  MatchRenameRequest,
  MatchRow,
  MatchesSummaryV1BrandsBrandIdMatchesSummaryGet200,
  Me,
  MoveCity,
  PipelineV1AvailabilityPipelineGetParams,
  Platform,
  PlatformMeta,
  PoolSummary,
  PreflightOut,
  ProbeConfigOut,
  ProbeConfigUpdate,
  ProbeLocationCreate,
  ProbeLocationOut,
  ProbeLocationSetEnabled,
  ProbeLocationUpdate,
  ProxiesV1ProxyProxiesGetParams,
  ProxyAdminActionOut,
  ProxyCountryPreferenceOut,
  ProxyCountryPreferenceUpdate,
  ProxyEventsOut,
  ProxyListOut,
  ProxyPreferencesOut,
  ProxyResetOut,
  ProxySyncOut,
  ProxyTimeseriesOut,
  ReachCityHealth,
  Readiness,
  ResetPoolV1ProxyResetPostParams,
  RetireRow,
  ReviewSkusV1TaxonomySkusGetParams,
  RunCompare,
  RunCoverage,
  RunCoverageV1RunsRunIdCoverageGetParams,
  RunHandoff,
  RunOut,
  RunStats,
  RunStoreHulls,
  RunSweepStatsBatchV1RunsSweepStatsBatchPost200,
  ScheduleCreate,
  ScheduleOut,
  ScheduleUpdate,
  SearchProbeRequest,
  SearchProbeResult,
  SetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostParams,
  SetSetting,
  SettingOut,
  ShelfOut,
  ShelfRunOut,
  Sku,
  SkuAddResult,
  SkuCountsV1BrandsSkuCountsGet200,
  SkuCountsV1BrandsSkuCountsGetParams,
  SkuDetail,
  SkuEvent,
  SkuEventsV1SkuEventsGetParams,
  SkuExportCount,
  SkuInventorySeries,
  SkuInventoryV1SkusPlatformProductIdInventoryGetParams,
  SkuOverrideResult,
  SkuPdp,
  SkuRemoveRequest,
  SkuRemoveResult,
  SkuSetBundle,
  SkuSetEnabled,
  SkuStoreDetail,
  SkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetParams,
  SkuStoreMap,
  SkuStoreMapV1SkusPlatformProductIdStoreMapGetParams,
  SkuStoreRow,
  SkuUrlProbeResult,
  SkuUrlRequest,
  SnapshotOut,
  Store,
  StoreCoverage,
  StoreCoverageMap,
  StoreDetail,
  StoreDiffProbe,
  StoreEvent,
  StoreEventsV1StoreEventsGetParams,
  StoreExcludeRequest,
  StoreExclusionResult,
  StoreSkuDetail,
  StoresMap,
  StoresV1StoresGetParams,
  TaxonomyClassifyLaunch,
  TaxonomyClassifyLaunchResult,
  TaxonomyImportResult,
  TaxonomyLabelOut,
  TaxonomyNodeCreate,
  TaxonomyNodeOut,
  TaxonomyNodePatch,
  TaxonomyOverrideIn,
  TaxonomyReviewRow,
  TaxonomySummaryOut,
  TaxonomyVersionOut,
  TimeseriesV1ProxyTimeseriesGetParams,
  UsageBurnRateV1ProxyUsageBurnRateGetParams,
  UsageByIpV1ProxyUsageByIpGetParams,
  UsageDeadBySubnetV1ProxyUsageDeadBySubnetGetParams,
  UsageIpProfileV1ProxyUsageIpIpGet200,
  UsageIpProfileV1ProxyUsageIpIpGetParams,
  UsageIpRow,
  UsageRetireV1ProxyUsageRetireGetParams,
  UsageRightsizingV1ProxyUsageRightsizingGetParams,
  UserCreate,
  UserOut,
  UserUpdate,
  WafOverview,
  WafOverviewV1WafOverviewGetParams,
  WafTrendPoint,
  WafTrendV1WafTrendGetParams,
  WipeResult,
  WipeStoreCacheV1StoresCacheDeleteParams,
  WipeStoresV1StoresDeleteParams,
  _SweepStatsBatchIn
} from './model';

import { customFetch } from '../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthzHealthzGetUrl = () => {




  return `/healthz`
}

/**
 * @summary Healthz
 */
export const healthzHealthzGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthzHealthzGet200> => {

  return customFetch<HealthzHealthzGet200>(getHealthzHealthzGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthzHealthzGetQueryKey = () => {
    return [
    `/healthz`
    ] as const;
    }


export const getHealthzHealthzGetQueryOptions = <TData = Awaited<ReturnType<typeof healthzHealthzGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthzHealthzGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthzHealthzGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthzHealthzGet>>> = ({ signal }) => healthzHealthzGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthzHealthzGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthzHealthzGetQueryResult = NonNullable<Awaited<ReturnType<typeof healthzHealthzGet>>>
export type HealthzHealthzGetQueryError = unknown


export function useHealthzHealthzGet<TData = Awaited<ReturnType<typeof healthzHealthzGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthzHealthzGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthzHealthzGet>>,
          TError,
          Awaited<ReturnType<typeof healthzHealthzGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthzHealthzGet<TData = Awaited<ReturnType<typeof healthzHealthzGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthzHealthzGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthzHealthzGet>>,
          TError,
          Awaited<ReturnType<typeof healthzHealthzGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthzHealthzGet<TData = Awaited<ReturnType<typeof healthzHealthzGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthzHealthzGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Healthz
 */

export function useHealthzHealthzGet<TData = Awaited<ReturnType<typeof healthzHealthzGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthzHealthzGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthzHealthzGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReadyzReadyzGetUrl = () => {




  return `/readyz`
}

/**
 * @summary Readyz
 */
export const readyzReadyzGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<Readiness> => {

  return customFetch<Readiness>(getReadyzReadyzGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReadyzReadyzGetQueryKey = () => {
    return [
    `/readyz`
    ] as const;
    }


export const getReadyzReadyzGetQueryOptions = <TData = Awaited<ReturnType<typeof readyzReadyzGet>>, TError = Readiness>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readyzReadyzGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReadyzReadyzGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof readyzReadyzGet>>> = ({ signal }) => readyzReadyzGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof readyzReadyzGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReadyzReadyzGetQueryResult = NonNullable<Awaited<ReturnType<typeof readyzReadyzGet>>>
export type ReadyzReadyzGetQueryError = Readiness


export function useReadyzReadyzGet<TData = Awaited<ReturnType<typeof readyzReadyzGet>>, TError = Readiness>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof readyzReadyzGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readyzReadyzGet>>,
          TError,
          Awaited<ReturnType<typeof readyzReadyzGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadyzReadyzGet<TData = Awaited<ReturnType<typeof readyzReadyzGet>>, TError = Readiness>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readyzReadyzGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readyzReadyzGet>>,
          TError,
          Awaited<ReturnType<typeof readyzReadyzGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadyzReadyzGet<TData = Awaited<ReturnType<typeof readyzReadyzGet>>, TError = Readiness>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readyzReadyzGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Readyz
 */

export function useReadyzReadyzGet<TData = Awaited<ReturnType<typeof readyzReadyzGet>>, TError = Readiness>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readyzReadyzGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReadyzReadyzGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMeV1MeGetUrl = () => {




  return `/v1/me`
}

/**
 * @summary Me
 */
export const meV1MeGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<Me> => {

  return customFetch<Me>(getMeV1MeGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeV1MeGetQueryKey = () => {
    return [
    `/v1/me`
    ] as const;
    }


export const getMeV1MeGetQueryOptions = <TData = Awaited<ReturnType<typeof meV1MeGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meV1MeGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeV1MeGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof meV1MeGet>>> = ({ signal }) => meV1MeGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meV1MeGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeV1MeGetQueryResult = NonNullable<Awaited<ReturnType<typeof meV1MeGet>>>
export type MeV1MeGetQueryError = unknown


export function useMeV1MeGet<TData = Awaited<ReturnType<typeof meV1MeGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meV1MeGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meV1MeGet>>,
          TError,
          Awaited<ReturnType<typeof meV1MeGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeV1MeGet<TData = Awaited<ReturnType<typeof meV1MeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meV1MeGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meV1MeGet>>,
          TError,
          Awaited<ReturnType<typeof meV1MeGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeV1MeGet<TData = Awaited<ReturnType<typeof meV1MeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meV1MeGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Me
 */

export function useMeV1MeGet<TData = Awaited<ReturnType<typeof meV1MeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meV1MeGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeV1MeGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPlatformsV1PlatformsGetUrl = () => {




  return `/v1/platforms`
}

/**
 * Every registered platform's display + capability metadata (static config).
 * @summary List Platforms
 */
export const listPlatformsV1PlatformsGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<PlatformMeta[]> => {

  return customFetch<PlatformMeta[]>(getListPlatformsV1PlatformsGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlatformsV1PlatformsGetQueryKey = () => {
    return [
    `/v1/platforms`
    ] as const;
    }


export const getListPlatformsV1PlatformsGetQueryOptions = <TData = Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlatformsV1PlatformsGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>> = ({ signal }) => listPlatformsV1PlatformsGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlatformsV1PlatformsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>>
export type ListPlatformsV1PlatformsGetQueryError = unknown


export function useListPlatformsV1PlatformsGet<TData = Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>,
          TError,
          Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlatformsV1PlatformsGet<TData = Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>,
          TError,
          Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlatformsV1PlatformsGet<TData = Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Platforms
 */

export function useListPlatformsV1PlatformsGet<TData = Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformsV1PlatformsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPlatformsV1PlatformsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListUsersV1UsersGetUrl = () => {




  return `/v1/users`
}

/**
 * @summary List Users
 */
export const listUsersV1UsersGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<UserOut[]> => {

  return customFetch<UserOut[]>(getListUsersV1UsersGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsersV1UsersGetQueryKey = () => {
    return [
    `/v1/users`
    ] as const;
    }


export const getListUsersV1UsersGetQueryOptions = <TData = Awaited<ReturnType<typeof listUsersV1UsersGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersV1UsersGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersV1UsersGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsersV1UsersGet>>> = ({ signal }) => listUsersV1UsersGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsersV1UsersGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersV1UsersGetQueryResult = NonNullable<Awaited<ReturnType<typeof listUsersV1UsersGet>>>
export type ListUsersV1UsersGetQueryError = unknown


export function useListUsersV1UsersGet<TData = Awaited<ReturnType<typeof listUsersV1UsersGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersV1UsersGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsersV1UsersGet>>,
          TError,
          Awaited<ReturnType<typeof listUsersV1UsersGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsersV1UsersGet<TData = Awaited<ReturnType<typeof listUsersV1UsersGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersV1UsersGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsersV1UsersGet>>,
          TError,
          Awaited<ReturnType<typeof listUsersV1UsersGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsersV1UsersGet<TData = Awaited<ReturnType<typeof listUsersV1UsersGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersV1UsersGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Users
 */

export function useListUsersV1UsersGet<TData = Awaited<ReturnType<typeof listUsersV1UsersGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsersV1UsersGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersV1UsersGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getInviteUserV1UsersPostUrl = () => {




  return `/v1/users`
}

/**
 * @summary Invite User
 */
export const inviteUserV1UsersPost = async (userCreate: UserCreate, options?: Parameters<typeof customFetch>[1]): Promise<UserOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<UserOut>(getInviteUserV1UsersPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(userCreate)
  }
);}





export const getInviteUserV1UsersPostMutationKey = () => ['inviteUserV1UsersPost'] as const;

export const getInviteUserV1UsersPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteUserV1UsersPost>>, TError,InviteUserV1UsersPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteUserV1UsersPost>>, TError,InviteUserV1UsersPostMutationVariables, TContext> => {

const mutationKey = getInviteUserV1UsersPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteUserV1UsersPost>>, InviteUserV1UsersPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  inviteUserV1UsersPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InviteUserV1UsersPostMutationResult = NonNullable<Awaited<ReturnType<typeof inviteUserV1UsersPost>>>
    export type InviteUserV1UsersPostMutationBody = UserCreate
    export type InviteUserV1UsersPostMutationError = HTTPValidationError
    export type InviteUserV1UsersPostMutationVariables = {data: UserCreate}

    /**
 * @summary Invite User
 */
export const useInviteUserV1UsersPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteUserV1UsersPost>>, TError,InviteUserV1UsersPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteUserV1UsersPost>>,
        TError,
        InviteUserV1UsersPostMutationVariables,
        TContext
      > => {
      return useMutation(getInviteUserV1UsersPostMutationOptions(options), queryClient);
    }

export const getUpdateUserV1UsersUserIdPatchUrl = (userId: string,) => {




  return `/v1/users/${userId}`
}

/**
 * @summary Update User
 */
export const updateUserV1UsersUserIdPatch = async (userId: string,
    userUpdate: UserUpdate, options?: Parameters<typeof customFetch>[1]): Promise<UserOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<UserOut>(getUpdateUserV1UsersUserIdPatchUrl(userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(userUpdate)
  }
);}





export const getUpdateUserV1UsersUserIdPatchMutationKey = () => ['updateUserV1UsersUserIdPatch'] as const;

export const getUpdateUserV1UsersUserIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserV1UsersUserIdPatch>>, TError,UpdateUserV1UsersUserIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserV1UsersUserIdPatch>>, TError,UpdateUserV1UsersUserIdPatchMutationVariables, TContext> => {

const mutationKey = getUpdateUserV1UsersUserIdPatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserV1UsersUserIdPatch>>, UpdateUserV1UsersUserIdPatchMutationVariables> = (props) => {
          const {userId,data} = props ?? {};

          return  updateUserV1UsersUserIdPatch(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserV1UsersUserIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserV1UsersUserIdPatch>>>
    export type UpdateUserV1UsersUserIdPatchMutationBody = UserUpdate
    export type UpdateUserV1UsersUserIdPatchMutationError = HTTPValidationError
    export type UpdateUserV1UsersUserIdPatchMutationVariables = {userId: string;data: UserUpdate}

    /**
 * @summary Update User
 */
export const useUpdateUserV1UsersUserIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserV1UsersUserIdPatch>>, TError,UpdateUserV1UsersUserIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUserV1UsersUserIdPatch>>,
        TError,
        UpdateUserV1UsersUserIdPatchMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateUserV1UsersUserIdPatchMutationOptions(options), queryClient);
    }

export const getDeleteUserV1UsersUserIdDeleteUrl = (userId: string,) => {




  return `/v1/users/${userId}`
}

/**
 * @summary Delete User
 */
export const deleteUserV1UsersUserIdDelete = async (userId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteUserV1UsersUserIdDeleteUrl(userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteUserV1UsersUserIdDeleteMutationKey = () => ['deleteUserV1UsersUserIdDelete'] as const;

export const getDeleteUserV1UsersUserIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserV1UsersUserIdDelete>>, TError,DeleteUserV1UsersUserIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserV1UsersUserIdDelete>>, TError,DeleteUserV1UsersUserIdDeleteMutationVariables, TContext> => {

const mutationKey = getDeleteUserV1UsersUserIdDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserV1UsersUserIdDelete>>, DeleteUserV1UsersUserIdDeleteMutationVariables> = (props) => {
          const {userId} = props ?? {};

          return  deleteUserV1UsersUserIdDelete(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserV1UsersUserIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserV1UsersUserIdDelete>>>

    export type DeleteUserV1UsersUserIdDeleteMutationError = HTTPValidationError
    export type DeleteUserV1UsersUserIdDeleteMutationVariables = {userId: string}

    /**
 * @summary Delete User
 */
export const useDeleteUserV1UsersUserIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserV1UsersUserIdDelete>>, TError,DeleteUserV1UsersUserIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserV1UsersUserIdDelete>>,
        TError,
        DeleteUserV1UsersUserIdDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteUserV1UsersUserIdDeleteMutationOptions(options), queryClient);
    }

export const getListAuditV1AuditGetUrl = (params?: ListAuditV1AuditGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/audit?${stringifiedParams}` : `/v1/audit`
}

/**
 * @summary List Audit
 */
export const listAuditV1AuditGet = async (params?: ListAuditV1AuditGetParams, options?: Parameters<typeof customFetch>[1]): Promise<AuditOut[]> => {

  return customFetch<AuditOut[]>(getListAuditV1AuditGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAuditV1AuditGetQueryKey = (params?: ListAuditV1AuditGetParams,) => {
    return [
    `/v1/audit`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAuditV1AuditGetQueryOptions = <TData = Awaited<ReturnType<typeof listAuditV1AuditGet>>, TError = HTTPValidationError>(params?: ListAuditV1AuditGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditV1AuditGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditV1AuditGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditV1AuditGet>>> = ({ signal }) => listAuditV1AuditGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditV1AuditGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAuditV1AuditGetQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditV1AuditGet>>>
export type ListAuditV1AuditGetQueryError = HTTPValidationError


export function useListAuditV1AuditGet<TData = Awaited<ReturnType<typeof listAuditV1AuditGet>>, TError = HTTPValidationError>(
 params: undefined |  ListAuditV1AuditGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditV1AuditGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditV1AuditGet>>,
          TError,
          Awaited<ReturnType<typeof listAuditV1AuditGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditV1AuditGet<TData = Awaited<ReturnType<typeof listAuditV1AuditGet>>, TError = HTTPValidationError>(
 params?: ListAuditV1AuditGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditV1AuditGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAuditV1AuditGet>>,
          TError,
          Awaited<ReturnType<typeof listAuditV1AuditGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAuditV1AuditGet<TData = Awaited<ReturnType<typeof listAuditV1AuditGet>>, TError = HTTPValidationError>(
 params?: ListAuditV1AuditGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditV1AuditGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Audit
 */

export function useListAuditV1AuditGet<TData = Awaited<ReturnType<typeof listAuditV1AuditGet>>, TError = HTTPValidationError>(
 params?: ListAuditV1AuditGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAuditV1AuditGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAuditV1AuditGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getIndiaBoundaryV1GeoIndiaBoundaryGetUrl = () => {




  return `/v1/geo/india-boundary`
}

/**
 * Return the vendored India probe-mask boundary as GeoJSON (outline overlay).
 * @summary India Boundary
 */
export const indiaBoundaryV1GeoIndiaBoundaryGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<IndiaBoundary> => {

  return customFetch<IndiaBoundary>(getIndiaBoundaryV1GeoIndiaBoundaryGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getIndiaBoundaryV1GeoIndiaBoundaryGetQueryKey = () => {
    return [
    `/v1/geo/india-boundary`
    ] as const;
    }


export const getIndiaBoundaryV1GeoIndiaBoundaryGetQueryOptions = <TData = Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIndiaBoundaryV1GeoIndiaBoundaryGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>> = ({ signal }) => indiaBoundaryV1GeoIndiaBoundaryGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IndiaBoundaryV1GeoIndiaBoundaryGetQueryResult = NonNullable<Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>>
export type IndiaBoundaryV1GeoIndiaBoundaryGetQueryError = unknown


export function useIndiaBoundaryV1GeoIndiaBoundaryGet<TData = Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>,
          TError,
          Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIndiaBoundaryV1GeoIndiaBoundaryGet<TData = Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>,
          TError,
          Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIndiaBoundaryV1GeoIndiaBoundaryGet<TData = Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary India Boundary
 */

export function useIndiaBoundaryV1GeoIndiaBoundaryGet<TData = Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof indiaBoundaryV1GeoIndiaBoundaryGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIndiaBoundaryV1GeoIndiaBoundaryGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSummaryV1ProxySummaryGetUrl = () => {




  return `/v1/proxy/summary`
}

/**
 * @summary Summary
 */
export const summaryV1ProxySummaryGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<PoolSummary> => {

  return customFetch<PoolSummary>(getSummaryV1ProxySummaryGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSummaryV1ProxySummaryGetQueryKey = () => {
    return [
    `/v1/proxy/summary`
    ] as const;
    }


export const getSummaryV1ProxySummaryGetQueryOptions = <TData = Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSummaryV1ProxySummaryGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>> = ({ signal }) => summaryV1ProxySummaryGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SummaryV1ProxySummaryGetQueryResult = NonNullable<Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>>
export type SummaryV1ProxySummaryGetQueryError = unknown


export function useSummaryV1ProxySummaryGet<TData = Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>,
          TError,
          Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSummaryV1ProxySummaryGet<TData = Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>,
          TError,
          Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSummaryV1ProxySummaryGet<TData = Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Summary
 */

export function useSummaryV1ProxySummaryGet<TData = Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof summaryV1ProxySummaryGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSummaryV1ProxySummaryGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getProxiesV1ProxyProxiesGetUrl = (params?: ProxiesV1ProxyProxiesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/proxy/proxies?${stringifiedParams}` : `/v1/proxy/proxies`
}

/**
 * @summary Proxies
 */
export const proxiesV1ProxyProxiesGet = async (params?: ProxiesV1ProxyProxiesGetParams, options?: Parameters<typeof customFetch>[1]): Promise<ProxyListOut> => {

  return customFetch<ProxyListOut>(getProxiesV1ProxyProxiesGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProxiesV1ProxyProxiesGetQueryKey = (params?: ProxiesV1ProxyProxiesGetParams,) => {
    return [
    `/v1/proxy/proxies`, ...(params ? [params] : [])
    ] as const;
    }


export const getProxiesV1ProxyProxiesGetQueryOptions = <TData = Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>, TError = HTTPValidationError>(params?: ProxiesV1ProxyProxiesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProxiesV1ProxyProxiesGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>> = ({ signal }) => proxiesV1ProxyProxiesGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProxiesV1ProxyProxiesGetQueryResult = NonNullable<Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>>
export type ProxiesV1ProxyProxiesGetQueryError = HTTPValidationError


export function useProxiesV1ProxyProxiesGet<TData = Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>, TError = HTTPValidationError>(
 params: undefined |  ProxiesV1ProxyProxiesGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>,
          TError,
          Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProxiesV1ProxyProxiesGet<TData = Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>, TError = HTTPValidationError>(
 params?: ProxiesV1ProxyProxiesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>,
          TError,
          Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProxiesV1ProxyProxiesGet<TData = Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>, TError = HTTPValidationError>(
 params?: ProxiesV1ProxyProxiesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Proxies
 */

export function useProxiesV1ProxyProxiesGet<TData = Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>, TError = HTTPValidationError>(
 params?: ProxiesV1ProxyProxiesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proxiesV1ProxyProxiesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProxiesV1ProxyProxiesGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getEventsV1ProxyEventsGetUrl = (params?: EventsV1ProxyEventsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/proxy/events?${stringifiedParams}` : `/v1/proxy/events`
}

/**
 * @summary Events
 */
export const eventsV1ProxyEventsGet = async (params?: EventsV1ProxyEventsGetParams, options?: Parameters<typeof customFetch>[1]): Promise<ProxyEventsOut> => {

  return customFetch<ProxyEventsOut>(getEventsV1ProxyEventsGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getEventsV1ProxyEventsGetQueryKey = (params?: EventsV1ProxyEventsGetParams,) => {
    return [
    `/v1/proxy/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getEventsV1ProxyEventsGetQueryOptions = <TData = Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>, TError = HTTPValidationError>(params?: EventsV1ProxyEventsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getEventsV1ProxyEventsGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>> = ({ signal }) => eventsV1ProxyEventsGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type EventsV1ProxyEventsGetQueryResult = NonNullable<Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>>
export type EventsV1ProxyEventsGetQueryError = HTTPValidationError


export function useEventsV1ProxyEventsGet<TData = Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>, TError = HTTPValidationError>(
 params: undefined |  EventsV1ProxyEventsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>,
          TError,
          Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventsV1ProxyEventsGet<TData = Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>, TError = HTTPValidationError>(
 params?: EventsV1ProxyEventsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>,
          TError,
          Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useEventsV1ProxyEventsGet<TData = Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>, TError = HTTPValidationError>(
 params?: EventsV1ProxyEventsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Events
 */

export function useEventsV1ProxyEventsGet<TData = Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>, TError = HTTPValidationError>(
 params?: EventsV1ProxyEventsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof eventsV1ProxyEventsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEventsV1ProxyEventsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getTimeseriesV1ProxyTimeseriesGetUrl = (params: TimeseriesV1ProxyTimeseriesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/proxy/timeseries?${stringifiedParams}` : `/v1/proxy/timeseries`
}

/**
 * @summary Timeseries
 */
export const timeseriesV1ProxyTimeseriesGet = async (params: TimeseriesV1ProxyTimeseriesGetParams, options?: Parameters<typeof customFetch>[1]): Promise<ProxyTimeseriesOut> => {

  return customFetch<ProxyTimeseriesOut>(getTimeseriesV1ProxyTimeseriesGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTimeseriesV1ProxyTimeseriesGetQueryKey = (params?: TimeseriesV1ProxyTimeseriesGetParams,) => {
    return [
    `/v1/proxy/timeseries`, ...(params ? [params] : [])
    ] as const;
    }


export const getTimeseriesV1ProxyTimeseriesGetQueryOptions = <TData = Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>, TError = HTTPValidationError>(params: TimeseriesV1ProxyTimeseriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTimeseriesV1ProxyTimeseriesGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>> = ({ signal }) => timeseriesV1ProxyTimeseriesGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TimeseriesV1ProxyTimeseriesGetQueryResult = NonNullable<Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>>
export type TimeseriesV1ProxyTimeseriesGetQueryError = HTTPValidationError


export function useTimeseriesV1ProxyTimeseriesGet<TData = Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>, TError = HTTPValidationError>(
 params: TimeseriesV1ProxyTimeseriesGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>,
          TError,
          Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimeseriesV1ProxyTimeseriesGet<TData = Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>, TError = HTTPValidationError>(
 params: TimeseriesV1ProxyTimeseriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>,
          TError,
          Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimeseriesV1ProxyTimeseriesGet<TData = Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>, TError = HTTPValidationError>(
 params: TimeseriesV1ProxyTimeseriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Timeseries
 */

export function useTimeseriesV1ProxyTimeseriesGet<TData = Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>, TError = HTTPValidationError>(
 params: TimeseriesV1ProxyTimeseriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeseriesV1ProxyTimeseriesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTimeseriesV1ProxyTimeseriesGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getHealthV1ProxyHealthGetUrl = () => {




  return `/v1/proxy/health`
}

/**
 * @summary Health
 */
export const healthV1ProxyHealthGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<Readiness> => {

  return customFetch<Readiness>(getHealthV1ProxyHealthGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthV1ProxyHealthGetQueryKey = () => {
    return [
    `/v1/proxy/health`
    ] as const;
    }


export const getHealthV1ProxyHealthGetQueryOptions = <TData = Awaited<ReturnType<typeof healthV1ProxyHealthGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthV1ProxyHealthGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthV1ProxyHealthGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthV1ProxyHealthGet>>> = ({ signal }) => healthV1ProxyHealthGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthV1ProxyHealthGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthV1ProxyHealthGetQueryResult = NonNullable<Awaited<ReturnType<typeof healthV1ProxyHealthGet>>>
export type HealthV1ProxyHealthGetQueryError = unknown


export function useHealthV1ProxyHealthGet<TData = Awaited<ReturnType<typeof healthV1ProxyHealthGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthV1ProxyHealthGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthV1ProxyHealthGet>>,
          TError,
          Awaited<ReturnType<typeof healthV1ProxyHealthGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthV1ProxyHealthGet<TData = Awaited<ReturnType<typeof healthV1ProxyHealthGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthV1ProxyHealthGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthV1ProxyHealthGet>>,
          TError,
          Awaited<ReturnType<typeof healthV1ProxyHealthGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthV1ProxyHealthGet<TData = Awaited<ReturnType<typeof healthV1ProxyHealthGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthV1ProxyHealthGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Health
 */

export function useHealthV1ProxyHealthGet<TData = Awaited<ReturnType<typeof healthV1ProxyHealthGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthV1ProxyHealthGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthV1ProxyHealthGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCountryPreferenceV1ProxyCountryPreferenceGetUrl = () => {




  return `/v1/proxy/country-preference`
}

/**
 * @summary Country Preference
 */
export const countryPreferenceV1ProxyCountryPreferenceGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<ProxyCountryPreferenceOut> => {

  return customFetch<ProxyCountryPreferenceOut>(getCountryPreferenceV1ProxyCountryPreferenceGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCountryPreferenceV1ProxyCountryPreferenceGetQueryKey = () => {
    return [
    `/v1/proxy/country-preference`
    ] as const;
    }


export const getCountryPreferenceV1ProxyCountryPreferenceGetQueryOptions = <TData = Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCountryPreferenceV1ProxyCountryPreferenceGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>> = ({ signal }) => countryPreferenceV1ProxyCountryPreferenceGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CountryPreferenceV1ProxyCountryPreferenceGetQueryResult = NonNullable<Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>>
export type CountryPreferenceV1ProxyCountryPreferenceGetQueryError = unknown


export function useCountryPreferenceV1ProxyCountryPreferenceGet<TData = Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>,
          TError,
          Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountryPreferenceV1ProxyCountryPreferenceGet<TData = Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>,
          TError,
          Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCountryPreferenceV1ProxyCountryPreferenceGet<TData = Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Country Preference
 */

export function useCountryPreferenceV1ProxyCountryPreferenceGet<TData = Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof countryPreferenceV1ProxyCountryPreferenceGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCountryPreferenceV1ProxyCountryPreferenceGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetCountryPreferenceV1ProxyCountryPreferencePlatformPutUrl = (platform: Platform,) => {




  return `/v1/proxy/country-preference/${platform}`
}

/**
 * @summary Set Country Preference
 */
export const setCountryPreferenceV1ProxyCountryPreferencePlatformPut = async (platform: Platform,
    proxyCountryPreferenceUpdate: ProxyCountryPreferenceUpdate, options?: Parameters<typeof customFetch>[1]): Promise<ProxyPreferencesOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProxyPreferencesOut>(getSetCountryPreferenceV1ProxyCountryPreferencePlatformPutUrl(platform),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proxyCountryPreferenceUpdate)
  }
);}





export const getSetCountryPreferenceV1ProxyCountryPreferencePlatformPutMutationKey = () => ['setCountryPreferenceV1ProxyCountryPreferencePlatformPut'] as const;

export const getSetCountryPreferenceV1ProxyCountryPreferencePlatformPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCountryPreferenceV1ProxyCountryPreferencePlatformPut>>, TError,SetCountryPreferenceV1ProxyCountryPreferencePlatformPutMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setCountryPreferenceV1ProxyCountryPreferencePlatformPut>>, TError,SetCountryPreferenceV1ProxyCountryPreferencePlatformPutMutationVariables, TContext> => {

const mutationKey = getSetCountryPreferenceV1ProxyCountryPreferencePlatformPutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCountryPreferenceV1ProxyCountryPreferencePlatformPut>>, SetCountryPreferenceV1ProxyCountryPreferencePlatformPutMutationVariables> = (props) => {
          const {platform,data} = props ?? {};

          return  setCountryPreferenceV1ProxyCountryPreferencePlatformPut(platform,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetCountryPreferenceV1ProxyCountryPreferencePlatformPutMutationResult = NonNullable<Awaited<ReturnType<typeof setCountryPreferenceV1ProxyCountryPreferencePlatformPut>>>
    export type SetCountryPreferenceV1ProxyCountryPreferencePlatformPutMutationBody = ProxyCountryPreferenceUpdate
    export type SetCountryPreferenceV1ProxyCountryPreferencePlatformPutMutationError = HTTPValidationError
    export type SetCountryPreferenceV1ProxyCountryPreferencePlatformPutMutationVariables = {platform: Platform;data: ProxyCountryPreferenceUpdate}

    /**
 * @summary Set Country Preference
 */
export const useSetCountryPreferenceV1ProxyCountryPreferencePlatformPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCountryPreferenceV1ProxyCountryPreferencePlatformPut>>, TError,SetCountryPreferenceV1ProxyCountryPreferencePlatformPutMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setCountryPreferenceV1ProxyCountryPreferencePlatformPut>>,
        TError,
        SetCountryPreferenceV1ProxyCountryPreferencePlatformPutMutationVariables,
        TContext
      > => {
      return useMutation(getSetCountryPreferenceV1ProxyCountryPreferencePlatformPutMutationOptions(options), queryClient);
    }

export const getSyncV1ProxySyncPostUrl = () => {




  return `/v1/proxy/sync`
}

/**
 * @summary Sync
 */
export const syncV1ProxySyncPost = async ( options?: Parameters<typeof customFetch>[1]): Promise<ProxySyncOut> => {

  return customFetch<ProxySyncOut>(getSyncV1ProxySyncPostUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSyncV1ProxySyncPostMutationKey = () => ['syncV1ProxySyncPost'] as const;

export const getSyncV1ProxySyncPostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncV1ProxySyncPost>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncV1ProxySyncPost>>, TError,void, TContext> => {

const mutationKey = getSyncV1ProxySyncPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncV1ProxySyncPost>>, void> = () => {


          return  syncV1ProxySyncPost(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncV1ProxySyncPostMutationResult = NonNullable<Awaited<ReturnType<typeof syncV1ProxySyncPost>>>

    export type SyncV1ProxySyncPostMutationError = unknown


    /**
 * @summary Sync
 */
export const useSyncV1ProxySyncPost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncV1ProxySyncPost>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof syncV1ProxySyncPost>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSyncV1ProxySyncPostMutationOptions(options), queryClient);
    }

export const getResetPoolV1ProxyResetPostUrl = (params?: ResetPoolV1ProxyResetPostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/proxy/reset?${stringifiedParams}` : `/v1/proxy/reset`
}

/**
 * Wipe learned proxy state back to ``untried`` (one platform, or all). Destructive.
 * @summary Reset Pool
 */
export const resetPoolV1ProxyResetPost = async (params?: ResetPoolV1ProxyResetPostParams, options?: Parameters<typeof customFetch>[1]): Promise<ProxyResetOut> => {

  return customFetch<ProxyResetOut>(getResetPoolV1ProxyResetPostUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResetPoolV1ProxyResetPostMutationKey = () => ['resetPoolV1ProxyResetPost'] as const;

export const getResetPoolV1ProxyResetPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPoolV1ProxyResetPost>>, TError,ResetPoolV1ProxyResetPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPoolV1ProxyResetPost>>, TError,ResetPoolV1ProxyResetPostMutationVariables, TContext> => {

const mutationKey = getResetPoolV1ProxyResetPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPoolV1ProxyResetPost>>, ResetPoolV1ProxyResetPostMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  resetPoolV1ProxyResetPost(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetPoolV1ProxyResetPostMutationResult = NonNullable<Awaited<ReturnType<typeof resetPoolV1ProxyResetPost>>>

    export type ResetPoolV1ProxyResetPostMutationError = HTTPValidationError
    export type ResetPoolV1ProxyResetPostMutationVariables = {params?: ResetPoolV1ProxyResetPostParams}

    /**
 * @summary Reset Pool
 */
export const useResetPoolV1ProxyResetPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPoolV1ProxyResetPost>>, TError,ResetPoolV1ProxyResetPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPoolV1ProxyResetPost>>,
        TError,
        ResetPoolV1ProxyResetPostMutationVariables,
        TContext
      > => {
      return useMutation(getResetPoolV1ProxyResetPostMutationOptions(options), queryClient);
    }

export const getMarkDeadV1ProxyProxiesPlatformIpMarkDeadPostUrl = (platform: Platform,
    ip: string,) => {




  return `/v1/proxy/proxies/${platform}/${ip}/mark-dead`
}

/**
 * @summary Mark Dead
 */
export const markDeadV1ProxyProxiesPlatformIpMarkDeadPost = async (platform: Platform,
    ip: string, options?: Parameters<typeof customFetch>[1]): Promise<ProxyAdminActionOut> => {

  return customFetch<ProxyAdminActionOut>(getMarkDeadV1ProxyProxiesPlatformIpMarkDeadPostUrl(platform,ip),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMarkDeadV1ProxyProxiesPlatformIpMarkDeadPostMutationKey = () => ['markDeadV1ProxyProxiesPlatformIpMarkDeadPost'] as const;

export const getMarkDeadV1ProxyProxiesPlatformIpMarkDeadPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markDeadV1ProxyProxiesPlatformIpMarkDeadPost>>, TError,MarkDeadV1ProxyProxiesPlatformIpMarkDeadPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markDeadV1ProxyProxiesPlatformIpMarkDeadPost>>, TError,MarkDeadV1ProxyProxiesPlatformIpMarkDeadPostMutationVariables, TContext> => {

const mutationKey = getMarkDeadV1ProxyProxiesPlatformIpMarkDeadPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markDeadV1ProxyProxiesPlatformIpMarkDeadPost>>, MarkDeadV1ProxyProxiesPlatformIpMarkDeadPostMutationVariables> = (props) => {
          const {platform,ip} = props ?? {};

          return  markDeadV1ProxyProxiesPlatformIpMarkDeadPost(platform,ip,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkDeadV1ProxyProxiesPlatformIpMarkDeadPostMutationResult = NonNullable<Awaited<ReturnType<typeof markDeadV1ProxyProxiesPlatformIpMarkDeadPost>>>

    export type MarkDeadV1ProxyProxiesPlatformIpMarkDeadPostMutationError = HTTPValidationError
    export type MarkDeadV1ProxyProxiesPlatformIpMarkDeadPostMutationVariables = {platform: Platform;ip: string}

    /**
 * @summary Mark Dead
 */
export const useMarkDeadV1ProxyProxiesPlatformIpMarkDeadPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markDeadV1ProxyProxiesPlatformIpMarkDeadPost>>, TError,MarkDeadV1ProxyProxiesPlatformIpMarkDeadPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markDeadV1ProxyProxiesPlatformIpMarkDeadPost>>,
        TError,
        MarkDeadV1ProxyProxiesPlatformIpMarkDeadPostMutationVariables,
        TContext
      > => {
      return useMutation(getMarkDeadV1ProxyProxiesPlatformIpMarkDeadPostMutationOptions(options), queryClient);
    }

export const getReviveV1ProxyProxiesPlatformIpRevivePostUrl = (platform: Platform,
    ip: string,) => {




  return `/v1/proxy/proxies/${platform}/${ip}/revive`
}

/**
 * @summary Revive
 */
export const reviveV1ProxyProxiesPlatformIpRevivePost = async (platform: Platform,
    ip: string, options?: Parameters<typeof customFetch>[1]): Promise<ProxyAdminActionOut> => {

  return customFetch<ProxyAdminActionOut>(getReviveV1ProxyProxiesPlatformIpRevivePostUrl(platform,ip),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReviveV1ProxyProxiesPlatformIpRevivePostMutationKey = () => ['reviveV1ProxyProxiesPlatformIpRevivePost'] as const;

export const getReviveV1ProxyProxiesPlatformIpRevivePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviveV1ProxyProxiesPlatformIpRevivePost>>, TError,ReviveV1ProxyProxiesPlatformIpRevivePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviveV1ProxyProxiesPlatformIpRevivePost>>, TError,ReviveV1ProxyProxiesPlatformIpRevivePostMutationVariables, TContext> => {

const mutationKey = getReviveV1ProxyProxiesPlatformIpRevivePostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviveV1ProxyProxiesPlatformIpRevivePost>>, ReviveV1ProxyProxiesPlatformIpRevivePostMutationVariables> = (props) => {
          const {platform,ip} = props ?? {};

          return  reviveV1ProxyProxiesPlatformIpRevivePost(platform,ip,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviveV1ProxyProxiesPlatformIpRevivePostMutationResult = NonNullable<Awaited<ReturnType<typeof reviveV1ProxyProxiesPlatformIpRevivePost>>>

    export type ReviveV1ProxyProxiesPlatformIpRevivePostMutationError = HTTPValidationError
    export type ReviveV1ProxyProxiesPlatformIpRevivePostMutationVariables = {platform: Platform;ip: string}

    /**
 * @summary Revive
 */
export const useReviveV1ProxyProxiesPlatformIpRevivePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviveV1ProxyProxiesPlatformIpRevivePost>>, TError,ReviveV1ProxyProxiesPlatformIpRevivePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reviveV1ProxyProxiesPlatformIpRevivePost>>,
        TError,
        ReviveV1ProxyProxiesPlatformIpRevivePostMutationVariables,
        TContext
      > => {
      return useMutation(getReviveV1ProxyProxiesPlatformIpRevivePostMutationOptions(options), queryClient);
    }

export const getResetScoreV1ProxyProxiesPlatformIpResetScorePostUrl = (platform: Platform,
    ip: string,) => {




  return `/v1/proxy/proxies/${platform}/${ip}/reset-score`
}

/**
 * @summary Reset Score
 */
export const resetScoreV1ProxyProxiesPlatformIpResetScorePost = async (platform: Platform,
    ip: string, options?: Parameters<typeof customFetch>[1]): Promise<ProxyAdminActionOut> => {

  return customFetch<ProxyAdminActionOut>(getResetScoreV1ProxyProxiesPlatformIpResetScorePostUrl(platform,ip),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResetScoreV1ProxyProxiesPlatformIpResetScorePostMutationKey = () => ['resetScoreV1ProxyProxiesPlatformIpResetScorePost'] as const;

export const getResetScoreV1ProxyProxiesPlatformIpResetScorePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetScoreV1ProxyProxiesPlatformIpResetScorePost>>, TError,ResetScoreV1ProxyProxiesPlatformIpResetScorePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetScoreV1ProxyProxiesPlatformIpResetScorePost>>, TError,ResetScoreV1ProxyProxiesPlatformIpResetScorePostMutationVariables, TContext> => {

const mutationKey = getResetScoreV1ProxyProxiesPlatformIpResetScorePostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetScoreV1ProxyProxiesPlatformIpResetScorePost>>, ResetScoreV1ProxyProxiesPlatformIpResetScorePostMutationVariables> = (props) => {
          const {platform,ip} = props ?? {};

          return  resetScoreV1ProxyProxiesPlatformIpResetScorePost(platform,ip,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetScoreV1ProxyProxiesPlatformIpResetScorePostMutationResult = NonNullable<Awaited<ReturnType<typeof resetScoreV1ProxyProxiesPlatformIpResetScorePost>>>

    export type ResetScoreV1ProxyProxiesPlatformIpResetScorePostMutationError = HTTPValidationError
    export type ResetScoreV1ProxyProxiesPlatformIpResetScorePostMutationVariables = {platform: Platform;ip: string}

    /**
 * @summary Reset Score
 */
export const useResetScoreV1ProxyProxiesPlatformIpResetScorePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetScoreV1ProxyProxiesPlatformIpResetScorePost>>, TError,ResetScoreV1ProxyProxiesPlatformIpResetScorePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetScoreV1ProxyProxiesPlatformIpResetScorePost>>,
        TError,
        ResetScoreV1ProxyProxiesPlatformIpResetScorePostMutationVariables,
        TContext
      > => {
      return useMutation(getResetScoreV1ProxyProxiesPlatformIpResetScorePostMutationOptions(options), queryClient);
    }

export const getUsageRightsizingV1ProxyUsageRightsizingGetUrl = (params?: UsageRightsizingV1ProxyUsageRightsizingGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/proxy/usage/rightsizing?${stringifiedParams}` : `/v1/proxy/usage/rightsizing`
}

/**
 * Fleet right-sizing: peak concurrency vs paid fleet + genuine (dead/never-used) waste.
 * @summary Usage Rightsizing
 */
export const usageRightsizingV1ProxyUsageRightsizingGet = async (params?: UsageRightsizingV1ProxyUsageRightsizingGetParams, options?: Parameters<typeof customFetch>[1]): Promise<FleetRightsizingOut> => {

  return customFetch<FleetRightsizingOut>(getUsageRightsizingV1ProxyUsageRightsizingGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsageRightsizingV1ProxyUsageRightsizingGetQueryKey = (params?: UsageRightsizingV1ProxyUsageRightsizingGetParams,) => {
    return [
    `/v1/proxy/usage/rightsizing`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsageRightsizingV1ProxyUsageRightsizingGetQueryOptions = <TData = Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>, TError = HTTPValidationError>(params?: UsageRightsizingV1ProxyUsageRightsizingGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsageRightsizingV1ProxyUsageRightsizingGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>> = ({ signal }) => usageRightsizingV1ProxyUsageRightsizingGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsageRightsizingV1ProxyUsageRightsizingGetQueryResult = NonNullable<Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>>
export type UsageRightsizingV1ProxyUsageRightsizingGetQueryError = HTTPValidationError


export function useUsageRightsizingV1ProxyUsageRightsizingGet<TData = Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>, TError = HTTPValidationError>(
 params: undefined |  UsageRightsizingV1ProxyUsageRightsizingGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>,
          TError,
          Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsageRightsizingV1ProxyUsageRightsizingGet<TData = Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>, TError = HTTPValidationError>(
 params?: UsageRightsizingV1ProxyUsageRightsizingGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>,
          TError,
          Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsageRightsizingV1ProxyUsageRightsizingGet<TData = Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>, TError = HTTPValidationError>(
 params?: UsageRightsizingV1ProxyUsageRightsizingGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Usage Rightsizing
 */

export function useUsageRightsizingV1ProxyUsageRightsizingGet<TData = Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>, TError = HTTPValidationError>(
 params?: UsageRightsizingV1ProxyUsageRightsizingGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageRightsizingV1ProxyUsageRightsizingGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsageRightsizingV1ProxyUsageRightsizingGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUsageRetireV1ProxyUsageRetireGetUrl = (params: UsageRetireV1ProxyUsageRetireGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/proxy/usage/retire?${stringifiedParams}` : `/v1/proxy/usage/retire`
}

/**
 * Retire candidates: worst sustained success-rate-when-used (not raw yield).
 *
 * ``min_scored_requests`` is the floor on the denominator, and it is a query parameter
 * because the right value is per platform: where load-shedding dominates and spread
 * rotation keeps per-IP volume low, the default can filter the whole roster out - and an
 * empty table reads as "no bad IPs" rather than "everything was held back". Lower it to
 * see what is behind the floor.
 * @summary Usage Retire
 */
export const usageRetireV1ProxyUsageRetireGet = async (params: UsageRetireV1ProxyUsageRetireGetParams, options?: Parameters<typeof customFetch>[1]): Promise<RetireRow[]> => {

  return customFetch<RetireRow[]>(getUsageRetireV1ProxyUsageRetireGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsageRetireV1ProxyUsageRetireGetQueryKey = (params?: UsageRetireV1ProxyUsageRetireGetParams,) => {
    return [
    `/v1/proxy/usage/retire`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsageRetireV1ProxyUsageRetireGetQueryOptions = <TData = Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>, TError = HTTPValidationError>(params: UsageRetireV1ProxyUsageRetireGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsageRetireV1ProxyUsageRetireGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>> = ({ signal }) => usageRetireV1ProxyUsageRetireGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsageRetireV1ProxyUsageRetireGetQueryResult = NonNullable<Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>>
export type UsageRetireV1ProxyUsageRetireGetQueryError = HTTPValidationError


export function useUsageRetireV1ProxyUsageRetireGet<TData = Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>, TError = HTTPValidationError>(
 params: UsageRetireV1ProxyUsageRetireGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>,
          TError,
          Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsageRetireV1ProxyUsageRetireGet<TData = Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>, TError = HTTPValidationError>(
 params: UsageRetireV1ProxyUsageRetireGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>,
          TError,
          Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsageRetireV1ProxyUsageRetireGet<TData = Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>, TError = HTTPValidationError>(
 params: UsageRetireV1ProxyUsageRetireGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Usage Retire
 */

export function useUsageRetireV1ProxyUsageRetireGet<TData = Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>, TError = HTTPValidationError>(
 params: UsageRetireV1ProxyUsageRetireGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageRetireV1ProxyUsageRetireGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsageRetireV1ProxyUsageRetireGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUsageDeadBySubnetV1ProxyUsageDeadBySubnetGetUrl = (params: UsageDeadBySubnetV1ProxyUsageDeadBySubnetGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/proxy/usage/dead-by-subnet?${stringifiedParams}` : `/v1/proxy/usage/dead-by-subnet`
}

/**
 * Dead-IP concentration by subnet (reputation ops).
 * @summary Usage Dead By Subnet
 */
export const usageDeadBySubnetV1ProxyUsageDeadBySubnetGet = async (params: UsageDeadBySubnetV1ProxyUsageDeadBySubnetGetParams, options?: Parameters<typeof customFetch>[1]): Promise<DeadSubnetRow[]> => {

  return customFetch<DeadSubnetRow[]>(getUsageDeadBySubnetV1ProxyUsageDeadBySubnetGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsageDeadBySubnetV1ProxyUsageDeadBySubnetGetQueryKey = (params?: UsageDeadBySubnetV1ProxyUsageDeadBySubnetGetParams,) => {
    return [
    `/v1/proxy/usage/dead-by-subnet`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsageDeadBySubnetV1ProxyUsageDeadBySubnetGetQueryOptions = <TData = Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>, TError = HTTPValidationError>(params: UsageDeadBySubnetV1ProxyUsageDeadBySubnetGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsageDeadBySubnetV1ProxyUsageDeadBySubnetGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>> = ({ signal }) => usageDeadBySubnetV1ProxyUsageDeadBySubnetGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsageDeadBySubnetV1ProxyUsageDeadBySubnetGetQueryResult = NonNullable<Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>>
export type UsageDeadBySubnetV1ProxyUsageDeadBySubnetGetQueryError = HTTPValidationError


export function useUsageDeadBySubnetV1ProxyUsageDeadBySubnetGet<TData = Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>, TError = HTTPValidationError>(
 params: UsageDeadBySubnetV1ProxyUsageDeadBySubnetGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>,
          TError,
          Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsageDeadBySubnetV1ProxyUsageDeadBySubnetGet<TData = Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>, TError = HTTPValidationError>(
 params: UsageDeadBySubnetV1ProxyUsageDeadBySubnetGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>,
          TError,
          Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsageDeadBySubnetV1ProxyUsageDeadBySubnetGet<TData = Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>, TError = HTTPValidationError>(
 params: UsageDeadBySubnetV1ProxyUsageDeadBySubnetGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Usage Dead By Subnet
 */

export function useUsageDeadBySubnetV1ProxyUsageDeadBySubnetGet<TData = Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>, TError = HTTPValidationError>(
 params: UsageDeadBySubnetV1ProxyUsageDeadBySubnetGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageDeadBySubnetV1ProxyUsageDeadBySubnetGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsageDeadBySubnetV1ProxyUsageDeadBySubnetGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUsageByIpV1ProxyUsageByIpGetUrl = (params: UsageByIpV1ProxyUsageByIpGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/proxy/usage/by-ip?${stringifiedParams}` : `/v1/proxy/usage/by-ip`
}

/**
 * Per-IP usage rows (data, quality-when-used, activity) for the proxies table.
 * @summary Usage By Ip
 */
export const usageByIpV1ProxyUsageByIpGet = async (params: UsageByIpV1ProxyUsageByIpGetParams, options?: Parameters<typeof customFetch>[1]): Promise<UsageIpRow[]> => {

  return customFetch<UsageIpRow[]>(getUsageByIpV1ProxyUsageByIpGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsageByIpV1ProxyUsageByIpGetQueryKey = (params?: UsageByIpV1ProxyUsageByIpGetParams,) => {
    return [
    `/v1/proxy/usage/by-ip`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsageByIpV1ProxyUsageByIpGetQueryOptions = <TData = Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>, TError = HTTPValidationError>(params: UsageByIpV1ProxyUsageByIpGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsageByIpV1ProxyUsageByIpGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>> = ({ signal }) => usageByIpV1ProxyUsageByIpGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsageByIpV1ProxyUsageByIpGetQueryResult = NonNullable<Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>>
export type UsageByIpV1ProxyUsageByIpGetQueryError = HTTPValidationError


export function useUsageByIpV1ProxyUsageByIpGet<TData = Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>, TError = HTTPValidationError>(
 params: UsageByIpV1ProxyUsageByIpGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>,
          TError,
          Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsageByIpV1ProxyUsageByIpGet<TData = Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>, TError = HTTPValidationError>(
 params: UsageByIpV1ProxyUsageByIpGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>,
          TError,
          Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsageByIpV1ProxyUsageByIpGet<TData = Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>, TError = HTTPValidationError>(
 params: UsageByIpV1ProxyUsageByIpGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Usage By Ip
 */

export function useUsageByIpV1ProxyUsageByIpGet<TData = Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>, TError = HTTPValidationError>(
 params: UsageByIpV1ProxyUsageByIpGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageByIpV1ProxyUsageByIpGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsageByIpV1ProxyUsageByIpGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUsageBurnRateV1ProxyUsageBurnRateGetUrl = (params: UsageBurnRateV1ProxyUsageBurnRateGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/proxy/usage/burn-rate?${stringifiedParams}` : `/v1/proxy/usage/burn-rate`
}

/**
 * Day-over-day dead/cooling counts (when to ask the proxy provider for fresh IPs).
 * @summary Usage Burn Rate
 */
export const usageBurnRateV1ProxyUsageBurnRateGet = async (params: UsageBurnRateV1ProxyUsageBurnRateGetParams, options?: Parameters<typeof customFetch>[1]): Promise<BurnRow[]> => {

  return customFetch<BurnRow[]>(getUsageBurnRateV1ProxyUsageBurnRateGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsageBurnRateV1ProxyUsageBurnRateGetQueryKey = (params?: UsageBurnRateV1ProxyUsageBurnRateGetParams,) => {
    return [
    `/v1/proxy/usage/burn-rate`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsageBurnRateV1ProxyUsageBurnRateGetQueryOptions = <TData = Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>, TError = HTTPValidationError>(params: UsageBurnRateV1ProxyUsageBurnRateGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsageBurnRateV1ProxyUsageBurnRateGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>> = ({ signal }) => usageBurnRateV1ProxyUsageBurnRateGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsageBurnRateV1ProxyUsageBurnRateGetQueryResult = NonNullable<Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>>
export type UsageBurnRateV1ProxyUsageBurnRateGetQueryError = HTTPValidationError


export function useUsageBurnRateV1ProxyUsageBurnRateGet<TData = Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>, TError = HTTPValidationError>(
 params: UsageBurnRateV1ProxyUsageBurnRateGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>,
          TError,
          Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsageBurnRateV1ProxyUsageBurnRateGet<TData = Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>, TError = HTTPValidationError>(
 params: UsageBurnRateV1ProxyUsageBurnRateGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>,
          TError,
          Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsageBurnRateV1ProxyUsageBurnRateGet<TData = Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>, TError = HTTPValidationError>(
 params: UsageBurnRateV1ProxyUsageBurnRateGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Usage Burn Rate
 */

export function useUsageBurnRateV1ProxyUsageBurnRateGet<TData = Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>, TError = HTTPValidationError>(
 params: UsageBurnRateV1ProxyUsageBurnRateGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageBurnRateV1ProxyUsageBurnRateGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsageBurnRateV1ProxyUsageBurnRateGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUsageIpProfileV1ProxyUsageIpIpGetUrl = (ip: string,
    params?: UsageIpProfileV1ProxyUsageIpIpGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/proxy/usage/ip/${ip}?${stringifiedParams}` : `/v1/proxy/usage/ip/${ip}`
}

/**
 * Single-IP drill-down: usage/quality over time + status timeline + attributes.
 * @summary Usage Ip Profile
 */
export const usageIpProfileV1ProxyUsageIpIpGet = async (ip: string,
    params?: UsageIpProfileV1ProxyUsageIpIpGetParams, options?: Parameters<typeof customFetch>[1]): Promise<UsageIpProfileV1ProxyUsageIpIpGet200> => {

  return customFetch<UsageIpProfileV1ProxyUsageIpIpGet200>(getUsageIpProfileV1ProxyUsageIpIpGetUrl(ip,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsageIpProfileV1ProxyUsageIpIpGetQueryKey = (ip: string,
    params?: UsageIpProfileV1ProxyUsageIpIpGetParams,) => {
    return [
    `/v1/proxy/usage/ip/${ip}`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsageIpProfileV1ProxyUsageIpIpGetQueryOptions = <TData = Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>, TError = HTTPValidationError>(ip: string,
    params?: UsageIpProfileV1ProxyUsageIpIpGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsageIpProfileV1ProxyUsageIpIpGetQueryKey(ip,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>> = ({ signal }) => usageIpProfileV1ProxyUsageIpIpGet(ip,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: ip !== null && ip !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsageIpProfileV1ProxyUsageIpIpGetQueryResult = NonNullable<Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>>
export type UsageIpProfileV1ProxyUsageIpIpGetQueryError = HTTPValidationError


export function useUsageIpProfileV1ProxyUsageIpIpGet<TData = Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>, TError = HTTPValidationError>(
 ip: string,
    params: undefined |  UsageIpProfileV1ProxyUsageIpIpGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>,
          TError,
          Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsageIpProfileV1ProxyUsageIpIpGet<TData = Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>, TError = HTTPValidationError>(
 ip: string,
    params?: UsageIpProfileV1ProxyUsageIpIpGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>,
          TError,
          Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsageIpProfileV1ProxyUsageIpIpGet<TData = Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>, TError = HTTPValidationError>(
 ip: string,
    params?: UsageIpProfileV1ProxyUsageIpIpGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Usage Ip Profile
 */

export function useUsageIpProfileV1ProxyUsageIpIpGet<TData = Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>, TError = HTTPValidationError>(
 ip: string,
    params?: UsageIpProfileV1ProxyUsageIpIpGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usageIpProfileV1ProxyUsageIpIpGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsageIpProfileV1ProxyUsageIpIpGetQueryOptions(ip,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getWafOverviewV1WafOverviewGetUrl = (params?: WafOverviewV1WafOverviewGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/waf/overview?${stringifiedParams}` : `/v1/waf/overview`
}

/**
 * Per-platform WAF posture + token health, plus what is happening right now.
 * @summary Waf Overview
 */
export const wafOverviewV1WafOverviewGet = async (params?: WafOverviewV1WafOverviewGetParams, options?: Parameters<typeof customFetch>[1]): Promise<WafOverview> => {

  return customFetch<WafOverview>(getWafOverviewV1WafOverviewGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWafOverviewV1WafOverviewGetQueryKey = (params?: WafOverviewV1WafOverviewGetParams,) => {
    return [
    `/v1/waf/overview`, ...(params ? [params] : [])
    ] as const;
    }


export const getWafOverviewV1WafOverviewGetQueryOptions = <TData = Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>, TError = HTTPValidationError>(params?: WafOverviewV1WafOverviewGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWafOverviewV1WafOverviewGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>> = ({ signal }) => wafOverviewV1WafOverviewGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WafOverviewV1WafOverviewGetQueryResult = NonNullable<Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>>
export type WafOverviewV1WafOverviewGetQueryError = HTTPValidationError


export function useWafOverviewV1WafOverviewGet<TData = Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>, TError = HTTPValidationError>(
 params: undefined |  WafOverviewV1WafOverviewGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>,
          TError,
          Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWafOverviewV1WafOverviewGet<TData = Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>, TError = HTTPValidationError>(
 params?: WafOverviewV1WafOverviewGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>,
          TError,
          Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWafOverviewV1WafOverviewGet<TData = Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>, TError = HTTPValidationError>(
 params?: WafOverviewV1WafOverviewGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Waf Overview
 */

export function useWafOverviewV1WafOverviewGet<TData = Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>, TError = HTTPValidationError>(
 params?: WafOverviewV1WafOverviewGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wafOverviewV1WafOverviewGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWafOverviewV1WafOverviewGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getWafTrendV1WafTrendGetUrl = (params?: WafTrendV1WafTrendGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/waf/trend?${stringifiedParams}` : `/v1/waf/trend`
}

/**
 * Mint / challenge / fail counts per bucket per platform - the escalation signal.
 * @summary Waf Trend
 */
export const wafTrendV1WafTrendGet = async (params?: WafTrendV1WafTrendGetParams, options?: Parameters<typeof customFetch>[1]): Promise<WafTrendPoint[]> => {

  return customFetch<WafTrendPoint[]>(getWafTrendV1WafTrendGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWafTrendV1WafTrendGetQueryKey = (params?: WafTrendV1WafTrendGetParams,) => {
    return [
    `/v1/waf/trend`, ...(params ? [params] : [])
    ] as const;
    }


export const getWafTrendV1WafTrendGetQueryOptions = <TData = Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>, TError = HTTPValidationError>(params?: WafTrendV1WafTrendGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWafTrendV1WafTrendGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>> = ({ signal }) => wafTrendV1WafTrendGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WafTrendV1WafTrendGetQueryResult = NonNullable<Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>>
export type WafTrendV1WafTrendGetQueryError = HTTPValidationError


export function useWafTrendV1WafTrendGet<TData = Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>, TError = HTTPValidationError>(
 params: undefined |  WafTrendV1WafTrendGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>,
          TError,
          Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWafTrendV1WafTrendGet<TData = Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>, TError = HTTPValidationError>(
 params?: WafTrendV1WafTrendGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>,
          TError,
          Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWafTrendV1WafTrendGet<TData = Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>, TError = HTTPValidationError>(
 params?: WafTrendV1WafTrendGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Waf Trend
 */

export function useWafTrendV1WafTrendGet<TData = Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>, TError = HTTPValidationError>(
 params?: WafTrendV1WafTrendGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wafTrendV1WafTrendGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWafTrendV1WafTrendGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListJobsV1JobsGetUrl = (params?: ListJobsV1JobsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/jobs?${stringifiedParams}` : `/v1/jobs`
}

/**
 * @summary List Jobs
 */
export const listJobsV1JobsGet = async (params?: ListJobsV1JobsGetParams, options?: Parameters<typeof customFetch>[1]): Promise<JobOut[]> => {

  return customFetch<JobOut[]>(getListJobsV1JobsGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJobsV1JobsGetQueryKey = (params?: ListJobsV1JobsGetParams,) => {
    return [
    `/v1/jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListJobsV1JobsGetQueryOptions = <TData = Awaited<ReturnType<typeof listJobsV1JobsGet>>, TError = HTTPValidationError>(params?: ListJobsV1JobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobsV1JobsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListJobsV1JobsGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobsV1JobsGet>>> = ({ signal }) => listJobsV1JobsGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobsV1JobsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListJobsV1JobsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listJobsV1JobsGet>>>
export type ListJobsV1JobsGetQueryError = HTTPValidationError


export function useListJobsV1JobsGet<TData = Awaited<ReturnType<typeof listJobsV1JobsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListJobsV1JobsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobsV1JobsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobsV1JobsGet>>,
          TError,
          Awaited<ReturnType<typeof listJobsV1JobsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobsV1JobsGet<TData = Awaited<ReturnType<typeof listJobsV1JobsGet>>, TError = HTTPValidationError>(
 params?: ListJobsV1JobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobsV1JobsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobsV1JobsGet>>,
          TError,
          Awaited<ReturnType<typeof listJobsV1JobsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobsV1JobsGet<TData = Awaited<ReturnType<typeof listJobsV1JobsGet>>, TError = HTTPValidationError>(
 params?: ListJobsV1JobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobsV1JobsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Jobs
 */

export function useListJobsV1JobsGet<TData = Awaited<ReturnType<typeof listJobsV1JobsGet>>, TError = HTTPValidationError>(
 params?: ListJobsV1JobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobsV1JobsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobsV1JobsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateJobV1JobsPostUrl = () => {




  return `/v1/jobs`
}

/**
 * @summary Create Job
 */
export const createJobV1JobsPost = async (jobCreate: JobCreate, options?: Parameters<typeof customFetch>[1]): Promise<JobOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobOut>(getCreateJobV1JobsPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobCreate)
  }
);}





export const getCreateJobV1JobsPostMutationKey = () => ['createJobV1JobsPost'] as const;

export const getCreateJobV1JobsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobV1JobsPost>>, TError,CreateJobV1JobsPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createJobV1JobsPost>>, TError,CreateJobV1JobsPostMutationVariables, TContext> => {

const mutationKey = getCreateJobV1JobsPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createJobV1JobsPost>>, CreateJobV1JobsPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createJobV1JobsPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateJobV1JobsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createJobV1JobsPost>>>
    export type CreateJobV1JobsPostMutationBody = JobCreate
    export type CreateJobV1JobsPostMutationError = HTTPValidationError
    export type CreateJobV1JobsPostMutationVariables = {data: JobCreate}

    /**
 * @summary Create Job
 */
export const useCreateJobV1JobsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createJobV1JobsPost>>, TError,CreateJobV1JobsPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createJobV1JobsPost>>,
        TError,
        CreateJobV1JobsPostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateJobV1JobsPostMutationOptions(options), queryClient);
    }

export const getListJobKnobsV1JobsKnobsGetUrl = (params: ListJobKnobsV1JobsKnobsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/jobs/knobs?${stringifiedParams}` : `/v1/jobs/knobs`
}

/**
 * @summary List Job Knobs
 */
export const listJobKnobsV1JobsKnobsGet = async (params: ListJobKnobsV1JobsKnobsGetParams, options?: Parameters<typeof customFetch>[1]): Promise<JobKnobDescriptor[]> => {

  return customFetch<JobKnobDescriptor[]>(getListJobKnobsV1JobsKnobsGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJobKnobsV1JobsKnobsGetQueryKey = (params?: ListJobKnobsV1JobsKnobsGetParams,) => {
    return [
    `/v1/jobs/knobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListJobKnobsV1JobsKnobsGetQueryOptions = <TData = Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>, TError = HTTPValidationError>(params: ListJobKnobsV1JobsKnobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListJobKnobsV1JobsKnobsGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>> = ({ signal }) => listJobKnobsV1JobsKnobsGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListJobKnobsV1JobsKnobsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>>
export type ListJobKnobsV1JobsKnobsGetQueryError = HTTPValidationError


export function useListJobKnobsV1JobsKnobsGet<TData = Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>, TError = HTTPValidationError>(
 params: ListJobKnobsV1JobsKnobsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>,
          TError,
          Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobKnobsV1JobsKnobsGet<TData = Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>, TError = HTTPValidationError>(
 params: ListJobKnobsV1JobsKnobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>,
          TError,
          Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobKnobsV1JobsKnobsGet<TData = Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>, TError = HTTPValidationError>(
 params: ListJobKnobsV1JobsKnobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Job Knobs
 */

export function useListJobKnobsV1JobsKnobsGet<TData = Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>, TError = HTTPValidationError>(
 params: ListJobKnobsV1JobsKnobsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobKnobsV1JobsKnobsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobKnobsV1JobsKnobsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExportJobsV1JobsExportGetUrl = () => {




  return `/v1/jobs/export`
}

/**
 * Stream every job config (+ attached schedules) as one downloadable JSON doc.
 *
 * Ad-hoc jobs (one-off scoped brand-sweep launches, planning/41) are ephemeral scope,
 * not portable config, so they are excluded from the export.
 * @summary Export Jobs
 */
export const exportJobsV1JobsExportGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {

  return customFetch<unknown>(getExportJobsV1JobsExportGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportJobsV1JobsExportGetQueryKey = () => {
    return [
    `/v1/jobs/export`
    ] as const;
    }


export const getExportJobsV1JobsExportGetQueryOptions = <TData = Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportJobsV1JobsExportGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>> = ({ signal }) => exportJobsV1JobsExportGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportJobsV1JobsExportGetQueryResult = NonNullable<Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>>
export type ExportJobsV1JobsExportGetQueryError = unknown


export function useExportJobsV1JobsExportGet<TData = Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>,
          TError,
          Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportJobsV1JobsExportGet<TData = Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>,
          TError,
          Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportJobsV1JobsExportGet<TData = Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export Jobs
 */

export function useExportJobsV1JobsExportGet<TData = Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportJobsV1JobsExportGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportJobsV1JobsExportGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getImportJobsV1JobsImportPostUrl = (params?: ImportJobsV1JobsImportPostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/jobs/import?${stringifiedParams}` : `/v1/jobs/import`
}

/**
 * Upsert job configs from an exported JSON doc, matched on (platform, flow, name).
 *
 * A matching job is updated in place (UUID preserved); a non-matching one is
 * created. Attached schedules are reconciled by (cron, timezone): missing ones
 * are created, existing ones left untouched, nothing is ever deleted. An item this
 * deployment cannot run (disabled platform, or a platform without the flow's adapter)
 * is skipped with a warning rather than failing the file. A malformed row is not: one
 * bad ``inputs`` field or knob fails the whole file with a 422 naming each row and
 * field, and nothing is written, because a skipped row is a job the operator loses
 * while the import reports success. ``dry_run`` (default) reports the diff without
 * writing.
 * @summary Import Jobs
 */
export const importJobsV1JobsImportPost = async (bodyImportJobsV1JobsImportPost: BodyImportJobsV1JobsImportPost,
    params?: ImportJobsV1JobsImportPostParams, options?: Parameters<typeof customFetch>[1]): Promise<JobImportResult> => {
    const formData = new FormData();
formData.append(`file`, bodyImportJobsV1JobsImportPost.file);

  return customFetch<JobImportResult>(getImportJobsV1JobsImportPostUrl(params),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getImportJobsV1JobsImportPostMutationKey = () => ['importJobsV1JobsImportPost'] as const;

export const getImportJobsV1JobsImportPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importJobsV1JobsImportPost>>, TError,ImportJobsV1JobsImportPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importJobsV1JobsImportPost>>, TError,ImportJobsV1JobsImportPostMutationVariables, TContext> => {

const mutationKey = getImportJobsV1JobsImportPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importJobsV1JobsImportPost>>, ImportJobsV1JobsImportPostMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  importJobsV1JobsImportPost(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportJobsV1JobsImportPostMutationResult = NonNullable<Awaited<ReturnType<typeof importJobsV1JobsImportPost>>>
    export type ImportJobsV1JobsImportPostMutationBody = BodyImportJobsV1JobsImportPost
    export type ImportJobsV1JobsImportPostMutationError = HTTPValidationError
    export type ImportJobsV1JobsImportPostMutationVariables = {data: BodyImportJobsV1JobsImportPost;params?: ImportJobsV1JobsImportPostParams}

    /**
 * @summary Import Jobs
 */
export const useImportJobsV1JobsImportPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importJobsV1JobsImportPost>>, TError,ImportJobsV1JobsImportPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importJobsV1JobsImportPost>>,
        TError,
        ImportJobsV1JobsImportPostMutationVariables,
        TContext
      > => {
      return useMutation(getImportJobsV1JobsImportPostMutationOptions(options), queryClient);
    }

export const getGetJobV1JobsJobIdGetUrl = (jobId: string,) => {




  return `/v1/jobs/${jobId}`
}

/**
 * @summary Get Job
 */
export const getJobV1JobsJobIdGet = async (jobId: string, options?: Parameters<typeof customFetch>[1]): Promise<JobOut> => {

  return customFetch<JobOut>(getGetJobV1JobsJobIdGetUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobV1JobsJobIdGetQueryKey = (jobId: string,) => {
    return [
    `/v1/jobs/${jobId}`
    ] as const;
    }


export const getGetJobV1JobsJobIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobV1JobsJobIdGetQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>> = ({ signal }) => getJobV1JobsJobIdGet(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobV1JobsJobIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>>
export type GetJobV1JobsJobIdGetQueryError = HTTPValidationError


export function useGetJobV1JobsJobIdGet<TData = Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>,
          TError,
          Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobV1JobsJobIdGet<TData = Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>,
          TError,
          Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobV1JobsJobIdGet<TData = Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Job
 */

export function useGetJobV1JobsJobIdGet<TData = Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobV1JobsJobIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobV1JobsJobIdGetQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateJobV1JobsJobIdPatchUrl = (jobId: string,) => {




  return `/v1/jobs/${jobId}`
}

/**
 * @summary Update Job
 */
export const updateJobV1JobsJobIdPatch = async (jobId: string,
    jobUpdate: JobUpdate, options?: Parameters<typeof customFetch>[1]): Promise<JobOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<JobOut>(getUpdateJobV1JobsJobIdPatchUrl(jobId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobUpdate)
  }
);}





export const getUpdateJobV1JobsJobIdPatchMutationKey = () => ['updateJobV1JobsJobIdPatch'] as const;

export const getUpdateJobV1JobsJobIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobV1JobsJobIdPatch>>, TError,UpdateJobV1JobsJobIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateJobV1JobsJobIdPatch>>, TError,UpdateJobV1JobsJobIdPatchMutationVariables, TContext> => {

const mutationKey = getUpdateJobV1JobsJobIdPatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateJobV1JobsJobIdPatch>>, UpdateJobV1JobsJobIdPatchMutationVariables> = (props) => {
          const {jobId,data} = props ?? {};

          return  updateJobV1JobsJobIdPatch(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateJobV1JobsJobIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateJobV1JobsJobIdPatch>>>
    export type UpdateJobV1JobsJobIdPatchMutationBody = JobUpdate
    export type UpdateJobV1JobsJobIdPatchMutationError = HTTPValidationError
    export type UpdateJobV1JobsJobIdPatchMutationVariables = {jobId: string;data: JobUpdate}

    /**
 * @summary Update Job
 */
export const useUpdateJobV1JobsJobIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateJobV1JobsJobIdPatch>>, TError,UpdateJobV1JobsJobIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateJobV1JobsJobIdPatch>>,
        TError,
        UpdateJobV1JobsJobIdPatchMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateJobV1JobsJobIdPatchMutationOptions(options), queryClient);
    }

export const getDeleteJobV1JobsJobIdDeleteUrl = (jobId: string,) => {




  return `/v1/jobs/${jobId}`
}

/**
 * @summary Delete Job
 */
export const deleteJobV1JobsJobIdDelete = async (jobId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteJobV1JobsJobIdDeleteUrl(jobId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteJobV1JobsJobIdDeleteMutationKey = () => ['deleteJobV1JobsJobIdDelete'] as const;

export const getDeleteJobV1JobsJobIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJobV1JobsJobIdDelete>>, TError,DeleteJobV1JobsJobIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteJobV1JobsJobIdDelete>>, TError,DeleteJobV1JobsJobIdDeleteMutationVariables, TContext> => {

const mutationKey = getDeleteJobV1JobsJobIdDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteJobV1JobsJobIdDelete>>, DeleteJobV1JobsJobIdDeleteMutationVariables> = (props) => {
          const {jobId} = props ?? {};

          return  deleteJobV1JobsJobIdDelete(jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteJobV1JobsJobIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteJobV1JobsJobIdDelete>>>

    export type DeleteJobV1JobsJobIdDeleteMutationError = HTTPValidationError
    export type DeleteJobV1JobsJobIdDeleteMutationVariables = {jobId: string}

    /**
 * @summary Delete Job
 */
export const useDeleteJobV1JobsJobIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJobV1JobsJobIdDelete>>, TError,DeleteJobV1JobsJobIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteJobV1JobsJobIdDelete>>,
        TError,
        DeleteJobV1JobsJobIdDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteJobV1JobsJobIdDeleteMutationOptions(options), queryClient);
    }

export const getRunNowV1JobsJobIdRunsPostUrl = (jobId: string,) => {




  return `/v1/jobs/${jobId}/runs`
}

/**
 * Enqueue a manual run; 409 if a run is already in flight for the job.
 * @summary Run Now
 */
export const runNowV1JobsJobIdRunsPost = async (jobId: string, options?: Parameters<typeof customFetch>[1]): Promise<RunOut> => {

  return customFetch<RunOut>(getRunNowV1JobsJobIdRunsPostUrl(jobId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRunNowV1JobsJobIdRunsPostMutationKey = () => ['runNowV1JobsJobIdRunsPost'] as const;

export const getRunNowV1JobsJobIdRunsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runNowV1JobsJobIdRunsPost>>, TError,RunNowV1JobsJobIdRunsPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runNowV1JobsJobIdRunsPost>>, TError,RunNowV1JobsJobIdRunsPostMutationVariables, TContext> => {

const mutationKey = getRunNowV1JobsJobIdRunsPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runNowV1JobsJobIdRunsPost>>, RunNowV1JobsJobIdRunsPostMutationVariables> = (props) => {
          const {jobId} = props ?? {};

          return  runNowV1JobsJobIdRunsPost(jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunNowV1JobsJobIdRunsPostMutationResult = NonNullable<Awaited<ReturnType<typeof runNowV1JobsJobIdRunsPost>>>

    export type RunNowV1JobsJobIdRunsPostMutationError = HTTPValidationError
    export type RunNowV1JobsJobIdRunsPostMutationVariables = {jobId: string}

    /**
 * @summary Run Now
 */
export const useRunNowV1JobsJobIdRunsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runNowV1JobsJobIdRunsPost>>, TError,RunNowV1JobsJobIdRunsPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof runNowV1JobsJobIdRunsPost>>,
        TError,
        RunNowV1JobsJobIdRunsPostMutationVariables,
        TContext
      > => {
      return useMutation(getRunNowV1JobsJobIdRunsPostMutationOptions(options), queryClient);
    }

export const getPipelineV1AvailabilityPipelineGetUrl = (params: PipelineV1AvailabilityPipelineGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/availability/pipeline?${stringifiedParams}` : `/v1/availability/pipeline`
}

/**
 * The platform's newest cart runs, newest first, each with its pipeline stages.
 * @summary Pipeline
 */
export const pipelineV1AvailabilityPipelineGet = async (params: PipelineV1AvailabilityPipelineGetParams, options?: Parameters<typeof customFetch>[1]): Promise<AvailabilityPlatform> => {

  return customFetch<AvailabilityPlatform>(getPipelineV1AvailabilityPipelineGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPipelineV1AvailabilityPipelineGetQueryKey = (params?: PipelineV1AvailabilityPipelineGetParams,) => {
    return [
    `/v1/availability/pipeline`, ...(params ? [params] : [])
    ] as const;
    }


export const getPipelineV1AvailabilityPipelineGetQueryOptions = <TData = Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>, TError = HTTPValidationError>(params: PipelineV1AvailabilityPipelineGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPipelineV1AvailabilityPipelineGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>> = ({ signal }) => pipelineV1AvailabilityPipelineGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PipelineV1AvailabilityPipelineGetQueryResult = NonNullable<Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>>
export type PipelineV1AvailabilityPipelineGetQueryError = HTTPValidationError


export function usePipelineV1AvailabilityPipelineGet<TData = Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>, TError = HTTPValidationError>(
 params: PipelineV1AvailabilityPipelineGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>,
          TError,
          Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePipelineV1AvailabilityPipelineGet<TData = Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>, TError = HTTPValidationError>(
 params: PipelineV1AvailabilityPipelineGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>,
          TError,
          Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePipelineV1AvailabilityPipelineGet<TData = Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>, TError = HTTPValidationError>(
 params: PipelineV1AvailabilityPipelineGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Pipeline
 */

export function usePipelineV1AvailabilityPipelineGet<TData = Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>, TError = HTTPValidationError>(
 params: PipelineV1AvailabilityPipelineGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pipelineV1AvailabilityPipelineGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPipelineV1AvailabilityPipelineGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getHealthV1AvailabilityHealthGetUrl = (params: HealthV1AvailabilityHealthGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/availability/health?${stringifiedParams}` : `/v1/availability/health`
}

/**
 * One cart run's Reach health per city; empty until its Reach is built.
 * @summary Health
 */
export const healthV1AvailabilityHealthGet = async (params: HealthV1AvailabilityHealthGetParams, options?: Parameters<typeof customFetch>[1]): Promise<ReachCityHealth[]> => {

  return customFetch<ReachCityHealth[]>(getHealthV1AvailabilityHealthGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthV1AvailabilityHealthGetQueryKey = (params?: HealthV1AvailabilityHealthGetParams,) => {
    return [
    `/v1/availability/health`, ...(params ? [params] : [])
    ] as const;
    }


export const getHealthV1AvailabilityHealthGetQueryOptions = <TData = Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>, TError = HTTPValidationError>(params: HealthV1AvailabilityHealthGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthV1AvailabilityHealthGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>> = ({ signal }) => healthV1AvailabilityHealthGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthV1AvailabilityHealthGetQueryResult = NonNullable<Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>>
export type HealthV1AvailabilityHealthGetQueryError = HTTPValidationError


export function useHealthV1AvailabilityHealthGet<TData = Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>, TError = HTTPValidationError>(
 params: HealthV1AvailabilityHealthGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>,
          TError,
          Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthV1AvailabilityHealthGet<TData = Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>, TError = HTTPValidationError>(
 params: HealthV1AvailabilityHealthGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>,
          TError,
          Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthV1AvailabilityHealthGet<TData = Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>, TError = HTTPValidationError>(
 params: HealthV1AvailabilityHealthGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Health
 */

export function useHealthV1AvailabilityHealthGet<TData = Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>, TError = HTTPValidationError>(
 params: HealthV1AvailabilityHealthGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthV1AvailabilityHealthGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthV1AvailabilityHealthGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDaysV1AvailabilityDaysGetUrl = (params: DaysV1AvailabilityDaysGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/availability/days?${stringifiedParams}` : `/v1/availability/days`
}

/**
 * The platform's recorded day closes, newest first.
 * @summary Days
 */
export const daysV1AvailabilityDaysGet = async (params: DaysV1AvailabilityDaysGetParams, options?: Parameters<typeof customFetch>[1]): Promise<AvailabilityDayCloseOut[]> => {

  return customFetch<AvailabilityDayCloseOut[]>(getDaysV1AvailabilityDaysGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDaysV1AvailabilityDaysGetQueryKey = (params?: DaysV1AvailabilityDaysGetParams,) => {
    return [
    `/v1/availability/days`, ...(params ? [params] : [])
    ] as const;
    }


export const getDaysV1AvailabilityDaysGetQueryOptions = <TData = Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>, TError = HTTPValidationError>(params: DaysV1AvailabilityDaysGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDaysV1AvailabilityDaysGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>> = ({ signal }) => daysV1AvailabilityDaysGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DaysV1AvailabilityDaysGetQueryResult = NonNullable<Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>>
export type DaysV1AvailabilityDaysGetQueryError = HTTPValidationError


export function useDaysV1AvailabilityDaysGet<TData = Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>, TError = HTTPValidationError>(
 params: DaysV1AvailabilityDaysGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>,
          TError,
          Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDaysV1AvailabilityDaysGet<TData = Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>, TError = HTTPValidationError>(
 params: DaysV1AvailabilityDaysGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>,
          TError,
          Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDaysV1AvailabilityDaysGet<TData = Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>, TError = HTTPValidationError>(
 params: DaysV1AvailabilityDaysGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Days
 */

export function useDaysV1AvailabilityDaysGet<TData = Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>, TError = HTTPValidationError>(
 params: DaysV1AvailabilityDaysGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof daysV1AvailabilityDaysGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDaysV1AvailabilityDaysGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRebuildV1AvailabilityRebuildPostUrl = () => {




  return `/v1/availability/rebuild`
}

/**
 * Start an ad-hoc rebuild of a range of days; it queues one day after another.
 * @summary Rebuild
 */
export const rebuildV1AvailabilityRebuildPost = async (availabilityRebuildRequest: AvailabilityRebuildRequest, options?: Parameters<typeof customFetch>[1]): Promise<RunOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<RunOut>(getRebuildV1AvailabilityRebuildPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(availabilityRebuildRequest)
  }
);}





export const getRebuildV1AvailabilityRebuildPostMutationKey = () => ['rebuildV1AvailabilityRebuildPost'] as const;

export const getRebuildV1AvailabilityRebuildPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rebuildV1AvailabilityRebuildPost>>, TError,RebuildV1AvailabilityRebuildPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rebuildV1AvailabilityRebuildPost>>, TError,RebuildV1AvailabilityRebuildPostMutationVariables, TContext> => {

const mutationKey = getRebuildV1AvailabilityRebuildPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rebuildV1AvailabilityRebuildPost>>, RebuildV1AvailabilityRebuildPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  rebuildV1AvailabilityRebuildPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RebuildV1AvailabilityRebuildPostMutationResult = NonNullable<Awaited<ReturnType<typeof rebuildV1AvailabilityRebuildPost>>>
    export type RebuildV1AvailabilityRebuildPostMutationBody = AvailabilityRebuildRequest
    export type RebuildV1AvailabilityRebuildPostMutationError = HTTPValidationError
    export type RebuildV1AvailabilityRebuildPostMutationVariables = {data: AvailabilityRebuildRequest}

    /**
 * @summary Rebuild
 */
export const useRebuildV1AvailabilityRebuildPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rebuildV1AvailabilityRebuildPost>>, TError,RebuildV1AvailabilityRebuildPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rebuildV1AvailabilityRebuildPost>>,
        TError,
        RebuildV1AvailabilityRebuildPostMutationVariables,
        TContext
      > => {
      return useMutation(getRebuildV1AvailabilityRebuildPostMutationOptions(options), queryClient);
    }

export const getListRunsV1RunsGetUrl = (params?: ListRunsV1RunsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/runs?${stringifiedParams}` : `/v1/runs`
}

/**
 * @summary List Runs
 */
export const listRunsV1RunsGet = async (params?: ListRunsV1RunsGetParams, options?: Parameters<typeof customFetch>[1]): Promise<RunOut[]> => {

  return customFetch<RunOut[]>(getListRunsV1RunsGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRunsV1RunsGetQueryKey = (params?: ListRunsV1RunsGetParams,) => {
    return [
    `/v1/runs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRunsV1RunsGetQueryOptions = <TData = Awaited<ReturnType<typeof listRunsV1RunsGet>>, TError = HTTPValidationError>(params?: ListRunsV1RunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRunsV1RunsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRunsV1RunsGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRunsV1RunsGet>>> = ({ signal }) => listRunsV1RunsGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRunsV1RunsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRunsV1RunsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listRunsV1RunsGet>>>
export type ListRunsV1RunsGetQueryError = HTTPValidationError


export function useListRunsV1RunsGet<TData = Awaited<ReturnType<typeof listRunsV1RunsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListRunsV1RunsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRunsV1RunsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRunsV1RunsGet>>,
          TError,
          Awaited<ReturnType<typeof listRunsV1RunsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRunsV1RunsGet<TData = Awaited<ReturnType<typeof listRunsV1RunsGet>>, TError = HTTPValidationError>(
 params?: ListRunsV1RunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRunsV1RunsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRunsV1RunsGet>>,
          TError,
          Awaited<ReturnType<typeof listRunsV1RunsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRunsV1RunsGet<TData = Awaited<ReturnType<typeof listRunsV1RunsGet>>, TError = HTTPValidationError>(
 params?: ListRunsV1RunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRunsV1RunsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Runs
 */

export function useListRunsV1RunsGet<TData = Awaited<ReturnType<typeof listRunsV1RunsGet>>, TError = HTTPValidationError>(
 params?: ListRunsV1RunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRunsV1RunsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRunsV1RunsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCompareRunsV1RunsCompareGetUrl = (params: CompareRunsV1RunsCompareGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/runs/compare?${stringifiedParams}` : `/v1/runs/compare`
}

/**
 * Diff two merchant-sweep runs: the day-vs-night comparison page's data source.
 *
 * Both runs must be merchant-sweep runs on the **same platform** (comparing store
 * counts across platforms is meaningless). Returns each side's run metadata +
 * aggregate stats and the ``b - a`` delta for the headline metrics. The per-run
 * maps are drawn by the existing ``/{run_id}/coverage`` endpoint; this is the
 * numbers feed only. Declared before ``/{run_id}`` so the literal path wins.
 * @summary Compare Runs
 */
export const compareRunsV1RunsCompareGet = async (params: CompareRunsV1RunsCompareGetParams, options?: Parameters<typeof customFetch>[1]): Promise<RunCompare> => {

  return customFetch<RunCompare>(getCompareRunsV1RunsCompareGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompareRunsV1RunsCompareGetQueryKey = (params?: CompareRunsV1RunsCompareGetParams,) => {
    return [
    `/v1/runs/compare`, ...(params ? [params] : [])
    ] as const;
    }


export const getCompareRunsV1RunsCompareGetQueryOptions = <TData = Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>, TError = HTTPValidationError>(params: CompareRunsV1RunsCompareGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompareRunsV1RunsCompareGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>> = ({ signal }) => compareRunsV1RunsCompareGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CompareRunsV1RunsCompareGetQueryResult = NonNullable<Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>>
export type CompareRunsV1RunsCompareGetQueryError = HTTPValidationError


export function useCompareRunsV1RunsCompareGet<TData = Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>, TError = HTTPValidationError>(
 params: CompareRunsV1RunsCompareGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>,
          TError,
          Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompareRunsV1RunsCompareGet<TData = Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>, TError = HTTPValidationError>(
 params: CompareRunsV1RunsCompareGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>,
          TError,
          Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompareRunsV1RunsCompareGet<TData = Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>, TError = HTTPValidationError>(
 params: CompareRunsV1RunsCompareGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Compare Runs
 */

export function useCompareRunsV1RunsCompareGet<TData = Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>, TError = HTTPValidationError>(
 params: CompareRunsV1RunsCompareGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareRunsV1RunsCompareGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompareRunsV1RunsCompareGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCompareStoreDiffV1RunsCompareStoreDiffGetUrl = (params: CompareStoreDiffV1RunsCompareStoreDiffGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/runs/compare/store-diff?${stringifiedParams}` : `/v1/runs/compare/store-diff`
}

/**
 * For the store diff: did the *other* run actually probe each changed store's area?
 *
 * Resolves whether an added/removed store reflects a genuine serviceability change or
 * just a coverage gap (the other run never looked there). See
 * :meth:`ClickHouse.compare_store_probe`. Declared before ``/{run_id}`` so the literal
 * path wins. Degrades to an empty skeleton on any miss.
 * @summary Compare Store Diff
 */
export const compareStoreDiffV1RunsCompareStoreDiffGet = async (params: CompareStoreDiffV1RunsCompareStoreDiffGetParams, options?: Parameters<typeof customFetch>[1]): Promise<StoreDiffProbe> => {

  return customFetch<StoreDiffProbe>(getCompareStoreDiffV1RunsCompareStoreDiffGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompareStoreDiffV1RunsCompareStoreDiffGetQueryKey = (params?: CompareStoreDiffV1RunsCompareStoreDiffGetParams,) => {
    return [
    `/v1/runs/compare/store-diff`, ...(params ? [params] : [])
    ] as const;
    }


export const getCompareStoreDiffV1RunsCompareStoreDiffGetQueryOptions = <TData = Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>, TError = HTTPValidationError>(params: CompareStoreDiffV1RunsCompareStoreDiffGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompareStoreDiffV1RunsCompareStoreDiffGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>> = ({ signal }) => compareStoreDiffV1RunsCompareStoreDiffGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CompareStoreDiffV1RunsCompareStoreDiffGetQueryResult = NonNullable<Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>>
export type CompareStoreDiffV1RunsCompareStoreDiffGetQueryError = HTTPValidationError


export function useCompareStoreDiffV1RunsCompareStoreDiffGet<TData = Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>, TError = HTTPValidationError>(
 params: CompareStoreDiffV1RunsCompareStoreDiffGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>,
          TError,
          Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompareStoreDiffV1RunsCompareStoreDiffGet<TData = Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>, TError = HTTPValidationError>(
 params: CompareStoreDiffV1RunsCompareStoreDiffGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>,
          TError,
          Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompareStoreDiffV1RunsCompareStoreDiffGet<TData = Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>, TError = HTTPValidationError>(
 params: CompareStoreDiffV1RunsCompareStoreDiffGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Compare Store Diff
 */

export function useCompareStoreDiffV1RunsCompareStoreDiffGet<TData = Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>, TError = HTTPValidationError>(
 params: CompareStoreDiffV1RunsCompareStoreDiffGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareStoreDiffV1RunsCompareStoreDiffGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompareStoreDiffV1RunsCompareStoreDiffGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCompareHandoffV1RunsCompareHandoffGetUrl = (params: CompareHandoffV1RunsCompareHandoffGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/runs/compare/handoff?${stringifiedParams}` : `/v1/runs/compare/handoff`
}

/**
 * For each disappeared/shrank store, which run-B store(s) took over its lost area.
 *
 * See :meth:`ClickHouse.compare_store_handoff`. Distinguishes a genuine coverage loss
 * from a handoff to a neighbour (often a store that grew). Declared before ``/{run_id}``
 * so the literal path wins. Degrades to an empty skeleton on any miss.
 * @summary Compare Handoff
 */
export const compareHandoffV1RunsCompareHandoffGet = async (params: CompareHandoffV1RunsCompareHandoffGetParams, options?: Parameters<typeof customFetch>[1]): Promise<RunHandoff> => {

  return customFetch<RunHandoff>(getCompareHandoffV1RunsCompareHandoffGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCompareHandoffV1RunsCompareHandoffGetQueryKey = (params?: CompareHandoffV1RunsCompareHandoffGetParams,) => {
    return [
    `/v1/runs/compare/handoff`, ...(params ? [params] : [])
    ] as const;
    }


export const getCompareHandoffV1RunsCompareHandoffGetQueryOptions = <TData = Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>, TError = HTTPValidationError>(params: CompareHandoffV1RunsCompareHandoffGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompareHandoffV1RunsCompareHandoffGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>> = ({ signal }) => compareHandoffV1RunsCompareHandoffGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CompareHandoffV1RunsCompareHandoffGetQueryResult = NonNullable<Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>>
export type CompareHandoffV1RunsCompareHandoffGetQueryError = HTTPValidationError


export function useCompareHandoffV1RunsCompareHandoffGet<TData = Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>, TError = HTTPValidationError>(
 params: CompareHandoffV1RunsCompareHandoffGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>,
          TError,
          Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompareHandoffV1RunsCompareHandoffGet<TData = Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>, TError = HTTPValidationError>(
 params: CompareHandoffV1RunsCompareHandoffGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>,
          TError,
          Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCompareHandoffV1RunsCompareHandoffGet<TData = Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>, TError = HTTPValidationError>(
 params: CompareHandoffV1RunsCompareHandoffGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Compare Handoff
 */

export function useCompareHandoffV1RunsCompareHandoffGet<TData = Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>, TError = HTTPValidationError>(
 params: CompareHandoffV1RunsCompareHandoffGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof compareHandoffV1RunsCompareHandoffGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCompareHandoffV1RunsCompareHandoffGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRunSweepStatsBatchV1RunsSweepStatsBatchPostUrl = () => {




  return `/v1/runs/sweep-stats-batch`
}

/**
 * Distinct-store counts for many runs at once: the job page's run-history column.
 *
 * Resolves each run UUID to its ``(platform, run_id)`` and returns
 * ``{run_uuid: distinct_stores}`` with a single ClickHouse query per platform, so the
 * job page fills the whole "distinct" column in one request instead of fanning out one
 * per run. Non-merchant / not-yet-started runs and CH misses are simply absent from the
 * map. Declared before ``/{run_id}`` so the literal path wins.
 * @summary Run Sweep Stats Batch
 */
export const runSweepStatsBatchV1RunsSweepStatsBatchPost = async (_sweepStatsBatchIn: _SweepStatsBatchIn, options?: Parameters<typeof customFetch>[1]): Promise<RunSweepStatsBatchV1RunsSweepStatsBatchPost200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<RunSweepStatsBatchV1RunsSweepStatsBatchPost200>(getRunSweepStatsBatchV1RunsSweepStatsBatchPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(_sweepStatsBatchIn)
  }
);}





export const getRunSweepStatsBatchV1RunsSweepStatsBatchPostMutationKey = () => ['runSweepStatsBatchV1RunsSweepStatsBatchPost'] as const;

export const getRunSweepStatsBatchV1RunsSweepStatsBatchPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runSweepStatsBatchV1RunsSweepStatsBatchPost>>, TError,RunSweepStatsBatchV1RunsSweepStatsBatchPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runSweepStatsBatchV1RunsSweepStatsBatchPost>>, TError,RunSweepStatsBatchV1RunsSweepStatsBatchPostMutationVariables, TContext> => {

const mutationKey = getRunSweepStatsBatchV1RunsSweepStatsBatchPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runSweepStatsBatchV1RunsSweepStatsBatchPost>>, RunSweepStatsBatchV1RunsSweepStatsBatchPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  runSweepStatsBatchV1RunsSweepStatsBatchPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunSweepStatsBatchV1RunsSweepStatsBatchPostMutationResult = NonNullable<Awaited<ReturnType<typeof runSweepStatsBatchV1RunsSweepStatsBatchPost>>>
    export type RunSweepStatsBatchV1RunsSweepStatsBatchPostMutationBody = _SweepStatsBatchIn
    export type RunSweepStatsBatchV1RunsSweepStatsBatchPostMutationError = HTTPValidationError
    export type RunSweepStatsBatchV1RunsSweepStatsBatchPostMutationVariables = {data: _SweepStatsBatchIn}

    /**
 * @summary Run Sweep Stats Batch
 */
export const useRunSweepStatsBatchV1RunsSweepStatsBatchPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runSweepStatsBatchV1RunsSweepStatsBatchPost>>, TError,RunSweepStatsBatchV1RunsSweepStatsBatchPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof runSweepStatsBatchV1RunsSweepStatsBatchPost>>,
        TError,
        RunSweepStatsBatchV1RunsSweepStatsBatchPostMutationVariables,
        TContext
      > => {
      return useMutation(getRunSweepStatsBatchV1RunsSweepStatsBatchPostMutationOptions(options), queryClient);
    }

export const getGetRunV1RunsRunIdGetUrl = (runId: string,) => {




  return `/v1/runs/${runId}`
}

/**
 * @summary Get Run
 */
export const getRunV1RunsRunIdGet = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<RunOut> => {

  return customFetch<RunOut>(getGetRunV1RunsRunIdGetUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRunV1RunsRunIdGetQueryKey = (runId: string,) => {
    return [
    `/v1/runs/${runId}`
    ] as const;
    }


export const getGetRunV1RunsRunIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>, TError = HTTPValidationError>(runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRunV1RunsRunIdGetQueryKey(runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>> = ({ signal }) => getRunV1RunsRunIdGet(runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRunV1RunsRunIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>>
export type GetRunV1RunsRunIdGetQueryError = HTTPValidationError


export function useGetRunV1RunsRunIdGet<TData = Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>, TError = HTTPValidationError>(
 runId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>,
          TError,
          Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRunV1RunsRunIdGet<TData = Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>,
          TError,
          Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRunV1RunsRunIdGet<TData = Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Run
 */

export function useGetRunV1RunsRunIdGet<TData = Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRunV1RunsRunIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRunV1RunsRunIdGetQueryOptions(runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRunEventsV1RunsRunIdEventsGetUrl = (runId: string,) => {




  return `/v1/runs/${runId}/events`
}

/**
 * Live SSE stream of ``{status, progress, error}`` until terminal.
 * @summary Run Events
 */
export const runEventsV1RunsRunIdEventsGet = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {

  return customFetch<unknown>(getRunEventsV1RunsRunIdEventsGetUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRunEventsV1RunsRunIdEventsGetQueryKey = (runId: string,) => {
    return [
    `/v1/runs/${runId}/events`
    ] as const;
    }


export const getRunEventsV1RunsRunIdEventsGetQueryOptions = <TData = Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>, TError = HTTPValidationError>(runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRunEventsV1RunsRunIdEventsGetQueryKey(runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>> = ({ signal }) => runEventsV1RunsRunIdEventsGet(runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RunEventsV1RunsRunIdEventsGetQueryResult = NonNullable<Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>>
export type RunEventsV1RunsRunIdEventsGetQueryError = HTTPValidationError


export function useRunEventsV1RunsRunIdEventsGet<TData = Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>, TError = HTTPValidationError>(
 runId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>,
          TError,
          Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunEventsV1RunsRunIdEventsGet<TData = Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>,
          TError,
          Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunEventsV1RunsRunIdEventsGet<TData = Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Run Events
 */

export function useRunEventsV1RunsRunIdEventsGet<TData = Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runEventsV1RunsRunIdEventsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRunEventsV1RunsRunIdEventsGetQueryOptions(runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRunCoverageV1RunsRunIdCoverageGetUrl = (runId: string,
    params?: RunCoverageV1RunsRunIdCoverageGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/runs/${runId}/coverage?${stringifiedParams}` : `/v1/runs/${runId}/coverage`
}

/**
 * Aggregated scan-coverage for a merchant-sweep run: the run-page live map.
 *
 * Probe points are binned server-side into a zoom/viewport grid (a national dense
 * sweep is millions of points), with viewport-culled store markers. The ``min/max``
 * bbox + ``bin`` (degrees) come from the client's current map view. Degrades to an
 * empty skeleton for a not-yet-started run, a non-merchant flow, or no ClickHouse.
 * @summary Run Coverage
 */
export const runCoverageV1RunsRunIdCoverageGet = async (runId: string,
    params?: RunCoverageV1RunsRunIdCoverageGetParams, options?: Parameters<typeof customFetch>[1]): Promise<RunCoverage> => {

  return customFetch<RunCoverage>(getRunCoverageV1RunsRunIdCoverageGetUrl(runId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRunCoverageV1RunsRunIdCoverageGetQueryKey = (runId: string,
    params?: RunCoverageV1RunsRunIdCoverageGetParams,) => {
    return [
    `/v1/runs/${runId}/coverage`, ...(params ? [params] : [])
    ] as const;
    }


export const getRunCoverageV1RunsRunIdCoverageGetQueryOptions = <TData = Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>, TError = HTTPValidationError>(runId: string,
    params?: RunCoverageV1RunsRunIdCoverageGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRunCoverageV1RunsRunIdCoverageGetQueryKey(runId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>> = ({ signal }) => runCoverageV1RunsRunIdCoverageGet(runId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RunCoverageV1RunsRunIdCoverageGetQueryResult = NonNullable<Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>>
export type RunCoverageV1RunsRunIdCoverageGetQueryError = HTTPValidationError


export function useRunCoverageV1RunsRunIdCoverageGet<TData = Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>, TError = HTTPValidationError>(
 runId: string,
    params: undefined |  RunCoverageV1RunsRunIdCoverageGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>,
          TError,
          Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunCoverageV1RunsRunIdCoverageGet<TData = Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>, TError = HTTPValidationError>(
 runId: string,
    params?: RunCoverageV1RunsRunIdCoverageGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>,
          TError,
          Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunCoverageV1RunsRunIdCoverageGet<TData = Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>, TError = HTTPValidationError>(
 runId: string,
    params?: RunCoverageV1RunsRunIdCoverageGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Run Coverage
 */

export function useRunCoverageV1RunsRunIdCoverageGet<TData = Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>, TError = HTTPValidationError>(
 runId: string,
    params?: RunCoverageV1RunsRunIdCoverageGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runCoverageV1RunsRunIdCoverageGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRunCoverageV1RunsRunIdCoverageGetQueryOptions(runId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRunSweepStatsV1RunsRunIdSweepStatsGetUrl = (runId: string,) => {




  return `/v1/runs/${runId}/sweep-stats`
}

/**
 * This run's OWN aggregate stats: distinct stores it saw, probed/serviceable cells.
 *
 * Distinct from the run's ``progress`` counters, whose ``stores_found`` reflects the
 * anchor stage's rolling-window catalog (all recent runs), not this run alone. This
 * reads ``store_sightings``/``sweep_coverage`` for *this* ``run_id`` only, so the run
 * page can show what the run itself observed. Degrades to a zero skeleton on any miss.
 * @summary Run Sweep Stats
 */
export const runSweepStatsV1RunsRunIdSweepStatsGet = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<RunStats> => {

  return customFetch<RunStats>(getRunSweepStatsV1RunsRunIdSweepStatsGetUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRunSweepStatsV1RunsRunIdSweepStatsGetQueryKey = (runId: string,) => {
    return [
    `/v1/runs/${runId}/sweep-stats`
    ] as const;
    }


export const getRunSweepStatsV1RunsRunIdSweepStatsGetQueryOptions = <TData = Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>, TError = HTTPValidationError>(runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRunSweepStatsV1RunsRunIdSweepStatsGetQueryKey(runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>> = ({ signal }) => runSweepStatsV1RunsRunIdSweepStatsGet(runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RunSweepStatsV1RunsRunIdSweepStatsGetQueryResult = NonNullable<Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>>
export type RunSweepStatsV1RunsRunIdSweepStatsGetQueryError = HTTPValidationError


export function useRunSweepStatsV1RunsRunIdSweepStatsGet<TData = Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>, TError = HTTPValidationError>(
 runId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>,
          TError,
          Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunSweepStatsV1RunsRunIdSweepStatsGet<TData = Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>,
          TError,
          Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunSweepStatsV1RunsRunIdSweepStatsGet<TData = Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Run Sweep Stats
 */

export function useRunSweepStatsV1RunsRunIdSweepStatsGet<TData = Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runSweepStatsV1RunsRunIdSweepStatsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRunSweepStatsV1RunsRunIdSweepStatsGetQueryOptions(runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRunStoreHullsV1RunsRunIdStoreHullsGetUrl = (runId: string,) => {




  return `/v1/runs/${runId}/store-hulls`
}

/**
 * Per-store serviceable-area hulls for a merchant-sweep run: the compare store maps.
 *
 * One polygon per store this run found serviceable, reconstructed from the run's own
 * coverage cells (so it's a true per-run footprint, not the rolling-window dimension).
 * Degrades to an empty skeleton for a not-yet-started run, a non-merchant flow, or no
 * ClickHouse; the map just shows nothing.
 * @summary Run Store Hulls
 */
export const runStoreHullsV1RunsRunIdStoreHullsGet = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<RunStoreHulls> => {

  return customFetch<RunStoreHulls>(getRunStoreHullsV1RunsRunIdStoreHullsGetUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRunStoreHullsV1RunsRunIdStoreHullsGetQueryKey = (runId: string,) => {
    return [
    `/v1/runs/${runId}/store-hulls`
    ] as const;
    }


export const getRunStoreHullsV1RunsRunIdStoreHullsGetQueryOptions = <TData = Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>, TError = HTTPValidationError>(runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRunStoreHullsV1RunsRunIdStoreHullsGetQueryKey(runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>> = ({ signal }) => runStoreHullsV1RunsRunIdStoreHullsGet(runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RunStoreHullsV1RunsRunIdStoreHullsGetQueryResult = NonNullable<Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>>
export type RunStoreHullsV1RunsRunIdStoreHullsGetQueryError = HTTPValidationError


export function useRunStoreHullsV1RunsRunIdStoreHullsGet<TData = Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>, TError = HTTPValidationError>(
 runId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>,
          TError,
          Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunStoreHullsV1RunsRunIdStoreHullsGet<TData = Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>,
          TError,
          Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunStoreHullsV1RunsRunIdStoreHullsGet<TData = Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Run Store Hulls
 */

export function useRunStoreHullsV1RunsRunIdStoreHullsGet<TData = Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreHullsV1RunsRunIdStoreHullsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRunStoreHullsV1RunsRunIdStoreHullsGetQueryOptions(runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRunStoreCoverageV1RunsRunIdStoreCoverageGetUrl = (runId: string,) => {




  return `/v1/runs/${runId}/store-coverage`
}

/**
 * Per-store coverage for a cart-inventory run: covered / delisted / deduped / gave-up.
 *
 * One row per store (with location + tier), drillable into per-SKU detail. Serves
 * both cart-adapter flows: ``cart_inventory`` reports covered/delisted/deduped/gave-up
 * from the price/stock ledger; ``store_sku_map`` reports the carriage matrix
 * (carried -> covered, not-carried -> delisted) from ``store_sku_history``. Degrades
 * to an empty skeleton for a not-yet-started run, a non-cart flow, or no ClickHouse.
 * @summary Run Store Coverage
 */
export const runStoreCoverageV1RunsRunIdStoreCoverageGet = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<StoreCoverage> => {

  return customFetch<StoreCoverage>(getRunStoreCoverageV1RunsRunIdStoreCoverageGetUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRunStoreCoverageV1RunsRunIdStoreCoverageGetQueryKey = (runId: string,) => {
    return [
    `/v1/runs/${runId}/store-coverage`
    ] as const;
    }


export const getRunStoreCoverageV1RunsRunIdStoreCoverageGetQueryOptions = <TData = Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>, TError = HTTPValidationError>(runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRunStoreCoverageV1RunsRunIdStoreCoverageGetQueryKey(runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>> = ({ signal }) => runStoreCoverageV1RunsRunIdStoreCoverageGet(runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RunStoreCoverageV1RunsRunIdStoreCoverageGetQueryResult = NonNullable<Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>>
export type RunStoreCoverageV1RunsRunIdStoreCoverageGetQueryError = HTTPValidationError


export function useRunStoreCoverageV1RunsRunIdStoreCoverageGet<TData = Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>, TError = HTTPValidationError>(
 runId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>,
          TError,
          Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunStoreCoverageV1RunsRunIdStoreCoverageGet<TData = Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>,
          TError,
          Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunStoreCoverageV1RunsRunIdStoreCoverageGet<TData = Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Run Store Coverage
 */

export function useRunStoreCoverageV1RunsRunIdStoreCoverageGet<TData = Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>, TError = HTTPValidationError>(
 runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreCoverageV1RunsRunIdStoreCoverageGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRunStoreCoverageV1RunsRunIdStoreCoverageGetQueryOptions(runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRunStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGetUrl = (runId: string,
    storeId: string,) => {




  return `/v1/runs/${runId}/store-coverage/${storeId}`
}

/**
 * Per-SKU detail for one store in a cart-adapter run (the inline drill-down).
 *
 * Serves both cart flows: ``cart_inventory`` returns each non-covered SKU's status
 * (delisted / deduped / gave-up); ``store_sku_map`` returns the store's not-carried
 * (and mirrored) SKUs from the carriage history.
 * @summary Run Store Sku Detail
 */
export const runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet = async (runId: string,
    storeId: string, options?: Parameters<typeof customFetch>[1]): Promise<StoreSkuDetail> => {

  return customFetch<StoreSkuDetail>(getRunStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGetUrl(runId,storeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRunStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGetQueryKey = (runId: string,
    storeId: string,) => {
    return [
    `/v1/runs/${runId}/store-coverage/${storeId}`
    ] as const;
    }


export const getRunStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGetQueryOptions = <TData = Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>, TError = HTTPValidationError>(runId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRunStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGetQueryKey(runId,storeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>> = ({ signal }) => runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet(runId,storeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined && storeId !== null && storeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RunStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>>
export type RunStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGetQueryError = HTTPValidationError


export function useRunStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet<TData = Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>, TError = HTTPValidationError>(
 runId: string,
    storeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>,
          TError,
          Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet<TData = Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>, TError = HTTPValidationError>(
 runId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>,
          TError,
          Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet<TData = Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>, TError = HTTPValidationError>(
 runId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Run Store Sku Detail
 */

export function useRunStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet<TData = Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>, TError = HTTPValidationError>(
 runId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRunStoreSkuDetailV1RunsRunIdStoreCoverageStoreIdGetQueryOptions(runId,storeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRunStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGetUrl = (runId: string,
    storeId: string,) => {




  return `/v1/runs/${runId}/store-coverage/${storeId}/map`
}

/**
 * Dedup-overlap geometry for one store: its area + the stores that covered its SKUs.
 * @summary Run Store Coverage Map
 */
export const runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet = async (runId: string,
    storeId: string, options?: Parameters<typeof customFetch>[1]): Promise<StoreCoverageMap> => {

  return customFetch<StoreCoverageMap>(getRunStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGetUrl(runId,storeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRunStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGetQueryKey = (runId: string,
    storeId: string,) => {
    return [
    `/v1/runs/${runId}/store-coverage/${storeId}/map`
    ] as const;
    }


export const getRunStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGetQueryOptions = <TData = Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>, TError = HTTPValidationError>(runId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRunStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGetQueryKey(runId,storeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>> = ({ signal }) => runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet(runId,storeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined && storeId !== null && storeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RunStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGetQueryResult = NonNullable<Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>>
export type RunStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGetQueryError = HTTPValidationError


export function useRunStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet<TData = Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>, TError = HTTPValidationError>(
 runId: string,
    storeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>,
          TError,
          Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet<TData = Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>, TError = HTTPValidationError>(
 runId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>,
          TError,
          Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRunStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet<TData = Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>, TError = HTTPValidationError>(
 runId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Run Store Coverage Map
 */

export function useRunStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet<TData = Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>, TError = HTTPValidationError>(
 runId: string,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof runStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRunStoreCoverageMapV1RunsRunIdStoreCoverageStoreIdMapGetQueryOptions(runId,storeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCancelRunV1RunsRunIdCancelPostUrl = (runId: string,) => {




  return `/v1/runs/${runId}/cancel`
}

/**
 * @summary Cancel Run
 */
export const cancelRunV1RunsRunIdCancelPost = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<RunOut> => {

  return customFetch<RunOut>(getCancelRunV1RunsRunIdCancelPostUrl(runId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelRunV1RunsRunIdCancelPostMutationKey = () => ['cancelRunV1RunsRunIdCancelPost'] as const;

export const getCancelRunV1RunsRunIdCancelPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRunV1RunsRunIdCancelPost>>, TError,CancelRunV1RunsRunIdCancelPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelRunV1RunsRunIdCancelPost>>, TError,CancelRunV1RunsRunIdCancelPostMutationVariables, TContext> => {

const mutationKey = getCancelRunV1RunsRunIdCancelPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelRunV1RunsRunIdCancelPost>>, CancelRunV1RunsRunIdCancelPostMutationVariables> = (props) => {
          const {runId} = props ?? {};

          return  cancelRunV1RunsRunIdCancelPost(runId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelRunV1RunsRunIdCancelPostMutationResult = NonNullable<Awaited<ReturnType<typeof cancelRunV1RunsRunIdCancelPost>>>

    export type CancelRunV1RunsRunIdCancelPostMutationError = HTTPValidationError
    export type CancelRunV1RunsRunIdCancelPostMutationVariables = {runId: string}

    /**
 * @summary Cancel Run
 */
export const useCancelRunV1RunsRunIdCancelPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelRunV1RunsRunIdCancelPost>>, TError,CancelRunV1RunsRunIdCancelPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelRunV1RunsRunIdCancelPost>>,
        TError,
        CancelRunV1RunsRunIdCancelPostMutationVariables,
        TContext
      > => {
      return useMutation(getCancelRunV1RunsRunIdCancelPostMutationOptions(options), queryClient);
    }

export const getAdvanceRunToPdpV1RunsRunIdAdvanceToPdpPostUrl = (runId: string,) => {




  return `/v1/runs/${runId}/advance-to-pdp`
}

/**
 * Brand sweep: stop searching, enrich what was found, finish normally.
 *
 * Non-destructive alternative to Cancel: sets ``advance_requested``, which the
 * activity heartbeat polls into the engine's cooperative ``advance_event``; the
 * remaining search tasks are dropped, PDP enrichment still runs, and the run ends
 * succeeded. Idempotent (a second call is a no-op).
 * @summary Advance Run To Pdp
 */
export const advanceRunToPdpV1RunsRunIdAdvanceToPdpPost = async (runId: string, options?: Parameters<typeof customFetch>[1]): Promise<RunOut> => {

  return customFetch<RunOut>(getAdvanceRunToPdpV1RunsRunIdAdvanceToPdpPostUrl(runId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdvanceRunToPdpV1RunsRunIdAdvanceToPdpPostMutationKey = () => ['advanceRunToPdpV1RunsRunIdAdvanceToPdpPost'] as const;

export const getAdvanceRunToPdpV1RunsRunIdAdvanceToPdpPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof advanceRunToPdpV1RunsRunIdAdvanceToPdpPost>>, TError,AdvanceRunToPdpV1RunsRunIdAdvanceToPdpPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof advanceRunToPdpV1RunsRunIdAdvanceToPdpPost>>, TError,AdvanceRunToPdpV1RunsRunIdAdvanceToPdpPostMutationVariables, TContext> => {

const mutationKey = getAdvanceRunToPdpV1RunsRunIdAdvanceToPdpPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof advanceRunToPdpV1RunsRunIdAdvanceToPdpPost>>, AdvanceRunToPdpV1RunsRunIdAdvanceToPdpPostMutationVariables> = (props) => {
          const {runId} = props ?? {};

          return  advanceRunToPdpV1RunsRunIdAdvanceToPdpPost(runId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdvanceRunToPdpV1RunsRunIdAdvanceToPdpPostMutationResult = NonNullable<Awaited<ReturnType<typeof advanceRunToPdpV1RunsRunIdAdvanceToPdpPost>>>

    export type AdvanceRunToPdpV1RunsRunIdAdvanceToPdpPostMutationError = HTTPValidationError
    export type AdvanceRunToPdpV1RunsRunIdAdvanceToPdpPostMutationVariables = {runId: string}

    /**
 * @summary Advance Run To Pdp
 */
export const useAdvanceRunToPdpV1RunsRunIdAdvanceToPdpPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof advanceRunToPdpV1RunsRunIdAdvanceToPdpPost>>, TError,AdvanceRunToPdpV1RunsRunIdAdvanceToPdpPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof advanceRunToPdpV1RunsRunIdAdvanceToPdpPost>>,
        TError,
        AdvanceRunToPdpV1RunsRunIdAdvanceToPdpPostMutationVariables,
        TContext
      > => {
      return useMutation(getAdvanceRunToPdpV1RunsRunIdAdvanceToPdpPostMutationOptions(options), queryClient);
    }

export const getListSchedulesV1JobsJobIdSchedulesGetUrl = (jobId: string,) => {




  return `/v1/jobs/${jobId}/schedules`
}

/**
 * @summary List Schedules
 */
export const listSchedulesV1JobsJobIdSchedulesGet = async (jobId: string, options?: Parameters<typeof customFetch>[1]): Promise<ScheduleOut[]> => {

  return customFetch<ScheduleOut[]>(getListSchedulesV1JobsJobIdSchedulesGetUrl(jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSchedulesV1JobsJobIdSchedulesGetQueryKey = (jobId: string,) => {
    return [
    `/v1/jobs/${jobId}/schedules`
    ] as const;
    }


export const getListSchedulesV1JobsJobIdSchedulesGetQueryOptions = <TData = Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>, TError = HTTPValidationError>(jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSchedulesV1JobsJobIdSchedulesGetQueryKey(jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>> = ({ signal }) => listSchedulesV1JobsJobIdSchedulesGet(jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSchedulesV1JobsJobIdSchedulesGetQueryResult = NonNullable<Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>>
export type ListSchedulesV1JobsJobIdSchedulesGetQueryError = HTTPValidationError


export function useListSchedulesV1JobsJobIdSchedulesGet<TData = Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>, TError = HTTPValidationError>(
 jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>,
          TError,
          Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchedulesV1JobsJobIdSchedulesGet<TData = Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>,
          TError,
          Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSchedulesV1JobsJobIdSchedulesGet<TData = Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Schedules
 */

export function useListSchedulesV1JobsJobIdSchedulesGet<TData = Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>, TError = HTTPValidationError>(
 jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchedulesV1JobsJobIdSchedulesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSchedulesV1JobsJobIdSchedulesGetQueryOptions(jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateScheduleV1JobsJobIdSchedulesPostUrl = (jobId: string,) => {




  return `/v1/jobs/${jobId}/schedules`
}

/**
 * @summary Create Schedule
 */
export const createScheduleV1JobsJobIdSchedulesPost = async (jobId: string,
    scheduleCreate: ScheduleCreate, options?: Parameters<typeof customFetch>[1]): Promise<ScheduleOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ScheduleOut>(getCreateScheduleV1JobsJobIdSchedulesPostUrl(jobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(scheduleCreate)
  }
);}





export const getCreateScheduleV1JobsJobIdSchedulesPostMutationKey = () => ['createScheduleV1JobsJobIdSchedulesPost'] as const;

export const getCreateScheduleV1JobsJobIdSchedulesPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScheduleV1JobsJobIdSchedulesPost>>, TError,CreateScheduleV1JobsJobIdSchedulesPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createScheduleV1JobsJobIdSchedulesPost>>, TError,CreateScheduleV1JobsJobIdSchedulesPostMutationVariables, TContext> => {

const mutationKey = getCreateScheduleV1JobsJobIdSchedulesPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createScheduleV1JobsJobIdSchedulesPost>>, CreateScheduleV1JobsJobIdSchedulesPostMutationVariables> = (props) => {
          const {jobId,data} = props ?? {};

          return  createScheduleV1JobsJobIdSchedulesPost(jobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateScheduleV1JobsJobIdSchedulesPostMutationResult = NonNullable<Awaited<ReturnType<typeof createScheduleV1JobsJobIdSchedulesPost>>>
    export type CreateScheduleV1JobsJobIdSchedulesPostMutationBody = ScheduleCreate
    export type CreateScheduleV1JobsJobIdSchedulesPostMutationError = HTTPValidationError
    export type CreateScheduleV1JobsJobIdSchedulesPostMutationVariables = {jobId: string;data: ScheduleCreate}

    /**
 * @summary Create Schedule
 */
export const useCreateScheduleV1JobsJobIdSchedulesPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScheduleV1JobsJobIdSchedulesPost>>, TError,CreateScheduleV1JobsJobIdSchedulesPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createScheduleV1JobsJobIdSchedulesPost>>,
        TError,
        CreateScheduleV1JobsJobIdSchedulesPostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateScheduleV1JobsJobIdSchedulesPostMutationOptions(options), queryClient);
    }

export const getUpdateScheduleV1SchedulesScheduleIdPatchUrl = (scheduleId: string,) => {




  return `/v1/schedules/${scheduleId}`
}

/**
 * @summary Update Schedule
 */
export const updateScheduleV1SchedulesScheduleIdPatch = async (scheduleId: string,
    scheduleUpdate: ScheduleUpdate, options?: Parameters<typeof customFetch>[1]): Promise<ScheduleOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ScheduleOut>(getUpdateScheduleV1SchedulesScheduleIdPatchUrl(scheduleId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(scheduleUpdate)
  }
);}





export const getUpdateScheduleV1SchedulesScheduleIdPatchMutationKey = () => ['updateScheduleV1SchedulesScheduleIdPatch'] as const;

export const getUpdateScheduleV1SchedulesScheduleIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScheduleV1SchedulesScheduleIdPatch>>, TError,UpdateScheduleV1SchedulesScheduleIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateScheduleV1SchedulesScheduleIdPatch>>, TError,UpdateScheduleV1SchedulesScheduleIdPatchMutationVariables, TContext> => {

const mutationKey = getUpdateScheduleV1SchedulesScheduleIdPatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateScheduleV1SchedulesScheduleIdPatch>>, UpdateScheduleV1SchedulesScheduleIdPatchMutationVariables> = (props) => {
          const {scheduleId,data} = props ?? {};

          return  updateScheduleV1SchedulesScheduleIdPatch(scheduleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateScheduleV1SchedulesScheduleIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateScheduleV1SchedulesScheduleIdPatch>>>
    export type UpdateScheduleV1SchedulesScheduleIdPatchMutationBody = ScheduleUpdate
    export type UpdateScheduleV1SchedulesScheduleIdPatchMutationError = HTTPValidationError
    export type UpdateScheduleV1SchedulesScheduleIdPatchMutationVariables = {scheduleId: string;data: ScheduleUpdate}

    /**
 * @summary Update Schedule
 */
export const useUpdateScheduleV1SchedulesScheduleIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScheduleV1SchedulesScheduleIdPatch>>, TError,UpdateScheduleV1SchedulesScheduleIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateScheduleV1SchedulesScheduleIdPatch>>,
        TError,
        UpdateScheduleV1SchedulesScheduleIdPatchMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateScheduleV1SchedulesScheduleIdPatchMutationOptions(options), queryClient);
    }

export const getDeleteScheduleV1SchedulesScheduleIdDeleteUrl = (scheduleId: string,) => {




  return `/v1/schedules/${scheduleId}`
}

/**
 * @summary Delete Schedule
 */
export const deleteScheduleV1SchedulesScheduleIdDelete = async (scheduleId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteScheduleV1SchedulesScheduleIdDeleteUrl(scheduleId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteScheduleV1SchedulesScheduleIdDeleteMutationKey = () => ['deleteScheduleV1SchedulesScheduleIdDelete'] as const;

export const getDeleteScheduleV1SchedulesScheduleIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScheduleV1SchedulesScheduleIdDelete>>, TError,DeleteScheduleV1SchedulesScheduleIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteScheduleV1SchedulesScheduleIdDelete>>, TError,DeleteScheduleV1SchedulesScheduleIdDeleteMutationVariables, TContext> => {

const mutationKey = getDeleteScheduleV1SchedulesScheduleIdDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteScheduleV1SchedulesScheduleIdDelete>>, DeleteScheduleV1SchedulesScheduleIdDeleteMutationVariables> = (props) => {
          const {scheduleId} = props ?? {};

          return  deleteScheduleV1SchedulesScheduleIdDelete(scheduleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteScheduleV1SchedulesScheduleIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteScheduleV1SchedulesScheduleIdDelete>>>

    export type DeleteScheduleV1SchedulesScheduleIdDeleteMutationError = HTTPValidationError
    export type DeleteScheduleV1SchedulesScheduleIdDeleteMutationVariables = {scheduleId: string}

    /**
 * @summary Delete Schedule
 */
export const useDeleteScheduleV1SchedulesScheduleIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScheduleV1SchedulesScheduleIdDelete>>, TError,DeleteScheduleV1SchedulesScheduleIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteScheduleV1SchedulesScheduleIdDelete>>,
        TError,
        DeleteScheduleV1SchedulesScheduleIdDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteScheduleV1SchedulesScheduleIdDeleteMutationOptions(options), queryClient);
    }

export const getListSettingsV1SettingsGetUrl = () => {




  return `/v1/settings`
}

/**
 * @summary List Settings
 */
export const listSettingsV1SettingsGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<SettingOut[]> => {

  return customFetch<SettingOut[]>(getListSettingsV1SettingsGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSettingsV1SettingsGetQueryKey = () => {
    return [
    `/v1/settings`
    ] as const;
    }


export const getListSettingsV1SettingsGetQueryOptions = <TData = Awaited<ReturnType<typeof listSettingsV1SettingsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSettingsV1SettingsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSettingsV1SettingsGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSettingsV1SettingsGet>>> = ({ signal }) => listSettingsV1SettingsGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSettingsV1SettingsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSettingsV1SettingsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listSettingsV1SettingsGet>>>
export type ListSettingsV1SettingsGetQueryError = unknown


export function useListSettingsV1SettingsGet<TData = Awaited<ReturnType<typeof listSettingsV1SettingsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSettingsV1SettingsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSettingsV1SettingsGet>>,
          TError,
          Awaited<ReturnType<typeof listSettingsV1SettingsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSettingsV1SettingsGet<TData = Awaited<ReturnType<typeof listSettingsV1SettingsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSettingsV1SettingsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSettingsV1SettingsGet>>,
          TError,
          Awaited<ReturnType<typeof listSettingsV1SettingsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSettingsV1SettingsGet<TData = Awaited<ReturnType<typeof listSettingsV1SettingsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSettingsV1SettingsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Settings
 */

export function useListSettingsV1SettingsGet<TData = Awaited<ReturnType<typeof listSettingsV1SettingsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSettingsV1SettingsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSettingsV1SettingsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSettingV1SettingsKeyGetUrl = (key: string,) => {




  return `/v1/settings/${key}`
}

/**
 * @summary Get Setting
 */
export const getSettingV1SettingsKeyGet = async (key: string, options?: Parameters<typeof customFetch>[1]): Promise<SettingOut> => {

  return customFetch<SettingOut>(getGetSettingV1SettingsKeyGetUrl(key),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSettingV1SettingsKeyGetQueryKey = (key: string,) => {
    return [
    `/v1/settings/${key}`
    ] as const;
    }


export const getGetSettingV1SettingsKeyGetQueryOptions = <TData = Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>, TError = HTTPValidationError>(key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingV1SettingsKeyGetQueryKey(key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>> = ({ signal }) => getSettingV1SettingsKeyGet(key, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingV1SettingsKeyGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>>
export type GetSettingV1SettingsKeyGetQueryError = HTTPValidationError


export function useGetSettingV1SettingsKeyGet<TData = Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>, TError = HTTPValidationError>(
 key: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>,
          TError,
          Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingV1SettingsKeyGet<TData = Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>, TError = HTTPValidationError>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>,
          TError,
          Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingV1SettingsKeyGet<TData = Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>, TError = HTTPValidationError>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Setting
 */

export function useGetSettingV1SettingsKeyGet<TData = Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>, TError = HTTPValidationError>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingV1SettingsKeyGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSettingV1SettingsKeyGetQueryOptions(key,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPutSettingV1SettingsKeyPutUrl = (key: string,) => {




  return `/v1/settings/${key}`
}

/**
 * @summary Put Setting
 */
export const putSettingV1SettingsKeyPut = async (key: string,
    setSetting: SetSetting, options?: Parameters<typeof customFetch>[1]): Promise<SettingOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SettingOut>(getPutSettingV1SettingsKeyPutUrl(key),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setSetting)
  }
);}





export const getPutSettingV1SettingsKeyPutMutationKey = () => ['putSettingV1SettingsKeyPut'] as const;

export const getPutSettingV1SettingsKeyPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSettingV1SettingsKeyPut>>, TError,PutSettingV1SettingsKeyPutMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putSettingV1SettingsKeyPut>>, TError,PutSettingV1SettingsKeyPutMutationVariables, TContext> => {

const mutationKey = getPutSettingV1SettingsKeyPutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSettingV1SettingsKeyPut>>, PutSettingV1SettingsKeyPutMutationVariables> = (props) => {
          const {key,data} = props ?? {};

          return  putSettingV1SettingsKeyPut(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutSettingV1SettingsKeyPutMutationResult = NonNullable<Awaited<ReturnType<typeof putSettingV1SettingsKeyPut>>>
    export type PutSettingV1SettingsKeyPutMutationBody = SetSetting
    export type PutSettingV1SettingsKeyPutMutationError = HTTPValidationError
    export type PutSettingV1SettingsKeyPutMutationVariables = {key: string;data: SetSetting}

    /**
 * @summary Put Setting
 */
export const usePutSettingV1SettingsKeyPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSettingV1SettingsKeyPut>>, TError,PutSettingV1SettingsKeyPutMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putSettingV1SettingsKeyPut>>,
        TError,
        PutSettingV1SettingsKeyPutMutationVariables,
        TContext
      > => {
      return useMutation(getPutSettingV1SettingsKeyPutMutationOptions(options), queryClient);
    }

export const getDeleteSettingV1SettingsKeyDeleteUrl = (key: string,
    params: DeleteSettingV1SettingsKeyDeleteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/settings/${key}?${stringifiedParams}` : `/v1/settings/${key}`
}

/**
 * @summary Delete Setting
 */
export const deleteSettingV1SettingsKeyDelete = async (key: string,
    params: DeleteSettingV1SettingsKeyDeleteParams, options?: Parameters<typeof customFetch>[1]): Promise<SettingOut> => {

  return customFetch<SettingOut>(getDeleteSettingV1SettingsKeyDeleteUrl(key,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSettingV1SettingsKeyDeleteMutationKey = () => ['deleteSettingV1SettingsKeyDelete'] as const;

export const getDeleteSettingV1SettingsKeyDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSettingV1SettingsKeyDelete>>, TError,DeleteSettingV1SettingsKeyDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSettingV1SettingsKeyDelete>>, TError,DeleteSettingV1SettingsKeyDeleteMutationVariables, TContext> => {

const mutationKey = getDeleteSettingV1SettingsKeyDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSettingV1SettingsKeyDelete>>, DeleteSettingV1SettingsKeyDeleteMutationVariables> = (props) => {
          const {key,params} = props ?? {};

          return  deleteSettingV1SettingsKeyDelete(key,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSettingV1SettingsKeyDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSettingV1SettingsKeyDelete>>>

    export type DeleteSettingV1SettingsKeyDeleteMutationError = HTTPValidationError
    export type DeleteSettingV1SettingsKeyDeleteMutationVariables = {key: string;params: DeleteSettingV1SettingsKeyDeleteParams}

    /**
 * @summary Delete Setting
 */
export const useDeleteSettingV1SettingsKeyDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSettingV1SettingsKeyDelete>>, TError,DeleteSettingV1SettingsKeyDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSettingV1SettingsKeyDelete>>,
        TError,
        DeleteSettingV1SettingsKeyDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteSettingV1SettingsKeyDeleteMutationOptions(options), queryClient);
    }

export const getSkuCountsV1BrandsSkuCountsGetUrl = (params: SkuCountsV1BrandsSkuCountsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/brands/sku-counts?${stringifiedParams}` : `/v1/brands/sku-counts`
}

/**
 * Per-brand active SKU counts for a platform (``{brand: {enabled, total}}``).
 *
 * Two numbers because two independent switches gate a scrape, and conflating them is how
 * the Brands page ended up claiming ~9.8k SKUs when ~0.8k would actually be probed:
 *
 * * ``total`` -- active SKUs carrying the brand label. The brand's footprint on the
 *   platform. Unaffected by any operator toggle.
 * * ``enabled`` -- ``total`` minus the SKUs switched off via ``sku_overrides.enabled``.
 *   What a sweep of this brand would actually probe, *if* the brand itself is enabled.
 *
 * Neither number looks at ``brands.enabled``: that is a brand-level fact the caller
 * already has, and folding it in here would make a disabled brand read as 0 SKUs rather
 * than "N SKUs, brand off". ``include_combos=false`` drops ``is_bundle=1`` rows from both.
 * @summary Sku Counts
 */
export const skuCountsV1BrandsSkuCountsGet = async (params: SkuCountsV1BrandsSkuCountsGetParams, options?: Parameters<typeof customFetch>[1]): Promise<SkuCountsV1BrandsSkuCountsGet200> => {

  return customFetch<SkuCountsV1BrandsSkuCountsGet200>(getSkuCountsV1BrandsSkuCountsGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkuCountsV1BrandsSkuCountsGetQueryKey = (params?: SkuCountsV1BrandsSkuCountsGetParams,) => {
    return [
    `/v1/brands/sku-counts`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkuCountsV1BrandsSkuCountsGetQueryOptions = <TData = Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>, TError = HTTPValidationError>(params: SkuCountsV1BrandsSkuCountsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkuCountsV1BrandsSkuCountsGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>> = ({ signal }) => skuCountsV1BrandsSkuCountsGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkuCountsV1BrandsSkuCountsGetQueryResult = NonNullable<Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>>
export type SkuCountsV1BrandsSkuCountsGetQueryError = HTTPValidationError


export function useSkuCountsV1BrandsSkuCountsGet<TData = Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>, TError = HTTPValidationError>(
 params: SkuCountsV1BrandsSkuCountsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>,
          TError,
          Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuCountsV1BrandsSkuCountsGet<TData = Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>, TError = HTTPValidationError>(
 params: SkuCountsV1BrandsSkuCountsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>,
          TError,
          Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuCountsV1BrandsSkuCountsGet<TData = Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>, TError = HTTPValidationError>(
 params: SkuCountsV1BrandsSkuCountsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sku Counts
 */

export function useSkuCountsV1BrandsSkuCountsGet<TData = Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>, TError = HTTPValidationError>(
 params: SkuCountsV1BrandsSkuCountsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuCountsV1BrandsSkuCountsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkuCountsV1BrandsSkuCountsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getBrandSkusV1BrandsSkusGetUrl = (params: BrandSkusV1BrandsSkusGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/brands/skus?${stringifiedParams}` : `/v1/brands/skus`
}

/**
 * The current active SKUs for a brand on a platform (the rows behind the count).
 *
 * Merges operator overrides (planning/47): the ``enabled`` master toggle and the effective
 * ``is_bundle`` (a manual bundle override wins over the scraped value).
 * @summary Brand Skus
 */
export const brandSkusV1BrandsSkusGet = async (params: BrandSkusV1BrandsSkusGetParams, options?: Parameters<typeof customFetch>[1]): Promise<Sku[]> => {

  return customFetch<Sku[]>(getBrandSkusV1BrandsSkusGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBrandSkusV1BrandsSkusGetQueryKey = (params?: BrandSkusV1BrandsSkusGetParams,) => {
    return [
    `/v1/brands/skus`, ...(params ? [params] : [])
    ] as const;
    }


export const getBrandSkusV1BrandsSkusGetQueryOptions = <TData = Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>, TError = HTTPValidationError>(params: BrandSkusV1BrandsSkusGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBrandSkusV1BrandsSkusGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>> = ({ signal }) => brandSkusV1BrandsSkusGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BrandSkusV1BrandsSkusGetQueryResult = NonNullable<Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>>
export type BrandSkusV1BrandsSkusGetQueryError = HTTPValidationError


export function useBrandSkusV1BrandsSkusGet<TData = Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>, TError = HTTPValidationError>(
 params: BrandSkusV1BrandsSkusGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>,
          TError,
          Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBrandSkusV1BrandsSkusGet<TData = Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>, TError = HTTPValidationError>(
 params: BrandSkusV1BrandsSkusGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>,
          TError,
          Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBrandSkusV1BrandsSkusGet<TData = Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>, TError = HTTPValidationError>(
 params: BrandSkusV1BrandsSkusGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Brand Skus
 */

export function useBrandSkusV1BrandsSkusGet<TData = Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>, TError = HTTPValidationError>(
 params: BrandSkusV1BrandsSkusGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof brandSkusV1BrandsSkusGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBrandSkusV1BrandsSkusGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getBrandSkusExportV1BrandsSkusExportGetUrl = (params?: BrandSkusExportV1BrandsSkusExportGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["selected"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/brands/skus/export?${stringifiedParams}` : `/v1/brands/skus/export`
}

/**
 * Full-column CSV export of SKUs, across brands and platforms (planning/47, 64).
 *
 * Every ``{p}_skus`` column + the taxonomy label + the operator override state, plus
 * ``platform``, ``brand_enabled`` and ``override_state`` so a cross-brand CSV is
 * self-describing. Streams one platform at a time rather than buffering the whole file.
 *
 * Four independent switches decide whether a SKU is scraped, and each is a separate
 * filter here so no one has to infer which is which:
 *
 * * ``brand_state``  -- ``brands.enabled``, the brand-level switch.
 * * ``sku_state``    -- the effective ``sku_overrides.enabled``; no override row means
 *   enabled, matching dispatch. ``enabled`` here does NOT imply the brand is on.
 * * ``combos``       -- the effective ``is_bundle`` (a manual override outranks the
 *   scraped flag). ``only`` / ``exclude`` / ``all``.
 * * ``sku_status``   -- the ClickHouse lifecycle status; ``active`` by default, ``all``
 *   to include removed/excluded SKUs.
 *
 * Scoped to registered brands, so ``brand_enabled`` is meaningful on every row. ``brand``
 * narrows to one label; ``selected`` narrows to a set (the Brands page checkbox scope).
 * @summary Brand Skus Export
 */
export const brandSkusExportV1BrandsSkusExportGet = async (params?: BrandSkusExportV1BrandsSkusExportGetParams, options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {

  return customFetch<unknown>(getBrandSkusExportV1BrandsSkusExportGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBrandSkusExportV1BrandsSkusExportGetQueryKey = (params?: BrandSkusExportV1BrandsSkusExportGetParams,) => {
    return [
    `/v1/brands/skus/export`, ...(params ? [params] : [])
    ] as const;
    }


export const getBrandSkusExportV1BrandsSkusExportGetQueryOptions = <TData = Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>, TError = HTTPValidationError>(params?: BrandSkusExportV1BrandsSkusExportGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBrandSkusExportV1BrandsSkusExportGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>> = ({ signal }) => brandSkusExportV1BrandsSkusExportGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BrandSkusExportV1BrandsSkusExportGetQueryResult = NonNullable<Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>>
export type BrandSkusExportV1BrandsSkusExportGetQueryError = HTTPValidationError


export function useBrandSkusExportV1BrandsSkusExportGet<TData = Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>, TError = HTTPValidationError>(
 params: undefined |  BrandSkusExportV1BrandsSkusExportGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>,
          TError,
          Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBrandSkusExportV1BrandsSkusExportGet<TData = Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>, TError = HTTPValidationError>(
 params?: BrandSkusExportV1BrandsSkusExportGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>,
          TError,
          Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBrandSkusExportV1BrandsSkusExportGet<TData = Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>, TError = HTTPValidationError>(
 params?: BrandSkusExportV1BrandsSkusExportGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Brand Skus Export
 */

export function useBrandSkusExportV1BrandsSkusExportGet<TData = Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>, TError = HTTPValidationError>(
 params?: BrandSkusExportV1BrandsSkusExportGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof brandSkusExportV1BrandsSkusExportGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBrandSkusExportV1BrandsSkusExportGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getBrandSkusExportCountV1BrandsSkusExportCountGetUrl = (params?: BrandSkusExportCountV1BrandsSkusExportCountGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["selected"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/brands/skus/export/count?${stringifiedParams}` : `/v1/brands/skus/export/count`
}

/**
 * How many rows :func:`brand_skus_export` would return for the same filters.
 *
 * Deliberately runs the identical resolve + filter path rather than approximating, so the
 * number the download dialog shows is the number of data rows you get.
 * @summary Brand Skus Export Count
 */
export const brandSkusExportCountV1BrandsSkusExportCountGet = async (params?: BrandSkusExportCountV1BrandsSkusExportCountGetParams, options?: Parameters<typeof customFetch>[1]): Promise<SkuExportCount> => {

  return customFetch<SkuExportCount>(getBrandSkusExportCountV1BrandsSkusExportCountGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBrandSkusExportCountV1BrandsSkusExportCountGetQueryKey = (params?: BrandSkusExportCountV1BrandsSkusExportCountGetParams,) => {
    return [
    `/v1/brands/skus/export/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getBrandSkusExportCountV1BrandsSkusExportCountGetQueryOptions = <TData = Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>, TError = HTTPValidationError>(params?: BrandSkusExportCountV1BrandsSkusExportCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBrandSkusExportCountV1BrandsSkusExportCountGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>> = ({ signal }) => brandSkusExportCountV1BrandsSkusExportCountGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BrandSkusExportCountV1BrandsSkusExportCountGetQueryResult = NonNullable<Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>>
export type BrandSkusExportCountV1BrandsSkusExportCountGetQueryError = HTTPValidationError


export function useBrandSkusExportCountV1BrandsSkusExportCountGet<TData = Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>, TError = HTTPValidationError>(
 params: undefined |  BrandSkusExportCountV1BrandsSkusExportCountGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>,
          TError,
          Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBrandSkusExportCountV1BrandsSkusExportCountGet<TData = Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>, TError = HTTPValidationError>(
 params?: BrandSkusExportCountV1BrandsSkusExportCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>,
          TError,
          Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBrandSkusExportCountV1BrandsSkusExportCountGet<TData = Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>, TError = HTTPValidationError>(
 params?: BrandSkusExportCountV1BrandsSkusExportCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Brand Skus Export Count
 */

export function useBrandSkusExportCountV1BrandsSkusExportCountGet<TData = Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>, TError = HTTPValidationError>(
 params?: BrandSkusExportCountV1BrandsSkusExportCountGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof brandSkusExportCountV1BrandsSkusExportCountGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBrandSkusExportCountV1BrandsSkusExportCountGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSkuDetailV1SkusPlatformProductIdGetUrl = (platform: Platform,
    productId: string,) => {




  return `/v1/skus/${platform}/${productId}`
}

/**
 * Full detail for one SKU: dimension row + price history + events.
 *
 * The per-store breakdown is its own endpoint (``/stores``): it reads the SKU's whole
 * store universe, and the page's header has no reason to wait on it.
 *
 * 404s on an unknown platform or a SKU that isn't in the current dimension, so the
 * detail page can show a clean not-found state (like the store detail page).
 * @summary Sku Detail
 */
export const skuDetailV1SkusPlatformProductIdGet = async (platform: Platform,
    productId: string, options?: Parameters<typeof customFetch>[1]): Promise<SkuDetail> => {

  return customFetch<SkuDetail>(getSkuDetailV1SkusPlatformProductIdGetUrl(platform,productId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkuDetailV1SkusPlatformProductIdGetQueryKey = (platform: Platform,
    productId: string,) => {
    return [
    `/v1/skus/${platform}/${productId}`
    ] as const;
    }


export const getSkuDetailV1SkusPlatformProductIdGetQueryOptions = <TData = Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>, TError = HTTPValidationError>(platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkuDetailV1SkusPlatformProductIdGetQueryKey(platform,productId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>> = ({ signal }) => skuDetailV1SkusPlatformProductIdGet(platform,productId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: platform !== null && platform !== undefined && productId !== null && productId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkuDetailV1SkusPlatformProductIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>>
export type SkuDetailV1SkusPlatformProductIdGetQueryError = HTTPValidationError


export function useSkuDetailV1SkusPlatformProductIdGet<TData = Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>,
          TError,
          Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuDetailV1SkusPlatformProductIdGet<TData = Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>,
          TError,
          Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuDetailV1SkusPlatformProductIdGet<TData = Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sku Detail
 */

export function useSkuDetailV1SkusPlatformProductIdGet<TData = Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuDetailV1SkusPlatformProductIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkuDetailV1SkusPlatformProductIdGetQueryOptions(platform,productId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSkuStoresV1SkusPlatformProductIdStoresGetUrl = (platform: Platform,
    productId: string,) => {




  return `/v1/skus/${platform}/${productId}/stores`
}

/**
 * Every store in this SKU's universe, with where it stands and its last price.
 *
 * Every admitted store the platform runs, plus any store that ever carried the SKU -
 * not just the ones a recent run happened to reach. A store the table does not list is
 * one we have excluded, which is the only absence a reader now has to explain.
 *
 * Degrades to an empty list rather than erroring, like the store map, so a ClickHouse
 * hiccup empties one panel instead of breaking the page.
 * @summary Sku Stores
 */
export const skuStoresV1SkusPlatformProductIdStoresGet = async (platform: Platform,
    productId: string, options?: Parameters<typeof customFetch>[1]): Promise<SkuStoreRow[]> => {

  return customFetch<SkuStoreRow[]>(getSkuStoresV1SkusPlatformProductIdStoresGetUrl(platform,productId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkuStoresV1SkusPlatformProductIdStoresGetQueryKey = (platform: Platform,
    productId: string,) => {
    return [
    `/v1/skus/${platform}/${productId}/stores`
    ] as const;
    }


export const getSkuStoresV1SkusPlatformProductIdStoresGetQueryOptions = <TData = Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>, TError = HTTPValidationError>(platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkuStoresV1SkusPlatformProductIdStoresGetQueryKey(platform,productId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>> = ({ signal }) => skuStoresV1SkusPlatformProductIdStoresGet(platform,productId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: platform !== null && platform !== undefined && productId !== null && productId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkuStoresV1SkusPlatformProductIdStoresGetQueryResult = NonNullable<Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>>
export type SkuStoresV1SkusPlatformProductIdStoresGetQueryError = HTTPValidationError


export function useSkuStoresV1SkusPlatformProductIdStoresGet<TData = Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>,
          TError,
          Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuStoresV1SkusPlatformProductIdStoresGet<TData = Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>,
          TError,
          Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuStoresV1SkusPlatformProductIdStoresGet<TData = Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sku Stores
 */

export function useSkuStoresV1SkusPlatformProductIdStoresGet<TData = Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuStoresV1SkusPlatformProductIdStoresGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkuStoresV1SkusPlatformProductIdStoresGetQueryOptions(platform,productId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSkuStoreMapV1SkusPlatformProductIdStoreMapGetUrl = (platform: Platform,
    productId: string,
    params?: SkuStoreMapV1SkusPlatformProductIdStoreMapGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/skus/${platform}/${productId}/store-map?${stringifiedParams}` : `/v1/skus/${platform}/${productId}/store-map`
}

/**
 * Active stores annotated with this SKU's presence + stock, for the two SKU maps.
 *
 * ``run_id`` rewinds the availability verdicts to one past cart run; empty (the default)
 * keeps the all-time carriage view the coverage map is built on.
 *
 * Degrades to an empty store list (rather than erroring) so the maps simply show
 * "no data" on a control-plane-only deployment or a transient ClickHouse hiccup.
 * @summary Sku Store Map
 */
export const skuStoreMapV1SkusPlatformProductIdStoreMapGet = async (platform: Platform,
    productId: string,
    params?: SkuStoreMapV1SkusPlatformProductIdStoreMapGetParams, options?: Parameters<typeof customFetch>[1]): Promise<SkuStoreMap> => {

  return customFetch<SkuStoreMap>(getSkuStoreMapV1SkusPlatformProductIdStoreMapGetUrl(platform,productId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkuStoreMapV1SkusPlatformProductIdStoreMapGetQueryKey = (platform: Platform,
    productId: string,
    params?: SkuStoreMapV1SkusPlatformProductIdStoreMapGetParams,) => {
    return [
    `/v1/skus/${platform}/${productId}/store-map`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkuStoreMapV1SkusPlatformProductIdStoreMapGetQueryOptions = <TData = Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>, TError = HTTPValidationError>(platform: Platform,
    productId: string,
    params?: SkuStoreMapV1SkusPlatformProductIdStoreMapGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkuStoreMapV1SkusPlatformProductIdStoreMapGetQueryKey(platform,productId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>> = ({ signal }) => skuStoreMapV1SkusPlatformProductIdStoreMapGet(platform,productId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: platform !== null && platform !== undefined && productId !== null && productId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkuStoreMapV1SkusPlatformProductIdStoreMapGetQueryResult = NonNullable<Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>>
export type SkuStoreMapV1SkusPlatformProductIdStoreMapGetQueryError = HTTPValidationError


export function useSkuStoreMapV1SkusPlatformProductIdStoreMapGet<TData = Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string,
    params: undefined |  SkuStoreMapV1SkusPlatformProductIdStoreMapGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>,
          TError,
          Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuStoreMapV1SkusPlatformProductIdStoreMapGet<TData = Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string,
    params?: SkuStoreMapV1SkusPlatformProductIdStoreMapGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>,
          TError,
          Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuStoreMapV1SkusPlatformProductIdStoreMapGet<TData = Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string,
    params?: SkuStoreMapV1SkusPlatformProductIdStoreMapGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sku Store Map
 */

export function useSkuStoreMapV1SkusPlatformProductIdStoreMapGet<TData = Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string,
    params?: SkuStoreMapV1SkusPlatformProductIdStoreMapGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuStoreMapV1SkusPlatformProductIdStoreMapGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkuStoreMapV1SkusPlatformProductIdStoreMapGetQueryOptions(platform,productId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSkuInventoryV1SkusPlatformProductIdInventoryGetUrl = (platform: Platform,
    productId: string,
    params?: SkuInventoryV1SkusPlatformProductIdInventoryGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/skus/${platform}/${productId}/inventory?${stringifiedParams}` : `/v1/skus/${platform}/${productId}/inventory`
}

/**
 * Per-run inventory level + per-day estimated sales for one SKU.
 *
 * One read behind both charts, so the two panels can never show different windows: the
 * level half scans `cart_inventory` per run, the sales half re-aggregates the day-grain
 * `metric_daily` rollup. Degrades to empty series rather than 500ing.
 * @summary Sku Inventory
 */
export const skuInventoryV1SkusPlatformProductIdInventoryGet = async (platform: Platform,
    productId: string,
    params?: SkuInventoryV1SkusPlatformProductIdInventoryGetParams, options?: Parameters<typeof customFetch>[1]): Promise<SkuInventorySeries> => {

  return customFetch<SkuInventorySeries>(getSkuInventoryV1SkusPlatformProductIdInventoryGetUrl(platform,productId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkuInventoryV1SkusPlatformProductIdInventoryGetQueryKey = (platform: Platform,
    productId: string,
    params?: SkuInventoryV1SkusPlatformProductIdInventoryGetParams,) => {
    return [
    `/v1/skus/${platform}/${productId}/inventory`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkuInventoryV1SkusPlatformProductIdInventoryGetQueryOptions = <TData = Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>, TError = HTTPValidationError>(platform: Platform,
    productId: string,
    params?: SkuInventoryV1SkusPlatformProductIdInventoryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkuInventoryV1SkusPlatformProductIdInventoryGetQueryKey(platform,productId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>> = ({ signal }) => skuInventoryV1SkusPlatformProductIdInventoryGet(platform,productId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: platform !== null && platform !== undefined && productId !== null && productId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkuInventoryV1SkusPlatformProductIdInventoryGetQueryResult = NonNullable<Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>>
export type SkuInventoryV1SkusPlatformProductIdInventoryGetQueryError = HTTPValidationError


export function useSkuInventoryV1SkusPlatformProductIdInventoryGet<TData = Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string,
    params: undefined |  SkuInventoryV1SkusPlatformProductIdInventoryGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>,
          TError,
          Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuInventoryV1SkusPlatformProductIdInventoryGet<TData = Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string,
    params?: SkuInventoryV1SkusPlatformProductIdInventoryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>,
          TError,
          Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuInventoryV1SkusPlatformProductIdInventoryGet<TData = Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string,
    params?: SkuInventoryV1SkusPlatformProductIdInventoryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sku Inventory
 */

export function useSkuInventoryV1SkusPlatformProductIdInventoryGet<TData = Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string,
    params?: SkuInventoryV1SkusPlatformProductIdInventoryGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuInventoryV1SkusPlatformProductIdInventoryGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkuInventoryV1SkusPlatformProductIdInventoryGetQueryOptions(platform,productId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetUrl = (platform: Platform,
    productId: string,
    storeId: string,
    params?: SkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/skus/${platform}/${productId}/stores/${storeId}?${stringifiedParams}` : `/v1/skus/${platform}/${productId}/stores/${storeId}`
}

/**
 * SKU dimension row + the (store, SKU) observation history for one store.
 *
 * The series behind the SKU x store page's price and inventory charts; full store
 * details come from the existing ``/v1/stores/{platform}/{store_id}`` endpoint.
 * 404s on an unknown platform or a SKU not in the current dimension.
 *
 * ``days`` frames the history, clamped the same 1..90 as ``/inventory`` so the two
 * pages cannot offer windows the other refuses. The ``latest`` row it returns beside
 * the history ignores the window.
 * @summary Sku Store Detail
 */
export const skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet = async (platform: Platform,
    productId: string,
    storeId: string,
    params?: SkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetParams, options?: Parameters<typeof customFetch>[1]): Promise<SkuStoreDetail> => {

  return customFetch<SkuStoreDetail>(getSkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetUrl(platform,productId,storeId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetQueryKey = (platform: Platform,
    productId: string,
    storeId: string,
    params?: SkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetParams,) => {
    return [
    `/v1/skus/${platform}/${productId}/stores/${storeId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetQueryOptions = <TData = Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>, TError = HTTPValidationError>(platform: Platform,
    productId: string,
    storeId: string,
    params?: SkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetQueryKey(platform,productId,storeId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>> = ({ signal }) => skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet(platform,productId,storeId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: platform !== null && platform !== undefined && productId !== null && productId !== undefined && storeId !== null && storeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>>
export type SkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetQueryError = HTTPValidationError


export function useSkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet<TData = Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string,
    storeId: string,
    params: undefined |  SkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>,
          TError,
          Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet<TData = Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string,
    storeId: string,
    params?: SkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>,
          TError,
          Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet<TData = Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string,
    storeId: string,
    params?: SkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sku Store Detail
 */

export function useSkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet<TData = Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string,
    storeId: string,
    params?: SkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuStoreDetailV1SkusPlatformProductIdStoresStoreIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkuStoreDetailV1SkusPlatformProductIdStoresStoreIdGetQueryOptions(platform,productId,storeId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSkuPdpV1SkusPlatformProductIdPdpGetUrl = (platform: Platform,
    productId: string,) => {




  return `/v1/skus/${platform}/${productId}/pdp`
}

/**
 * Everything the PDP parser could extract from this SKU's most recent cached PDP.
 *
 * Re-parses the raw cached body with the platform's own ``parse_pdp`` so the page
 * reflects exactly what the brand sweep extracts; ``captured=false`` when there is
 * no cached PDP (search-only discovery, or the 30-day cache row has expired).
 * @summary Sku Pdp
 */
export const skuPdpV1SkusPlatformProductIdPdpGet = async (platform: Platform,
    productId: string, options?: Parameters<typeof customFetch>[1]): Promise<SkuPdp> => {

  return customFetch<SkuPdp>(getSkuPdpV1SkusPlatformProductIdPdpGetUrl(platform,productId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkuPdpV1SkusPlatformProductIdPdpGetQueryKey = (platform: Platform,
    productId: string,) => {
    return [
    `/v1/skus/${platform}/${productId}/pdp`
    ] as const;
    }


export const getSkuPdpV1SkusPlatformProductIdPdpGetQueryOptions = <TData = Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>, TError = HTTPValidationError>(platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkuPdpV1SkusPlatformProductIdPdpGetQueryKey(platform,productId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>> = ({ signal }) => skuPdpV1SkusPlatformProductIdPdpGet(platform,productId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: platform !== null && platform !== undefined && productId !== null && productId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkuPdpV1SkusPlatformProductIdPdpGetQueryResult = NonNullable<Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>>
export type SkuPdpV1SkusPlatformProductIdPdpGetQueryError = HTTPValidationError


export function useSkuPdpV1SkusPlatformProductIdPdpGet<TData = Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>,
          TError,
          Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuPdpV1SkusPlatformProductIdPdpGet<TData = Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>,
          TError,
          Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuPdpV1SkusPlatformProductIdPdpGet<TData = Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sku Pdp
 */

export function useSkuPdpV1SkusPlatformProductIdPdpGet<TData = Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuPdpV1SkusPlatformProductIdPdpGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkuPdpV1SkusPlatformProductIdPdpGetQueryOptions(platform,productId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSkuEventsV1SkuEventsGetUrl = (params: SkuEventsV1SkuEventsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/sku-events?${stringifiedParams}` : `/v1/sku-events`
}

/**
 * Recent SKU lifecycle events for a brand (newest first).
 * @summary Sku Events
 */
export const skuEventsV1SkuEventsGet = async (params: SkuEventsV1SkuEventsGetParams, options?: Parameters<typeof customFetch>[1]): Promise<SkuEvent[]> => {

  return customFetch<SkuEvent[]>(getSkuEventsV1SkuEventsGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkuEventsV1SkuEventsGetQueryKey = (params?: SkuEventsV1SkuEventsGetParams,) => {
    return [
    `/v1/sku-events`, ...(params ? [params] : [])
    ] as const;
    }


export const getSkuEventsV1SkuEventsGetQueryOptions = <TData = Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>, TError = HTTPValidationError>(params: SkuEventsV1SkuEventsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkuEventsV1SkuEventsGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>> = ({ signal }) => skuEventsV1SkuEventsGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkuEventsV1SkuEventsGetQueryResult = NonNullable<Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>>
export type SkuEventsV1SkuEventsGetQueryError = HTTPValidationError


export function useSkuEventsV1SkuEventsGet<TData = Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>, TError = HTTPValidationError>(
 params: SkuEventsV1SkuEventsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>,
          TError,
          Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuEventsV1SkuEventsGet<TData = Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>, TError = HTTPValidationError>(
 params: SkuEventsV1SkuEventsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>,
          TError,
          Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkuEventsV1SkuEventsGet<TData = Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>, TError = HTTPValidationError>(
 params: SkuEventsV1SkuEventsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Sku Events
 */

export function useSkuEventsV1SkuEventsGet<TData = Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>, TError = HTTPValidationError>(
 params: SkuEventsV1SkuEventsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skuEventsV1SkuEventsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkuEventsV1SkuEventsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListBrandsV1BrandsGetUrl = () => {




  return `/v1/brands`
}

/**
 * @summary List Brands
 */
export const listBrandsV1BrandsGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<BrandOut[]> => {

  return customFetch<BrandOut[]>(getListBrandsV1BrandsGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBrandsV1BrandsGetQueryKey = () => {
    return [
    `/v1/brands`
    ] as const;
    }


export const getListBrandsV1BrandsGetQueryOptions = <TData = Awaited<ReturnType<typeof listBrandsV1BrandsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrandsV1BrandsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBrandsV1BrandsGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBrandsV1BrandsGet>>> = ({ signal }) => listBrandsV1BrandsGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBrandsV1BrandsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBrandsV1BrandsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listBrandsV1BrandsGet>>>
export type ListBrandsV1BrandsGetQueryError = unknown


export function useListBrandsV1BrandsGet<TData = Awaited<ReturnType<typeof listBrandsV1BrandsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrandsV1BrandsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBrandsV1BrandsGet>>,
          TError,
          Awaited<ReturnType<typeof listBrandsV1BrandsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBrandsV1BrandsGet<TData = Awaited<ReturnType<typeof listBrandsV1BrandsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrandsV1BrandsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBrandsV1BrandsGet>>,
          TError,
          Awaited<ReturnType<typeof listBrandsV1BrandsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBrandsV1BrandsGet<TData = Awaited<ReturnType<typeof listBrandsV1BrandsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrandsV1BrandsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Brands
 */

export function useListBrandsV1BrandsGet<TData = Awaited<ReturnType<typeof listBrandsV1BrandsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrandsV1BrandsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBrandsV1BrandsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateBrandV1BrandsPostUrl = () => {




  return `/v1/brands`
}

/**
 * @summary Create Brand
 */
export const createBrandV1BrandsPost = async (brandCreate: BrandCreate, options?: Parameters<typeof customFetch>[1]): Promise<BrandOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BrandOut>(getCreateBrandV1BrandsPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(brandCreate)
  }
);}





export const getCreateBrandV1BrandsPostMutationKey = () => ['createBrandV1BrandsPost'] as const;

export const getCreateBrandV1BrandsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBrandV1BrandsPost>>, TError,CreateBrandV1BrandsPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBrandV1BrandsPost>>, TError,CreateBrandV1BrandsPostMutationVariables, TContext> => {

const mutationKey = getCreateBrandV1BrandsPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBrandV1BrandsPost>>, CreateBrandV1BrandsPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createBrandV1BrandsPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBrandV1BrandsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createBrandV1BrandsPost>>>
    export type CreateBrandV1BrandsPostMutationBody = BrandCreate
    export type CreateBrandV1BrandsPostMutationError = HTTPValidationError
    export type CreateBrandV1BrandsPostMutationVariables = {data: BrandCreate}

    /**
 * @summary Create Brand
 */
export const useCreateBrandV1BrandsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBrandV1BrandsPost>>, TError,CreateBrandV1BrandsPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBrandV1BrandsPost>>,
        TError,
        CreateBrandV1BrandsPostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateBrandV1BrandsPostMutationOptions(options), queryClient);
    }

export const getSetEnabledV1BrandsSetEnabledPostUrl = () => {




  return `/v1/brands/set-enabled`
}

/**
 * Activate/deactivate brands in bulk: selected ``ids``, or all when ``None``.
 * @summary Set Enabled
 */
export const setEnabledV1BrandsSetEnabledPost = async (brandSetEnabled: BrandSetEnabled, options?: Parameters<typeof customFetch>[1]): Promise<BrandOut[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BrandOut[]>(getSetEnabledV1BrandsSetEnabledPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(brandSetEnabled)
  }
);}





export const getSetEnabledV1BrandsSetEnabledPostMutationKey = () => ['setEnabledV1BrandsSetEnabledPost'] as const;

export const getSetEnabledV1BrandsSetEnabledPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setEnabledV1BrandsSetEnabledPost>>, TError,SetEnabledV1BrandsSetEnabledPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setEnabledV1BrandsSetEnabledPost>>, TError,SetEnabledV1BrandsSetEnabledPostMutationVariables, TContext> => {

const mutationKey = getSetEnabledV1BrandsSetEnabledPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setEnabledV1BrandsSetEnabledPost>>, SetEnabledV1BrandsSetEnabledPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setEnabledV1BrandsSetEnabledPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetEnabledV1BrandsSetEnabledPostMutationResult = NonNullable<Awaited<ReturnType<typeof setEnabledV1BrandsSetEnabledPost>>>
    export type SetEnabledV1BrandsSetEnabledPostMutationBody = BrandSetEnabled
    export type SetEnabledV1BrandsSetEnabledPostMutationError = HTTPValidationError
    export type SetEnabledV1BrandsSetEnabledPostMutationVariables = {data: BrandSetEnabled}

    /**
 * @summary Set Enabled
 */
export const useSetEnabledV1BrandsSetEnabledPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setEnabledV1BrandsSetEnabledPost>>, TError,SetEnabledV1BrandsSetEnabledPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setEnabledV1BrandsSetEnabledPost>>,
        TError,
        SetEnabledV1BrandsSetEnabledPostMutationVariables,
        TContext
      > => {
      return useMutation(getSetEnabledV1BrandsSetEnabledPostMutationOptions(options), queryClient);
    }

export const getSetPriorityV1BrandsSetPriorityPostUrl = () => {




  return `/v1/brands/set-priority`
}

/**
 * Set sweep priority in bulk -- selected ``ids``, or all when ``None``.
 * @summary Set Priority
 */
export const setPriorityV1BrandsSetPriorityPost = async (brandSetPriority: BrandSetPriority, options?: Parameters<typeof customFetch>[1]): Promise<BrandOut[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BrandOut[]>(getSetPriorityV1BrandsSetPriorityPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(brandSetPriority)
  }
);}





export const getSetPriorityV1BrandsSetPriorityPostMutationKey = () => ['setPriorityV1BrandsSetPriorityPost'] as const;

export const getSetPriorityV1BrandsSetPriorityPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPriorityV1BrandsSetPriorityPost>>, TError,SetPriorityV1BrandsSetPriorityPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPriorityV1BrandsSetPriorityPost>>, TError,SetPriorityV1BrandsSetPriorityPostMutationVariables, TContext> => {

const mutationKey = getSetPriorityV1BrandsSetPriorityPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPriorityV1BrandsSetPriorityPost>>, SetPriorityV1BrandsSetPriorityPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setPriorityV1BrandsSetPriorityPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPriorityV1BrandsSetPriorityPostMutationResult = NonNullable<Awaited<ReturnType<typeof setPriorityV1BrandsSetPriorityPost>>>
    export type SetPriorityV1BrandsSetPriorityPostMutationBody = BrandSetPriority
    export type SetPriorityV1BrandsSetPriorityPostMutationError = HTTPValidationError
    export type SetPriorityV1BrandsSetPriorityPostMutationVariables = {data: BrandSetPriority}

    /**
 * @summary Set Priority
 */
export const useSetPriorityV1BrandsSetPriorityPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPriorityV1BrandsSetPriorityPost>>, TError,SetPriorityV1BrandsSetPriorityPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setPriorityV1BrandsSetPriorityPost>>,
        TError,
        SetPriorityV1BrandsSetPriorityPostMutationVariables,
        TContext
      > => {
      return useMutation(getSetPriorityV1BrandsSetPriorityPostMutationOptions(options), queryClient);
    }

export const getSetForceAllStoresV1BrandsSetForceAllStoresPostUrl = () => {




  return `/v1/brands/set-force-all-stores`
}

/**
 * Set the cart force-all-stores flag in bulk (planning/47).
 *
 * A flagged brand's SKUs are probed in every active store in cart inventory even when the
 * run has the store-sku carriage filter on. ``ids=None`` targets every brand.
 * @summary Set Force All Stores
 */
export const setForceAllStoresV1BrandsSetForceAllStoresPost = async (brandSetForceAllStores: BrandSetForceAllStores, options?: Parameters<typeof customFetch>[1]): Promise<BrandOut[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BrandOut[]>(getSetForceAllStoresV1BrandsSetForceAllStoresPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(brandSetForceAllStores)
  }
);}





export const getSetForceAllStoresV1BrandsSetForceAllStoresPostMutationKey = () => ['setForceAllStoresV1BrandsSetForceAllStoresPost'] as const;

export const getSetForceAllStoresV1BrandsSetForceAllStoresPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setForceAllStoresV1BrandsSetForceAllStoresPost>>, TError,SetForceAllStoresV1BrandsSetForceAllStoresPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setForceAllStoresV1BrandsSetForceAllStoresPost>>, TError,SetForceAllStoresV1BrandsSetForceAllStoresPostMutationVariables, TContext> => {

const mutationKey = getSetForceAllStoresV1BrandsSetForceAllStoresPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setForceAllStoresV1BrandsSetForceAllStoresPost>>, SetForceAllStoresV1BrandsSetForceAllStoresPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setForceAllStoresV1BrandsSetForceAllStoresPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetForceAllStoresV1BrandsSetForceAllStoresPostMutationResult = NonNullable<Awaited<ReturnType<typeof setForceAllStoresV1BrandsSetForceAllStoresPost>>>
    export type SetForceAllStoresV1BrandsSetForceAllStoresPostMutationBody = BrandSetForceAllStores
    export type SetForceAllStoresV1BrandsSetForceAllStoresPostMutationError = HTTPValidationError
    export type SetForceAllStoresV1BrandsSetForceAllStoresPostMutationVariables = {data: BrandSetForceAllStores}

    /**
 * @summary Set Force All Stores
 */
export const useSetForceAllStoresV1BrandsSetForceAllStoresPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setForceAllStoresV1BrandsSetForceAllStoresPost>>, TError,SetForceAllStoresV1BrandsSetForceAllStoresPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setForceAllStoresV1BrandsSetForceAllStoresPost>>,
        TError,
        SetForceAllStoresV1BrandsSetForceAllStoresPostMutationVariables,
        TContext
      > => {
      return useMutation(getSetForceAllStoresV1BrandsSetForceAllStoresPostMutationOptions(options), queryClient);
    }

export const getBulkDeleteV1BrandsBulkDeletePostUrl = () => {




  return `/v1/brands/bulk-delete`
}

/**
 * Remove many brands by id in one call (the Brands table's bulk-select action).
 * @summary Bulk Delete
 */
export const bulkDeleteV1BrandsBulkDeletePost = async (brandBulkDelete: BrandBulkDelete, options?: Parameters<typeof customFetch>[1]): Promise<BrandBulkDeleteResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BrandBulkDeleteResult>(getBulkDeleteV1BrandsBulkDeletePostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(brandBulkDelete)
  }
);}





export const getBulkDeleteV1BrandsBulkDeletePostMutationKey = () => ['bulkDeleteV1BrandsBulkDeletePost'] as const;

export const getBulkDeleteV1BrandsBulkDeletePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteV1BrandsBulkDeletePost>>, TError,BulkDeleteV1BrandsBulkDeletePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteV1BrandsBulkDeletePost>>, TError,BulkDeleteV1BrandsBulkDeletePostMutationVariables, TContext> => {

const mutationKey = getBulkDeleteV1BrandsBulkDeletePostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDeleteV1BrandsBulkDeletePost>>, BulkDeleteV1BrandsBulkDeletePostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  bulkDeleteV1BrandsBulkDeletePost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkDeleteV1BrandsBulkDeletePostMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDeleteV1BrandsBulkDeletePost>>>
    export type BulkDeleteV1BrandsBulkDeletePostMutationBody = BrandBulkDelete
    export type BulkDeleteV1BrandsBulkDeletePostMutationError = HTTPValidationError
    export type BulkDeleteV1BrandsBulkDeletePostMutationVariables = {data: BrandBulkDelete}

    /**
 * @summary Bulk Delete
 */
export const useBulkDeleteV1BrandsBulkDeletePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteV1BrandsBulkDeletePost>>, TError,BulkDeleteV1BrandsBulkDeletePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkDeleteV1BrandsBulkDeletePost>>,
        TError,
        BulkDeleteV1BrandsBulkDeletePostMutationVariables,
        TContext
      > => {
      return useMutation(getBulkDeleteV1BrandsBulkDeletePostMutationOptions(options), queryClient);
    }

export const getGetBrandV1BrandsBrandIdGetUrl = (brandId: string,) => {




  return `/v1/brands/${brandId}`
}

/**
 * @summary Get Brand
 */
export const getBrandV1BrandsBrandIdGet = async (brandId: string, options?: Parameters<typeof customFetch>[1]): Promise<BrandOut> => {

  return customFetch<BrandOut>(getGetBrandV1BrandsBrandIdGetUrl(brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBrandV1BrandsBrandIdGetQueryKey = (brandId: string,) => {
    return [
    `/v1/brands/${brandId}`
    ] as const;
    }


export const getGetBrandV1BrandsBrandIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>, TError = HTTPValidationError>(brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrandV1BrandsBrandIdGetQueryKey(brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>> = ({ signal }) => getBrandV1BrandsBrandIdGet(brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrandV1BrandsBrandIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>>
export type GetBrandV1BrandsBrandIdGetQueryError = HTTPValidationError


export function useGetBrandV1BrandsBrandIdGet<TData = Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>, TError = HTTPValidationError>(
 brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>,
          TError,
          Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrandV1BrandsBrandIdGet<TData = Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>, TError = HTTPValidationError>(
 brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>,
          TError,
          Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrandV1BrandsBrandIdGet<TData = Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>, TError = HTTPValidationError>(
 brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Brand
 */

export function useGetBrandV1BrandsBrandIdGet<TData = Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>, TError = HTTPValidationError>(
 brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandV1BrandsBrandIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrandV1BrandsBrandIdGetQueryOptions(brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateBrandV1BrandsBrandIdPatchUrl = (brandId: string,) => {




  return `/v1/brands/${brandId}`
}

/**
 * @summary Update Brand
 */
export const updateBrandV1BrandsBrandIdPatch = async (brandId: string,
    brandUpdate: BrandUpdate, options?: Parameters<typeof customFetch>[1]): Promise<BrandOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BrandOut>(getUpdateBrandV1BrandsBrandIdPatchUrl(brandId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(brandUpdate)
  }
);}





export const getUpdateBrandV1BrandsBrandIdPatchMutationKey = () => ['updateBrandV1BrandsBrandIdPatch'] as const;

export const getUpdateBrandV1BrandsBrandIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBrandV1BrandsBrandIdPatch>>, TError,UpdateBrandV1BrandsBrandIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBrandV1BrandsBrandIdPatch>>, TError,UpdateBrandV1BrandsBrandIdPatchMutationVariables, TContext> => {

const mutationKey = getUpdateBrandV1BrandsBrandIdPatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBrandV1BrandsBrandIdPatch>>, UpdateBrandV1BrandsBrandIdPatchMutationVariables> = (props) => {
          const {brandId,data} = props ?? {};

          return  updateBrandV1BrandsBrandIdPatch(brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBrandV1BrandsBrandIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateBrandV1BrandsBrandIdPatch>>>
    export type UpdateBrandV1BrandsBrandIdPatchMutationBody = BrandUpdate
    export type UpdateBrandV1BrandsBrandIdPatchMutationError = HTTPValidationError
    export type UpdateBrandV1BrandsBrandIdPatchMutationVariables = {brandId: string;data: BrandUpdate}

    /**
 * @summary Update Brand
 */
export const useUpdateBrandV1BrandsBrandIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBrandV1BrandsBrandIdPatch>>, TError,UpdateBrandV1BrandsBrandIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateBrandV1BrandsBrandIdPatch>>,
        TError,
        UpdateBrandV1BrandsBrandIdPatchMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateBrandV1BrandsBrandIdPatchMutationOptions(options), queryClient);
    }

export const getDeleteBrandV1BrandsBrandIdDeleteUrl = (brandId: string,) => {




  return `/v1/brands/${brandId}`
}

/**
 * @summary Delete Brand
 */
export const deleteBrandV1BrandsBrandIdDelete = async (brandId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteBrandV1BrandsBrandIdDeleteUrl(brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteBrandV1BrandsBrandIdDeleteMutationKey = () => ['deleteBrandV1BrandsBrandIdDelete'] as const;

export const getDeleteBrandV1BrandsBrandIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBrandV1BrandsBrandIdDelete>>, TError,DeleteBrandV1BrandsBrandIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBrandV1BrandsBrandIdDelete>>, TError,DeleteBrandV1BrandsBrandIdDeleteMutationVariables, TContext> => {

const mutationKey = getDeleteBrandV1BrandsBrandIdDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBrandV1BrandsBrandIdDelete>>, DeleteBrandV1BrandsBrandIdDeleteMutationVariables> = (props) => {
          const {brandId} = props ?? {};

          return  deleteBrandV1BrandsBrandIdDelete(brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteBrandV1BrandsBrandIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBrandV1BrandsBrandIdDelete>>>

    export type DeleteBrandV1BrandsBrandIdDeleteMutationError = HTTPValidationError
    export type DeleteBrandV1BrandsBrandIdDeleteMutationVariables = {brandId: string}

    /**
 * @summary Delete Brand
 */
export const useDeleteBrandV1BrandsBrandIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBrandV1BrandsBrandIdDelete>>, TError,DeleteBrandV1BrandsBrandIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBrandV1BrandsBrandIdDelete>>,
        TError,
        DeleteBrandV1BrandsBrandIdDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteBrandV1BrandsBrandIdDeleteMutationOptions(options), queryClient);
    }

export const getRenameBrandV1BrandsBrandIdRenamePostUrl = (brandId: string,) => {




  return `/v1/brands/${brandId}/rename`
}

/**
 * Change the canonical brand name, repointing everything keyed by the old one.
 *
 * The name is the join key into the ClickHouse facts and the scope selector jobs carry,
 * so this is not a plain field write -- see :mod:`._rename` for what has to move with
 * it. The advisory lock is taken before the brand is even read, so the collision probe,
 * the ClickHouse rewrite and the commit that settles who owns the new name all sit in
 * one exclusion window; ClickHouse is rewritten before Postgres commits, so a failed
 * repoint leaves both stores on the old name instead of stranding the brand's SKUs.
 *
 * EVERY path after the rewrite reverts it, not just the one that was foreseen: whatever
 * stops the commit (a jobs-table deadlock, a dropped connection, the unique race with a
 * concurrent create), leaving ClickHouse ahead of Postgres would make the brand read as
 * having no SKUs and no history at all, with nothing saying why.
 * @summary Rename Brand
 */
export const renameBrandV1BrandsBrandIdRenamePost = async (brandId: string,
    brandRename: BrandRename, options?: Parameters<typeof customFetch>[1]): Promise<BrandRenameResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BrandRenameResult>(getRenameBrandV1BrandsBrandIdRenamePostUrl(brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(brandRename)
  }
);}





export const getRenameBrandV1BrandsBrandIdRenamePostMutationKey = () => ['renameBrandV1BrandsBrandIdRenamePost'] as const;

export const getRenameBrandV1BrandsBrandIdRenamePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameBrandV1BrandsBrandIdRenamePost>>, TError,RenameBrandV1BrandsBrandIdRenamePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof renameBrandV1BrandsBrandIdRenamePost>>, TError,RenameBrandV1BrandsBrandIdRenamePostMutationVariables, TContext> => {

const mutationKey = getRenameBrandV1BrandsBrandIdRenamePostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renameBrandV1BrandsBrandIdRenamePost>>, RenameBrandV1BrandsBrandIdRenamePostMutationVariables> = (props) => {
          const {brandId,data} = props ?? {};

          return  renameBrandV1BrandsBrandIdRenamePost(brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenameBrandV1BrandsBrandIdRenamePostMutationResult = NonNullable<Awaited<ReturnType<typeof renameBrandV1BrandsBrandIdRenamePost>>>
    export type RenameBrandV1BrandsBrandIdRenamePostMutationBody = BrandRename
    export type RenameBrandV1BrandsBrandIdRenamePostMutationError = HTTPValidationError
    export type RenameBrandV1BrandsBrandIdRenamePostMutationVariables = {brandId: string;data: BrandRename}

    /**
 * @summary Rename Brand
 */
export const useRenameBrandV1BrandsBrandIdRenamePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameBrandV1BrandsBrandIdRenamePost>>, TError,RenameBrandV1BrandsBrandIdRenamePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof renameBrandV1BrandsBrandIdRenamePost>>,
        TError,
        RenameBrandV1BrandsBrandIdRenamePostMutationVariables,
        TContext
      > => {
      return useMutation(getRenameBrandV1BrandsBrandIdRenamePostMutationOptions(options), queryClient);
    }

export const getLaunchBrandSweepV1BrandsBrandIdSweepPostUrl = (brandId: string,) => {




  return `/v1/brands/${brandId}/sweep`
}

/**
 * Launch an ad-hoc brand sweep scoped to this brand (planning/41).
 *
 * ``platform`` omitted => fan out one run per platform with an enabled candidate.
 * ``search_term`` present => keyword-level (one candidate; requires an explicit
 * platform). Returns per-platform outcomes; a busy or candidate-less platform is a skip,
 * never a hard failure, so one platform never blocks the others in a fan-out.
 * @summary Launch Brand Sweep
 */
export const launchBrandSweepV1BrandsBrandIdSweepPost = async (brandId: string,
    brandSweepLaunch: BrandSweepLaunch, options?: Parameters<typeof customFetch>[1]): Promise<BrandSweepLaunchResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BrandSweepLaunchResult>(getLaunchBrandSweepV1BrandsBrandIdSweepPostUrl(brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(brandSweepLaunch)
  }
);}





export const getLaunchBrandSweepV1BrandsBrandIdSweepPostMutationKey = () => ['launchBrandSweepV1BrandsBrandIdSweepPost'] as const;

export const getLaunchBrandSweepV1BrandsBrandIdSweepPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchBrandSweepV1BrandsBrandIdSweepPost>>, TError,LaunchBrandSweepV1BrandsBrandIdSweepPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof launchBrandSweepV1BrandsBrandIdSweepPost>>, TError,LaunchBrandSweepV1BrandsBrandIdSweepPostMutationVariables, TContext> => {

const mutationKey = getLaunchBrandSweepV1BrandsBrandIdSweepPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof launchBrandSweepV1BrandsBrandIdSweepPost>>, LaunchBrandSweepV1BrandsBrandIdSweepPostMutationVariables> = (props) => {
          const {brandId,data} = props ?? {};

          return  launchBrandSweepV1BrandsBrandIdSweepPost(brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LaunchBrandSweepV1BrandsBrandIdSweepPostMutationResult = NonNullable<Awaited<ReturnType<typeof launchBrandSweepV1BrandsBrandIdSweepPost>>>
    export type LaunchBrandSweepV1BrandsBrandIdSweepPostMutationBody = BrandSweepLaunch
    export type LaunchBrandSweepV1BrandsBrandIdSweepPostMutationError = HTTPValidationError
    export type LaunchBrandSweepV1BrandsBrandIdSweepPostMutationVariables = {brandId: string;data: BrandSweepLaunch}

    /**
 * @summary Launch Brand Sweep
 */
export const useLaunchBrandSweepV1BrandsBrandIdSweepPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchBrandSweepV1BrandsBrandIdSweepPost>>, TError,LaunchBrandSweepV1BrandsBrandIdSweepPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof launchBrandSweepV1BrandsBrandIdSweepPost>>,
        TError,
        LaunchBrandSweepV1BrandsBrandIdSweepPostMutationVariables,
        TContext
      > => {
      return useMutation(getLaunchBrandSweepV1BrandsBrandIdSweepPostMutationOptions(options), queryClient);
    }

export const getAddCandidateV1BrandsBrandIdCandidatesPostUrl = (brandId: string,) => {




  return `/v1/brands/${brandId}/candidates`
}

/**
 * @summary Add Candidate
 */
export const addCandidateV1BrandsBrandIdCandidatesPost = async (brandId: string,
    brandCandidateCreate: BrandCandidateCreate, options?: Parameters<typeof customFetch>[1]): Promise<BrandCandidateOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BrandCandidateOut>(getAddCandidateV1BrandsBrandIdCandidatesPostUrl(brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(brandCandidateCreate)
  }
);}





export const getAddCandidateV1BrandsBrandIdCandidatesPostMutationKey = () => ['addCandidateV1BrandsBrandIdCandidatesPost'] as const;

export const getAddCandidateV1BrandsBrandIdCandidatesPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCandidateV1BrandsBrandIdCandidatesPost>>, TError,AddCandidateV1BrandsBrandIdCandidatesPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addCandidateV1BrandsBrandIdCandidatesPost>>, TError,AddCandidateV1BrandsBrandIdCandidatesPostMutationVariables, TContext> => {

const mutationKey = getAddCandidateV1BrandsBrandIdCandidatesPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCandidateV1BrandsBrandIdCandidatesPost>>, AddCandidateV1BrandsBrandIdCandidatesPostMutationVariables> = (props) => {
          const {brandId,data} = props ?? {};

          return  addCandidateV1BrandsBrandIdCandidatesPost(brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddCandidateV1BrandsBrandIdCandidatesPostMutationResult = NonNullable<Awaited<ReturnType<typeof addCandidateV1BrandsBrandIdCandidatesPost>>>
    export type AddCandidateV1BrandsBrandIdCandidatesPostMutationBody = BrandCandidateCreate
    export type AddCandidateV1BrandsBrandIdCandidatesPostMutationError = HTTPValidationError
    export type AddCandidateV1BrandsBrandIdCandidatesPostMutationVariables = {brandId: string;data: BrandCandidateCreate}

    /**
 * @summary Add Candidate
 */
export const useAddCandidateV1BrandsBrandIdCandidatesPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCandidateV1BrandsBrandIdCandidatesPost>>, TError,AddCandidateV1BrandsBrandIdCandidatesPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addCandidateV1BrandsBrandIdCandidatesPost>>,
        TError,
        AddCandidateV1BrandsBrandIdCandidatesPostMutationVariables,
        TContext
      > => {
      return useMutation(getAddCandidateV1BrandsBrandIdCandidatesPostMutationOptions(options), queryClient);
    }

export const getUpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatchUrl = (brandId: string,
    candidateId: string,) => {




  return `/v1/brands/${brandId}/candidates/${candidateId}`
}

/**
 * @summary Update Candidate
 */
export const updateCandidateV1BrandsBrandIdCandidatesCandidateIdPatch = async (brandId: string,
    candidateId: string,
    brandCandidateUpdate: BrandCandidateUpdate, options?: Parameters<typeof customFetch>[1]): Promise<BrandCandidateOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BrandCandidateOut>(getUpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatchUrl(brandId,candidateId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(brandCandidateUpdate)
  }
);}





export const getUpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatchMutationKey = () => ['updateCandidateV1BrandsBrandIdCandidatesCandidateIdPatch'] as const;

export const getUpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCandidateV1BrandsBrandIdCandidatesCandidateIdPatch>>, TError,UpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCandidateV1BrandsBrandIdCandidatesCandidateIdPatch>>, TError,UpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatchMutationVariables, TContext> => {

const mutationKey = getUpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCandidateV1BrandsBrandIdCandidatesCandidateIdPatch>>, UpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatchMutationVariables> = (props) => {
          const {brandId,candidateId,data} = props ?? {};

          return  updateCandidateV1BrandsBrandIdCandidatesCandidateIdPatch(brandId,candidateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateCandidateV1BrandsBrandIdCandidatesCandidateIdPatch>>>
    export type UpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatchMutationBody = BrandCandidateUpdate
    export type UpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatchMutationError = HTTPValidationError
    export type UpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatchMutationVariables = {brandId: string;candidateId: string;data: BrandCandidateUpdate}

    /**
 * @summary Update Candidate
 */
export const useUpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCandidateV1BrandsBrandIdCandidatesCandidateIdPatch>>, TError,UpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCandidateV1BrandsBrandIdCandidatesCandidateIdPatch>>,
        TError,
        UpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatchMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCandidateV1BrandsBrandIdCandidatesCandidateIdPatchMutationOptions(options), queryClient);
    }

export const getDeleteCandidateV1BrandsBrandIdCandidatesCandidateIdDeleteUrl = (brandId: string,
    candidateId: string,) => {




  return `/v1/brands/${brandId}/candidates/${candidateId}`
}

/**
 * @summary Delete Candidate
 */
export const deleteCandidateV1BrandsBrandIdCandidatesCandidateIdDelete = async (brandId: string,
    candidateId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteCandidateV1BrandsBrandIdCandidatesCandidateIdDeleteUrl(brandId,candidateId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCandidateV1BrandsBrandIdCandidatesCandidateIdDeleteMutationKey = () => ['deleteCandidateV1BrandsBrandIdCandidatesCandidateIdDelete'] as const;

export const getDeleteCandidateV1BrandsBrandIdCandidatesCandidateIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCandidateV1BrandsBrandIdCandidatesCandidateIdDelete>>, TError,DeleteCandidateV1BrandsBrandIdCandidatesCandidateIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCandidateV1BrandsBrandIdCandidatesCandidateIdDelete>>, TError,DeleteCandidateV1BrandsBrandIdCandidatesCandidateIdDeleteMutationVariables, TContext> => {

const mutationKey = getDeleteCandidateV1BrandsBrandIdCandidatesCandidateIdDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCandidateV1BrandsBrandIdCandidatesCandidateIdDelete>>, DeleteCandidateV1BrandsBrandIdCandidatesCandidateIdDeleteMutationVariables> = (props) => {
          const {brandId,candidateId} = props ?? {};

          return  deleteCandidateV1BrandsBrandIdCandidatesCandidateIdDelete(brandId,candidateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCandidateV1BrandsBrandIdCandidatesCandidateIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCandidateV1BrandsBrandIdCandidatesCandidateIdDelete>>>

    export type DeleteCandidateV1BrandsBrandIdCandidatesCandidateIdDeleteMutationError = HTTPValidationError
    export type DeleteCandidateV1BrandsBrandIdCandidatesCandidateIdDeleteMutationVariables = {brandId: string;candidateId: string}

    /**
 * @summary Delete Candidate
 */
export const useDeleteCandidateV1BrandsBrandIdCandidatesCandidateIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCandidateV1BrandsBrandIdCandidatesCandidateIdDelete>>, TError,DeleteCandidateV1BrandsBrandIdCandidatesCandidateIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCandidateV1BrandsBrandIdCandidatesCandidateIdDelete>>,
        TError,
        DeleteCandidateV1BrandsBrandIdCandidatesCandidateIdDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteCandidateV1BrandsBrandIdCandidatesCandidateIdDeleteMutationOptions(options), queryClient);
    }

export const getSearchProbeV1BrandsSearchProbePostUrl = () => {




  return `/v1/brands/search-probe`
}

/**
 * Live-test a search candidate against the platform's real search API (via proxies).
 * @summary Search Probe
 */
export const searchProbeV1BrandsSearchProbePost = async (searchProbeRequest: SearchProbeRequest, options?: Parameters<typeof customFetch>[1]): Promise<SearchProbeResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SearchProbeResult>(getSearchProbeV1BrandsSearchProbePostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(searchProbeRequest)
  }
);}





export const getSearchProbeV1BrandsSearchProbePostMutationKey = () => ['searchProbeV1BrandsSearchProbePost'] as const;

export const getSearchProbeV1BrandsSearchProbePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchProbeV1BrandsSearchProbePost>>, TError,SearchProbeV1BrandsSearchProbePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof searchProbeV1BrandsSearchProbePost>>, TError,SearchProbeV1BrandsSearchProbePostMutationVariables, TContext> => {

const mutationKey = getSearchProbeV1BrandsSearchProbePostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchProbeV1BrandsSearchProbePost>>, SearchProbeV1BrandsSearchProbePostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  searchProbeV1BrandsSearchProbePost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SearchProbeV1BrandsSearchProbePostMutationResult = NonNullable<Awaited<ReturnType<typeof searchProbeV1BrandsSearchProbePost>>>
    export type SearchProbeV1BrandsSearchProbePostMutationBody = SearchProbeRequest
    export type SearchProbeV1BrandsSearchProbePostMutationError = HTTPValidationError
    export type SearchProbeV1BrandsSearchProbePostMutationVariables = {data: SearchProbeRequest}

    /**
 * @summary Search Probe
 */
export const useSearchProbeV1BrandsSearchProbePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchProbeV1BrandsSearchProbePost>>, TError,SearchProbeV1BrandsSearchProbePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchProbeV1BrandsSearchProbePost>>,
        TError,
        SearchProbeV1BrandsSearchProbePostMutationVariables,
        TContext
      > => {
      return useMutation(getSearchProbeV1BrandsSearchProbePostMutationOptions(options), queryClient);
    }

export const getProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPostUrl = (brandId: string,) => {




  return `/v1/brands/${brandId}/skus/probe-url`
}

/**
 * Live-fetch a pasted PDP URL so the operator can preview the SKU before adding.
 * @summary Probe Sku Url
 */
export const probeSkuUrlV1BrandsBrandIdSkusProbeUrlPost = async (brandId: string,
    skuUrlRequest: SkuUrlRequest, options?: Parameters<typeof customFetch>[1]): Promise<SkuUrlProbeResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SkuUrlProbeResult>(getProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPostUrl(brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(skuUrlRequest)
  }
);}





export const getProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPostMutationKey = () => ['probeSkuUrlV1BrandsBrandIdSkusProbeUrlPost'] as const;

export const getProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof probeSkuUrlV1BrandsBrandIdSkusProbeUrlPost>>, TError,ProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof probeSkuUrlV1BrandsBrandIdSkusProbeUrlPost>>, TError,ProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPostMutationVariables, TContext> => {

const mutationKey = getProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof probeSkuUrlV1BrandsBrandIdSkusProbeUrlPost>>, ProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPostMutationVariables> = (props) => {
          const {brandId,data} = props ?? {};

          return  probeSkuUrlV1BrandsBrandIdSkusProbeUrlPost(brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPostMutationResult = NonNullable<Awaited<ReturnType<typeof probeSkuUrlV1BrandsBrandIdSkusProbeUrlPost>>>
    export type ProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPostMutationBody = SkuUrlRequest
    export type ProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPostMutationError = HTTPValidationError
    export type ProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPostMutationVariables = {brandId: string;data: SkuUrlRequest}

    /**
 * @summary Probe Sku Url
 */
export const useProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof probeSkuUrlV1BrandsBrandIdSkusProbeUrlPost>>, TError,ProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof probeSkuUrlV1BrandsBrandIdSkusProbeUrlPost>>,
        TError,
        ProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPostMutationVariables,
        TContext
      > => {
      return useMutation(getProbeSkuUrlV1BrandsBrandIdSkusProbeUrlPostMutationOptions(options), queryClient);
    }

export const getAddSkuUrlV1BrandsBrandIdSkusAddUrlPostUrl = (brandId: string,) => {




  return `/v1/brands/${brandId}/skus/add-url`
}

/**
 * Fetch a pasted PDP URL and fold it into this brand's SKU dimension (single row).
 *
 * Unlike a sweep, this adds exactly the one product and never removes others; the
 * canonical brand comes from the page (not the PDP), while the PDP's own brand string
 * is kept as ``display_brand``. Idempotent: re-adding an active SKU just refreshes it.
 *
 * Takes the rename lock, but only AFTER the live PDP fetch (see below): this is another
 * writer of ``{p}_skus.brand``, so without it a concurrent rename could sweep past
 * between reading the canonical name and inserting it, leaving the row stamped with a
 * name no brand owns - reported as added, then invisible everywhere.
 * @summary Add Sku Url
 */
export const addSkuUrlV1BrandsBrandIdSkusAddUrlPost = async (brandId: string,
    skuUrlRequest: SkuUrlRequest, options?: Parameters<typeof customFetch>[1]): Promise<SkuAddResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SkuAddResult>(getAddSkuUrlV1BrandsBrandIdSkusAddUrlPostUrl(brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(skuUrlRequest)
  }
);}





export const getAddSkuUrlV1BrandsBrandIdSkusAddUrlPostMutationKey = () => ['addSkuUrlV1BrandsBrandIdSkusAddUrlPost'] as const;

export const getAddSkuUrlV1BrandsBrandIdSkusAddUrlPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addSkuUrlV1BrandsBrandIdSkusAddUrlPost>>, TError,AddSkuUrlV1BrandsBrandIdSkusAddUrlPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addSkuUrlV1BrandsBrandIdSkusAddUrlPost>>, TError,AddSkuUrlV1BrandsBrandIdSkusAddUrlPostMutationVariables, TContext> => {

const mutationKey = getAddSkuUrlV1BrandsBrandIdSkusAddUrlPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addSkuUrlV1BrandsBrandIdSkusAddUrlPost>>, AddSkuUrlV1BrandsBrandIdSkusAddUrlPostMutationVariables> = (props) => {
          const {brandId,data} = props ?? {};

          return  addSkuUrlV1BrandsBrandIdSkusAddUrlPost(brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddSkuUrlV1BrandsBrandIdSkusAddUrlPostMutationResult = NonNullable<Awaited<ReturnType<typeof addSkuUrlV1BrandsBrandIdSkusAddUrlPost>>>
    export type AddSkuUrlV1BrandsBrandIdSkusAddUrlPostMutationBody = SkuUrlRequest
    export type AddSkuUrlV1BrandsBrandIdSkusAddUrlPostMutationError = HTTPValidationError
    export type AddSkuUrlV1BrandsBrandIdSkusAddUrlPostMutationVariables = {brandId: string;data: SkuUrlRequest}

    /**
 * @summary Add Sku Url
 */
export const useAddSkuUrlV1BrandsBrandIdSkusAddUrlPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addSkuUrlV1BrandsBrandIdSkusAddUrlPost>>, TError,AddSkuUrlV1BrandsBrandIdSkusAddUrlPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addSkuUrlV1BrandsBrandIdSkusAddUrlPost>>,
        TError,
        AddSkuUrlV1BrandsBrandIdSkusAddUrlPostMutationVariables,
        TContext
      > => {
      return useMutation(getAddSkuUrlV1BrandsBrandIdSkusAddUrlPostMutationOptions(options), queryClient);
    }

export const getRemoveSkuV1BrandsBrandIdSkusRemovePostUrl = (brandId: string,) => {




  return `/v1/brands/${brandId}/skus/remove`
}

/**
 * Suppress a false-positive SKU: flip it to a sticky ``excluded`` status.
 *
 * Unlike a sweep's ``removed``, ``excluded`` is never resurrected when search
 * rediscovers the SKU, so a product wrongly attributed to this brand stays gone. A
 * later manual add (paste its URL) re-activates it if the call was a mistake.
 *
 * Under the rename lock: ``exclude_sku`` re-emits the whole dimension row, ``brand``
 * column included, as a dominating ReplacingMergeTree version. Racing a rename, it
 * would resurrect the old label for this SKU and quietly drop it out of the brand.
 * @summary Remove Sku
 */
export const removeSkuV1BrandsBrandIdSkusRemovePost = async (brandId: string,
    skuRemoveRequest: SkuRemoveRequest, options?: Parameters<typeof customFetch>[1]): Promise<SkuRemoveResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SkuRemoveResult>(getRemoveSkuV1BrandsBrandIdSkusRemovePostUrl(brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(skuRemoveRequest)
  }
);}





export const getRemoveSkuV1BrandsBrandIdSkusRemovePostMutationKey = () => ['removeSkuV1BrandsBrandIdSkusRemovePost'] as const;

export const getRemoveSkuV1BrandsBrandIdSkusRemovePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeSkuV1BrandsBrandIdSkusRemovePost>>, TError,RemoveSkuV1BrandsBrandIdSkusRemovePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeSkuV1BrandsBrandIdSkusRemovePost>>, TError,RemoveSkuV1BrandsBrandIdSkusRemovePostMutationVariables, TContext> => {

const mutationKey = getRemoveSkuV1BrandsBrandIdSkusRemovePostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeSkuV1BrandsBrandIdSkusRemovePost>>, RemoveSkuV1BrandsBrandIdSkusRemovePostMutationVariables> = (props) => {
          const {brandId,data} = props ?? {};

          return  removeSkuV1BrandsBrandIdSkusRemovePost(brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveSkuV1BrandsBrandIdSkusRemovePostMutationResult = NonNullable<Awaited<ReturnType<typeof removeSkuV1BrandsBrandIdSkusRemovePost>>>
    export type RemoveSkuV1BrandsBrandIdSkusRemovePostMutationBody = SkuRemoveRequest
    export type RemoveSkuV1BrandsBrandIdSkusRemovePostMutationError = HTTPValidationError
    export type RemoveSkuV1BrandsBrandIdSkusRemovePostMutationVariables = {brandId: string;data: SkuRemoveRequest}

    /**
 * @summary Remove Sku
 */
export const useRemoveSkuV1BrandsBrandIdSkusRemovePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeSkuV1BrandsBrandIdSkusRemovePost>>, TError,RemoveSkuV1BrandsBrandIdSkusRemovePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeSkuV1BrandsBrandIdSkusRemovePost>>,
        TError,
        RemoveSkuV1BrandsBrandIdSkusRemovePostMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveSkuV1BrandsBrandIdSkusRemovePostMutationOptions(options), queryClient);
    }

export const getSetSkuEnabledV1BrandsBrandIdSkusSetEnabledPostUrl = (brandId: string,) => {




  return `/v1/brands/${brandId}/skus/set-enabled`
}

/**
 * Enable/disable SKUs for a brand (planning/47): the single master scrape toggle.
 *
 * A disabled SKU is skipped by BOTH the cart-inventory and store-sku-map scrapes. Reversible
 * (flip it back on); distinct from the terminal ``excluded`` status behind ``skus/remove``.
 * @summary Set Sku Enabled
 */
export const setSkuEnabledV1BrandsBrandIdSkusSetEnabledPost = async (brandId: string,
    skuSetEnabled: SkuSetEnabled, options?: Parameters<typeof customFetch>[1]): Promise<SkuOverrideResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SkuOverrideResult>(getSetSkuEnabledV1BrandsBrandIdSkusSetEnabledPostUrl(brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(skuSetEnabled)
  }
);}





export const getSetSkuEnabledV1BrandsBrandIdSkusSetEnabledPostMutationKey = () => ['setSkuEnabledV1BrandsBrandIdSkusSetEnabledPost'] as const;

export const getSetSkuEnabledV1BrandsBrandIdSkusSetEnabledPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSkuEnabledV1BrandsBrandIdSkusSetEnabledPost>>, TError,SetSkuEnabledV1BrandsBrandIdSkusSetEnabledPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setSkuEnabledV1BrandsBrandIdSkusSetEnabledPost>>, TError,SetSkuEnabledV1BrandsBrandIdSkusSetEnabledPostMutationVariables, TContext> => {

const mutationKey = getSetSkuEnabledV1BrandsBrandIdSkusSetEnabledPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSkuEnabledV1BrandsBrandIdSkusSetEnabledPost>>, SetSkuEnabledV1BrandsBrandIdSkusSetEnabledPostMutationVariables> = (props) => {
          const {brandId,data} = props ?? {};

          return  setSkuEnabledV1BrandsBrandIdSkusSetEnabledPost(brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSkuEnabledV1BrandsBrandIdSkusSetEnabledPostMutationResult = NonNullable<Awaited<ReturnType<typeof setSkuEnabledV1BrandsBrandIdSkusSetEnabledPost>>>
    export type SetSkuEnabledV1BrandsBrandIdSkusSetEnabledPostMutationBody = SkuSetEnabled
    export type SetSkuEnabledV1BrandsBrandIdSkusSetEnabledPostMutationError = HTTPValidationError
    export type SetSkuEnabledV1BrandsBrandIdSkusSetEnabledPostMutationVariables = {brandId: string;data: SkuSetEnabled}

    /**
 * @summary Set Sku Enabled
 */
export const useSetSkuEnabledV1BrandsBrandIdSkusSetEnabledPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSkuEnabledV1BrandsBrandIdSkusSetEnabledPost>>, TError,SetSkuEnabledV1BrandsBrandIdSkusSetEnabledPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSkuEnabledV1BrandsBrandIdSkusSetEnabledPost>>,
        TError,
        SetSkuEnabledV1BrandsBrandIdSkusSetEnabledPostMutationVariables,
        TContext
      > => {
      return useMutation(getSetSkuEnabledV1BrandsBrandIdSkusSetEnabledPostMutationOptions(options), queryClient);
    }

export const getSetSkuBundleV1BrandsBrandIdSkusSetBundlePostUrl = (brandId: string,) => {




  return `/v1/brands/${brandId}/skus/set-bundle`
}

/**
 * Manually override a SKU's bundle flag (planning/47).
 *
 * ``is_bundle`` true = force bundle (excluded from probing like a scraped multipack), false =
 * force NOT-bundle, null = clear the override. A true/false is authoritative in Postgres AND
 * written to ClickHouse (dominating version) so ``active_skus`` reflects it immediately, with
 * brand-sweep compaction re-applying it so a later re-derivation cannot reset it. Clearing
 * (null) only removes the Postgres override -- the CH ``is_bundle`` column keeps its last value
 * until the next brand sweep re-derives it from scraped data (compaction no longer sees an
 * override), because the true scraped value is not known at clear time.
 *
 * Marking a SKU as a bundle (``is_bundle=true``) also **untracks** it (``enabled=false``) in
 * the same upsert, matching how combos are registered by the brand sweep: the combo gate and
 * the track toggle should never disagree. false/null leave ``enabled`` untouched -- unmarking
 * a combo does not silently re-enable scraping.
 *
 * Under the rename lock: the ClickHouse sync below re-emits the whole dimension row,
 * ``brand`` column included, as a dominating version. Racing a rename, it would
 * resurrect the old label for this SKU and quietly drop it out of the brand.
 * @summary Set Sku Bundle
 */
export const setSkuBundleV1BrandsBrandIdSkusSetBundlePost = async (brandId: string,
    skuSetBundle: SkuSetBundle, options?: Parameters<typeof customFetch>[1]): Promise<SkuOverrideResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SkuOverrideResult>(getSetSkuBundleV1BrandsBrandIdSkusSetBundlePostUrl(brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(skuSetBundle)
  }
);}





export const getSetSkuBundleV1BrandsBrandIdSkusSetBundlePostMutationKey = () => ['setSkuBundleV1BrandsBrandIdSkusSetBundlePost'] as const;

export const getSetSkuBundleV1BrandsBrandIdSkusSetBundlePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSkuBundleV1BrandsBrandIdSkusSetBundlePost>>, TError,SetSkuBundleV1BrandsBrandIdSkusSetBundlePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setSkuBundleV1BrandsBrandIdSkusSetBundlePost>>, TError,SetSkuBundleV1BrandsBrandIdSkusSetBundlePostMutationVariables, TContext> => {

const mutationKey = getSetSkuBundleV1BrandsBrandIdSkusSetBundlePostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSkuBundleV1BrandsBrandIdSkusSetBundlePost>>, SetSkuBundleV1BrandsBrandIdSkusSetBundlePostMutationVariables> = (props) => {
          const {brandId,data} = props ?? {};

          return  setSkuBundleV1BrandsBrandIdSkusSetBundlePost(brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSkuBundleV1BrandsBrandIdSkusSetBundlePostMutationResult = NonNullable<Awaited<ReturnType<typeof setSkuBundleV1BrandsBrandIdSkusSetBundlePost>>>
    export type SetSkuBundleV1BrandsBrandIdSkusSetBundlePostMutationBody = SkuSetBundle
    export type SetSkuBundleV1BrandsBrandIdSkusSetBundlePostMutationError = HTTPValidationError
    export type SetSkuBundleV1BrandsBrandIdSkusSetBundlePostMutationVariables = {brandId: string;data: SkuSetBundle}

    /**
 * @summary Set Sku Bundle
 */
export const useSetSkuBundleV1BrandsBrandIdSkusSetBundlePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSkuBundleV1BrandsBrandIdSkusSetBundlePost>>, TError,SetSkuBundleV1BrandsBrandIdSkusSetBundlePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSkuBundleV1BrandsBrandIdSkusSetBundlePost>>,
        TError,
        SetSkuBundleV1BrandsBrandIdSkusSetBundlePostMutationVariables,
        TContext
      > => {
      return useMutation(getSetSkuBundleV1BrandsBrandIdSkusSetBundlePostMutationOptions(options), queryClient);
    }

export const getBulkUploadV1BrandsBulkUploadPostUrl = () => {




  return `/v1/brands/bulk/upload`
}

/**
 * Parse + structurally validate a CSV, stage it, return rows + per-line errors.
 *
 * No brand writes happen here; staging only. The operator then verifies, then commits.
 * @summary Bulk Upload
 */
export const bulkUploadV1BrandsBulkUploadPost = async (bodyBulkUploadV1BrandsBulkUploadPost: BodyBulkUploadV1BrandsBulkUploadPost, options?: Parameters<typeof customFetch>[1]): Promise<BulkUploadOut> => {
    const formData = new FormData();
formData.append(`file`, bodyBulkUploadV1BrandsBulkUploadPost.file);

  return customFetch<BulkUploadOut>(getBulkUploadV1BrandsBulkUploadPostUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getBulkUploadV1BrandsBulkUploadPostMutationKey = () => ['bulkUploadV1BrandsBulkUploadPost'] as const;

export const getBulkUploadV1BrandsBulkUploadPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUploadV1BrandsBulkUploadPost>>, TError,BulkUploadV1BrandsBulkUploadPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkUploadV1BrandsBulkUploadPost>>, TError,BulkUploadV1BrandsBulkUploadPostMutationVariables, TContext> => {

const mutationKey = getBulkUploadV1BrandsBulkUploadPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkUploadV1BrandsBulkUploadPost>>, BulkUploadV1BrandsBulkUploadPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  bulkUploadV1BrandsBulkUploadPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkUploadV1BrandsBulkUploadPostMutationResult = NonNullable<Awaited<ReturnType<typeof bulkUploadV1BrandsBulkUploadPost>>>
    export type BulkUploadV1BrandsBulkUploadPostMutationBody = BodyBulkUploadV1BrandsBulkUploadPost
    export type BulkUploadV1BrandsBulkUploadPostMutationError = HTTPValidationError
    export type BulkUploadV1BrandsBulkUploadPostMutationVariables = {data: BodyBulkUploadV1BrandsBulkUploadPost}

    /**
 * @summary Bulk Upload
 */
export const useBulkUploadV1BrandsBulkUploadPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkUploadV1BrandsBulkUploadPost>>, TError,BulkUploadV1BrandsBulkUploadPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkUploadV1BrandsBulkUploadPost>>,
        TError,
        BulkUploadV1BrandsBulkUploadPostMutationVariables,
        TContext
      > => {
      return useMutation(getBulkUploadV1BrandsBulkUploadPostMutationOptions(options), queryClient);
    }

export const getBulkVerifyV1BrandsBulkUploadIdVerifyPostUrl = (uploadId: string,) => {




  return `/v1/brands/bulk/${uploadId}/verify`
}

/**
 * Kick off background verification of every staged candidate; returns immediately.
 * @summary Bulk Verify
 */
export const bulkVerifyV1BrandsBulkUploadIdVerifyPost = async (uploadId: string, options?: Parameters<typeof customFetch>[1]): Promise<BulkUploadOut> => {

  return customFetch<BulkUploadOut>(getBulkVerifyV1BrandsBulkUploadIdVerifyPostUrl(uploadId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getBulkVerifyV1BrandsBulkUploadIdVerifyPostMutationKey = () => ['bulkVerifyV1BrandsBulkUploadIdVerifyPost'] as const;

export const getBulkVerifyV1BrandsBulkUploadIdVerifyPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkVerifyV1BrandsBulkUploadIdVerifyPost>>, TError,BulkVerifyV1BrandsBulkUploadIdVerifyPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkVerifyV1BrandsBulkUploadIdVerifyPost>>, TError,BulkVerifyV1BrandsBulkUploadIdVerifyPostMutationVariables, TContext> => {

const mutationKey = getBulkVerifyV1BrandsBulkUploadIdVerifyPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkVerifyV1BrandsBulkUploadIdVerifyPost>>, BulkVerifyV1BrandsBulkUploadIdVerifyPostMutationVariables> = (props) => {
          const {uploadId} = props ?? {};

          return  bulkVerifyV1BrandsBulkUploadIdVerifyPost(uploadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkVerifyV1BrandsBulkUploadIdVerifyPostMutationResult = NonNullable<Awaited<ReturnType<typeof bulkVerifyV1BrandsBulkUploadIdVerifyPost>>>

    export type BulkVerifyV1BrandsBulkUploadIdVerifyPostMutationError = HTTPValidationError
    export type BulkVerifyV1BrandsBulkUploadIdVerifyPostMutationVariables = {uploadId: string}

    /**
 * @summary Bulk Verify
 */
export const useBulkVerifyV1BrandsBulkUploadIdVerifyPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkVerifyV1BrandsBulkUploadIdVerifyPost>>, TError,BulkVerifyV1BrandsBulkUploadIdVerifyPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkVerifyV1BrandsBulkUploadIdVerifyPost>>,
        TError,
        BulkVerifyV1BrandsBulkUploadIdVerifyPostMutationVariables,
        TContext
      > => {
      return useMutation(getBulkVerifyV1BrandsBulkUploadIdVerifyPostMutationOptions(options), queryClient);
    }

export const getBulkStatusV1BrandsBulkUploadIdGetUrl = (uploadId: string,) => {




  return `/v1/brands/bulk/${uploadId}`
}

/**
 * Poll an upload's status + progress + per-row verdicts.
 * @summary Bulk Status
 */
export const bulkStatusV1BrandsBulkUploadIdGet = async (uploadId: string, options?: Parameters<typeof customFetch>[1]): Promise<BulkUploadOut> => {

  return customFetch<BulkUploadOut>(getBulkStatusV1BrandsBulkUploadIdGetUrl(uploadId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBulkStatusV1BrandsBulkUploadIdGetQueryKey = (uploadId: string,) => {
    return [
    `/v1/brands/bulk/${uploadId}`
    ] as const;
    }


export const getBulkStatusV1BrandsBulkUploadIdGetQueryOptions = <TData = Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>, TError = HTTPValidationError>(uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBulkStatusV1BrandsBulkUploadIdGetQueryKey(uploadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>> = ({ signal }) => bulkStatusV1BrandsBulkUploadIdGet(uploadId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uploadId !== null && uploadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BulkStatusV1BrandsBulkUploadIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>>
export type BulkStatusV1BrandsBulkUploadIdGetQueryError = HTTPValidationError


export function useBulkStatusV1BrandsBulkUploadIdGet<TData = Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>, TError = HTTPValidationError>(
 uploadId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>,
          TError,
          Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBulkStatusV1BrandsBulkUploadIdGet<TData = Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>, TError = HTTPValidationError>(
 uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>,
          TError,
          Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBulkStatusV1BrandsBulkUploadIdGet<TData = Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>, TError = HTTPValidationError>(
 uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Bulk Status
 */

export function useBulkStatusV1BrandsBulkUploadIdGet<TData = Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>, TError = HTTPValidationError>(
 uploadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof bulkStatusV1BrandsBulkUploadIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBulkStatusV1BrandsBulkUploadIdGetQueryOptions(uploadId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getBulkCommitV1BrandsBulkUploadIdCommitPostUrl = (uploadId: string,) => {




  return `/v1/brands/bulk/${uploadId}/commit`
}

/**
 * Register verified candidates (+ optionally not-found ones, disabled).
 * @summary Bulk Commit
 */
export const bulkCommitV1BrandsBulkUploadIdCommitPost = async (uploadId: string,
    bulkCommitRequest: BulkCommitRequest, options?: Parameters<typeof customFetch>[1]): Promise<BulkCommitResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BulkCommitResult>(getBulkCommitV1BrandsBulkUploadIdCommitPostUrl(uploadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkCommitRequest)
  }
);}





export const getBulkCommitV1BrandsBulkUploadIdCommitPostMutationKey = () => ['bulkCommitV1BrandsBulkUploadIdCommitPost'] as const;

export const getBulkCommitV1BrandsBulkUploadIdCommitPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCommitV1BrandsBulkUploadIdCommitPost>>, TError,BulkCommitV1BrandsBulkUploadIdCommitPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkCommitV1BrandsBulkUploadIdCommitPost>>, TError,BulkCommitV1BrandsBulkUploadIdCommitPostMutationVariables, TContext> => {

const mutationKey = getBulkCommitV1BrandsBulkUploadIdCommitPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkCommitV1BrandsBulkUploadIdCommitPost>>, BulkCommitV1BrandsBulkUploadIdCommitPostMutationVariables> = (props) => {
          const {uploadId,data} = props ?? {};

          return  bulkCommitV1BrandsBulkUploadIdCommitPost(uploadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkCommitV1BrandsBulkUploadIdCommitPostMutationResult = NonNullable<Awaited<ReturnType<typeof bulkCommitV1BrandsBulkUploadIdCommitPost>>>
    export type BulkCommitV1BrandsBulkUploadIdCommitPostMutationBody = BulkCommitRequest
    export type BulkCommitV1BrandsBulkUploadIdCommitPostMutationError = HTTPValidationError
    export type BulkCommitV1BrandsBulkUploadIdCommitPostMutationVariables = {uploadId: string;data: BulkCommitRequest}

    /**
 * @summary Bulk Commit
 */
export const useBulkCommitV1BrandsBulkUploadIdCommitPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCommitV1BrandsBulkUploadIdCommitPost>>, TError,BulkCommitV1BrandsBulkUploadIdCommitPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkCommitV1BrandsBulkUploadIdCommitPost>>,
        TError,
        BulkCommitV1BrandsBulkUploadIdCommitPostMutationVariables,
        TContext
      > => {
      return useMutation(getBulkCommitV1BrandsBulkUploadIdCommitPostMutationOptions(options), queryClient);
    }

export const getLowConfidenceCountsV1BrandsMatchesLowConfidenceGetUrl = () => {




  return `/v1/brands/matches/low-confidence`
}

/**
 * ``brand name -> groups whose weakest member is below the review bar``.
 *
 * Declared before ``/{brand_id}/...`` so "matches" is never parsed as a brand uuid.
 * Every brand in one query, because the caller is the brand LIST: asking per row would
 * be 130 round trips to render one column.
 * @summary Low Confidence Counts
 */
export const lowConfidenceCountsV1BrandsMatchesLowConfidenceGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<LowConfidenceCountsV1BrandsMatchesLowConfidenceGet200> => {

  return customFetch<LowConfidenceCountsV1BrandsMatchesLowConfidenceGet200>(getLowConfidenceCountsV1BrandsMatchesLowConfidenceGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLowConfidenceCountsV1BrandsMatchesLowConfidenceGetQueryKey = () => {
    return [
    `/v1/brands/matches/low-confidence`
    ] as const;
    }


export const getLowConfidenceCountsV1BrandsMatchesLowConfidenceGetQueryOptions = <TData = Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLowConfidenceCountsV1BrandsMatchesLowConfidenceGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>> = ({ signal }) => lowConfidenceCountsV1BrandsMatchesLowConfidenceGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LowConfidenceCountsV1BrandsMatchesLowConfidenceGetQueryResult = NonNullable<Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>>
export type LowConfidenceCountsV1BrandsMatchesLowConfidenceGetQueryError = unknown


export function useLowConfidenceCountsV1BrandsMatchesLowConfidenceGet<TData = Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>,
          TError,
          Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLowConfidenceCountsV1BrandsMatchesLowConfidenceGet<TData = Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>,
          TError,
          Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLowConfidenceCountsV1BrandsMatchesLowConfidenceGet<TData = Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Low Confidence Counts
 */

export function useLowConfidenceCountsV1BrandsMatchesLowConfidenceGet<TData = Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lowConfidenceCountsV1BrandsMatchesLowConfidenceGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLowConfidenceCountsV1BrandsMatchesLowConfidenceGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListMatchesV1BrandsBrandIdMatchesGetUrl = (brandId: string,) => {




  return `/v1/brands/${brandId}/matches`
}

/**
 * The brand's SKU grid: one row per matched product, plus the unmatched listings.
 *
 * Unmatched listings are returned as single-member rows rather than filtered out. They
 * are the working set for an operator -- a listing is only fixable if it is on screen --
 * and hiding them would make a brand look fully matched when it is not.
 * @summary List Matches
 */
export const listMatchesV1BrandsBrandIdMatchesGet = async (brandId: string, options?: Parameters<typeof customFetch>[1]): Promise<BrandMatches> => {

  return customFetch<BrandMatches>(getListMatchesV1BrandsBrandIdMatchesGetUrl(brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMatchesV1BrandsBrandIdMatchesGetQueryKey = (brandId: string,) => {
    return [
    `/v1/brands/${brandId}/matches`
    ] as const;
    }


export const getListMatchesV1BrandsBrandIdMatchesGetQueryOptions = <TData = Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>, TError = HTTPValidationError>(brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMatchesV1BrandsBrandIdMatchesGetQueryKey(brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>> = ({ signal }) => listMatchesV1BrandsBrandIdMatchesGet(brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMatchesV1BrandsBrandIdMatchesGetQueryResult = NonNullable<Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>>
export type ListMatchesV1BrandsBrandIdMatchesGetQueryError = HTTPValidationError


export function useListMatchesV1BrandsBrandIdMatchesGet<TData = Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>, TError = HTTPValidationError>(
 brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>,
          TError,
          Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMatchesV1BrandsBrandIdMatchesGet<TData = Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>, TError = HTTPValidationError>(
 brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>,
          TError,
          Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMatchesV1BrandsBrandIdMatchesGet<TData = Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>, TError = HTTPValidationError>(
 brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Matches
 */

export function useListMatchesV1BrandsBrandIdMatchesGet<TData = Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>, TError = HTTPValidationError>(
 brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchesV1BrandsBrandIdMatchesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMatchesV1BrandsBrandIdMatchesGetQueryOptions(brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMoveListingsV1BrandsBrandIdMatchesMovePostUrl = (brandId: string,) => {




  return `/v1/brands/${brandId}/matches/move`
}

/**
 * Point listings at a match group, creating one when ``target`` is null.
 *
 * Guards the brand boundary in both directions: the listings must belong to this brand,
 * and so must the target. Without the second check a move could stitch two brands into
 * one identity, which nothing downstream would flag.
 * @summary Move Listings
 */
export const moveListingsV1BrandsBrandIdMatchesMovePost = async (brandId: string,
    matchMoveRequest: MatchMoveRequest, options?: Parameters<typeof customFetch>[1]): Promise<MatchMoveResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<MatchMoveResult>(getMoveListingsV1BrandsBrandIdMatchesMovePostUrl(brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(matchMoveRequest)
  }
);}





export const getMoveListingsV1BrandsBrandIdMatchesMovePostMutationKey = () => ['moveListingsV1BrandsBrandIdMatchesMovePost'] as const;

export const getMoveListingsV1BrandsBrandIdMatchesMovePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveListingsV1BrandsBrandIdMatchesMovePost>>, TError,MoveListingsV1BrandsBrandIdMatchesMovePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof moveListingsV1BrandsBrandIdMatchesMovePost>>, TError,MoveListingsV1BrandsBrandIdMatchesMovePostMutationVariables, TContext> => {

const mutationKey = getMoveListingsV1BrandsBrandIdMatchesMovePostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveListingsV1BrandsBrandIdMatchesMovePost>>, MoveListingsV1BrandsBrandIdMatchesMovePostMutationVariables> = (props) => {
          const {brandId,data} = props ?? {};

          return  moveListingsV1BrandsBrandIdMatchesMovePost(brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveListingsV1BrandsBrandIdMatchesMovePostMutationResult = NonNullable<Awaited<ReturnType<typeof moveListingsV1BrandsBrandIdMatchesMovePost>>>
    export type MoveListingsV1BrandsBrandIdMatchesMovePostMutationBody = MatchMoveRequest
    export type MoveListingsV1BrandsBrandIdMatchesMovePostMutationError = HTTPValidationError
    export type MoveListingsV1BrandsBrandIdMatchesMovePostMutationVariables = {brandId: string;data: MatchMoveRequest}

    /**
 * @summary Move Listings
 */
export const useMoveListingsV1BrandsBrandIdMatchesMovePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveListingsV1BrandsBrandIdMatchesMovePost>>, TError,MoveListingsV1BrandsBrandIdMatchesMovePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof moveListingsV1BrandsBrandIdMatchesMovePost>>,
        TError,
        MoveListingsV1BrandsBrandIdMatchesMovePostMutationVariables,
        TContext
      > => {
      return useMutation(getMoveListingsV1BrandsBrandIdMatchesMovePostMutationOptions(options), queryClient);
    }

export const getRenameMatchV1BrandsBrandIdMatchesMatchIdRenamePostUrl = (brandId: string,
    matchId: string,) => {




  return `/v1/brands/${brandId}/matches/${matchId}/rename`
}

/**
 * Set a match's display name. Identity is the member set, so nothing re-points.
 * @summary Rename Match
 */
export const renameMatchV1BrandsBrandIdMatchesMatchIdRenamePost = async (brandId: string,
    matchId: string,
    matchRenameRequest: MatchRenameRequest, options?: Parameters<typeof customFetch>[1]): Promise<MatchRow> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<MatchRow>(getRenameMatchV1BrandsBrandIdMatchesMatchIdRenamePostUrl(brandId,matchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(matchRenameRequest)
  }
);}





export const getRenameMatchV1BrandsBrandIdMatchesMatchIdRenamePostMutationKey = () => ['renameMatchV1BrandsBrandIdMatchesMatchIdRenamePost'] as const;

export const getRenameMatchV1BrandsBrandIdMatchesMatchIdRenamePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameMatchV1BrandsBrandIdMatchesMatchIdRenamePost>>, TError,RenameMatchV1BrandsBrandIdMatchesMatchIdRenamePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof renameMatchV1BrandsBrandIdMatchesMatchIdRenamePost>>, TError,RenameMatchV1BrandsBrandIdMatchesMatchIdRenamePostMutationVariables, TContext> => {

const mutationKey = getRenameMatchV1BrandsBrandIdMatchesMatchIdRenamePostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renameMatchV1BrandsBrandIdMatchesMatchIdRenamePost>>, RenameMatchV1BrandsBrandIdMatchesMatchIdRenamePostMutationVariables> = (props) => {
          const {brandId,matchId,data} = props ?? {};

          return  renameMatchV1BrandsBrandIdMatchesMatchIdRenamePost(brandId,matchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenameMatchV1BrandsBrandIdMatchesMatchIdRenamePostMutationResult = NonNullable<Awaited<ReturnType<typeof renameMatchV1BrandsBrandIdMatchesMatchIdRenamePost>>>
    export type RenameMatchV1BrandsBrandIdMatchesMatchIdRenamePostMutationBody = MatchRenameRequest
    export type RenameMatchV1BrandsBrandIdMatchesMatchIdRenamePostMutationError = HTTPValidationError
    export type RenameMatchV1BrandsBrandIdMatchesMatchIdRenamePostMutationVariables = {brandId: string;matchId: string;data: MatchRenameRequest}

    /**
 * @summary Rename Match
 */
export const useRenameMatchV1BrandsBrandIdMatchesMatchIdRenamePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameMatchV1BrandsBrandIdMatchesMatchIdRenamePost>>, TError,RenameMatchV1BrandsBrandIdMatchesMatchIdRenamePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof renameMatchV1BrandsBrandIdMatchesMatchIdRenamePost>>,
        TError,
        RenameMatchV1BrandsBrandIdMatchesMatchIdRenamePostMutationVariables,
        TContext
      > => {
      return useMutation(getRenameMatchV1BrandsBrandIdMatchesMatchIdRenamePostMutationOptions(options), queryClient);
    }

export const getApproveMatchV1BrandsBrandIdMatchesMatchIdApprovePostUrl = (brandId: string,
    matchId: string,) => {




  return `/v1/brands/${brandId}/matches/${matchId}/approve`
}

/**
 * Confirm a grouping the model was unsure about.
 *
 * Approval is a MOVE of every member onto the match it is already in. That sounds like a
 * no-op and is the whole point: the move writes each membership row at the override
 * version with confidence 1.0, which does two things at once. The group leaves the
 * low-confidence queue because its weakest link is now a human, and the next matcher run
 * reads those rows back as pins and reproduces the grouping instead of re-deriving it.
 *
 * So there is no separate "approved" flag to keep in step with anything -- the existing
 * override mechanism already means exactly "a person decided this".
 * @summary Approve Match
 */
export const approveMatchV1BrandsBrandIdMatchesMatchIdApprovePost = async (brandId: string,
    matchId: string, options?: Parameters<typeof customFetch>[1]): Promise<MatchRow> => {

  return customFetch<MatchRow>(getApproveMatchV1BrandsBrandIdMatchesMatchIdApprovePostUrl(brandId,matchId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getApproveMatchV1BrandsBrandIdMatchesMatchIdApprovePostMutationKey = () => ['approveMatchV1BrandsBrandIdMatchesMatchIdApprovePost'] as const;

export const getApproveMatchV1BrandsBrandIdMatchesMatchIdApprovePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveMatchV1BrandsBrandIdMatchesMatchIdApprovePost>>, TError,ApproveMatchV1BrandsBrandIdMatchesMatchIdApprovePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveMatchV1BrandsBrandIdMatchesMatchIdApprovePost>>, TError,ApproveMatchV1BrandsBrandIdMatchesMatchIdApprovePostMutationVariables, TContext> => {

const mutationKey = getApproveMatchV1BrandsBrandIdMatchesMatchIdApprovePostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveMatchV1BrandsBrandIdMatchesMatchIdApprovePost>>, ApproveMatchV1BrandsBrandIdMatchesMatchIdApprovePostMutationVariables> = (props) => {
          const {brandId,matchId} = props ?? {};

          return  approveMatchV1BrandsBrandIdMatchesMatchIdApprovePost(brandId,matchId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveMatchV1BrandsBrandIdMatchesMatchIdApprovePostMutationResult = NonNullable<Awaited<ReturnType<typeof approveMatchV1BrandsBrandIdMatchesMatchIdApprovePost>>>

    export type ApproveMatchV1BrandsBrandIdMatchesMatchIdApprovePostMutationError = HTTPValidationError
    export type ApproveMatchV1BrandsBrandIdMatchesMatchIdApprovePostMutationVariables = {brandId: string;matchId: string}

    /**
 * @summary Approve Match
 */
export const useApproveMatchV1BrandsBrandIdMatchesMatchIdApprovePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveMatchV1BrandsBrandIdMatchesMatchIdApprovePost>>, TError,ApproveMatchV1BrandsBrandIdMatchesMatchIdApprovePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveMatchV1BrandsBrandIdMatchesMatchIdApprovePost>>,
        TError,
        ApproveMatchV1BrandsBrandIdMatchesMatchIdApprovePostMutationVariables,
        TContext
      > => {
      return useMutation(getApproveMatchV1BrandsBrandIdMatchesMatchIdApprovePostMutationOptions(options), queryClient);
    }

export const getSetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostUrl = (brandId: string,
    matchId: string,
    params: SetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/brands/${brandId}/matches/${matchId}/tracked?${stringifiedParams}` : `/v1/brands/${brandId}/matches/${matchId}/tracked`
}

/**
 * Track or untrack a whole matched product.
 *
 * Two writes, and the second is the one that changes behaviour. The group flag is what
 * the grid renders; the PER-SKU override is what a run reads -- cart inventory and
 * store-SKU map both subtract ``sku_overrides.enabled = false`` when they resolve their
 * universe (dispatch/sku_scope.py ``selected_skus``). Pushing it down means no
 * scrape resolver has to learn about matched products at all.
 *
 * Deliberately a veto, not a licence: untracking removes members from scrapes, but a SKU
 * that belongs to no group is untouched. Most listings are single-platform and have no
 * group, so requiring one would silently drop them from every run. Nor does either
 * direction overrule a decision made about one listing on the SKUs page -- see
 * :func:`_push_tracked_to_skus` for who owns which row.
 * @summary Set Match Tracked
 */
export const setMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPost = async (brandId: string,
    matchId: string,
    params: SetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostParams, options?: Parameters<typeof customFetch>[1]): Promise<MatchRow> => {

  return customFetch<MatchRow>(getSetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostUrl(brandId,matchId,params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostMutationKey = () => ['setMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPost'] as const;

export const getSetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPost>>, TError,SetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPost>>, TError,SetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostMutationVariables, TContext> => {

const mutationKey = getSetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPost>>, SetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostMutationVariables> = (props) => {
          const {brandId,matchId,params} = props ?? {};

          return  setMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPost(brandId,matchId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostMutationResult = NonNullable<Awaited<ReturnType<typeof setMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPost>>>

    export type SetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostMutationError = HTTPValidationError
    export type SetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostMutationVariables = {brandId: string;matchId: string;params: SetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostParams}

    /**
 * @summary Set Match Tracked
 */
export const useSetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPost>>, TError,SetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPost>>,
        TError,
        SetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostMutationVariables,
        TContext
      > => {
      return useMutation(getSetMatchTrackedV1BrandsBrandIdMatchesMatchIdTrackedPostMutationOptions(options), queryClient);
    }

export const getMoveTargetsV1BrandsBrandIdMatchesCandidatesGetUrl = (brandId: string,) => {




  return `/v1/brands/${brandId}/matches/candidates`
}

/**
 * The match groups a listing can be moved into: this brand's, nothing else.
 *
 * Feeds the move picker, which is why it is deliberately scoped to one brand -- an
 * operator should not be able to reach another brand's identity by typing an id.
 * @summary Move Targets
 */
export const moveTargetsV1BrandsBrandIdMatchesCandidatesGet = async (brandId: string, options?: Parameters<typeof customFetch>[1]): Promise<MatchRow[]> => {

  return customFetch<MatchRow[]>(getMoveTargetsV1BrandsBrandIdMatchesCandidatesGetUrl(brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMoveTargetsV1BrandsBrandIdMatchesCandidatesGetQueryKey = (brandId: string,) => {
    return [
    `/v1/brands/${brandId}/matches/candidates`
    ] as const;
    }


export const getMoveTargetsV1BrandsBrandIdMatchesCandidatesGetQueryOptions = <TData = Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>, TError = HTTPValidationError>(brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMoveTargetsV1BrandsBrandIdMatchesCandidatesGetQueryKey(brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>> = ({ signal }) => moveTargetsV1BrandsBrandIdMatchesCandidatesGet(brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MoveTargetsV1BrandsBrandIdMatchesCandidatesGetQueryResult = NonNullable<Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>>
export type MoveTargetsV1BrandsBrandIdMatchesCandidatesGetQueryError = HTTPValidationError


export function useMoveTargetsV1BrandsBrandIdMatchesCandidatesGet<TData = Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>, TError = HTTPValidationError>(
 brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>,
          TError,
          Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMoveTargetsV1BrandsBrandIdMatchesCandidatesGet<TData = Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>, TError = HTTPValidationError>(
 brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>,
          TError,
          Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMoveTargetsV1BrandsBrandIdMatchesCandidatesGet<TData = Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>, TError = HTTPValidationError>(
 brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Move Targets
 */

export function useMoveTargetsV1BrandsBrandIdMatchesCandidatesGet<TData = Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>, TError = HTTPValidationError>(
 brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moveTargetsV1BrandsBrandIdMatchesCandidatesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMoveTargetsV1BrandsBrandIdMatchesCandidatesGetQueryOptions(brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMatchesSummaryV1BrandsBrandIdMatchesSummaryGetUrl = (brandId: string,) => {




  return `/v1/brands/${brandId}/matches/summary`
}

/**
 * Counts for the brand list page: how many identities, how many operator-owned.
 * @summary Matches Summary
 */
export const matchesSummaryV1BrandsBrandIdMatchesSummaryGet = async (brandId: string, options?: Parameters<typeof customFetch>[1]): Promise<MatchesSummaryV1BrandsBrandIdMatchesSummaryGet200> => {

  return customFetch<MatchesSummaryV1BrandsBrandIdMatchesSummaryGet200>(getMatchesSummaryV1BrandsBrandIdMatchesSummaryGetUrl(brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMatchesSummaryV1BrandsBrandIdMatchesSummaryGetQueryKey = (brandId: string,) => {
    return [
    `/v1/brands/${brandId}/matches/summary`
    ] as const;
    }


export const getMatchesSummaryV1BrandsBrandIdMatchesSummaryGetQueryOptions = <TData = Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>, TError = HTTPValidationError>(brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMatchesSummaryV1BrandsBrandIdMatchesSummaryGetQueryKey(brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>> = ({ signal }) => matchesSummaryV1BrandsBrandIdMatchesSummaryGet(brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MatchesSummaryV1BrandsBrandIdMatchesSummaryGetQueryResult = NonNullable<Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>>
export type MatchesSummaryV1BrandsBrandIdMatchesSummaryGetQueryError = HTTPValidationError


export function useMatchesSummaryV1BrandsBrandIdMatchesSummaryGet<TData = Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>, TError = HTTPValidationError>(
 brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>,
          TError,
          Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMatchesSummaryV1BrandsBrandIdMatchesSummaryGet<TData = Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>, TError = HTTPValidationError>(
 brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>,
          TError,
          Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMatchesSummaryV1BrandsBrandIdMatchesSummaryGet<TData = Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>, TError = HTTPValidationError>(
 brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Matches Summary
 */

export function useMatchesSummaryV1BrandsBrandIdMatchesSummaryGet<TData = Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>, TError = HTTPValidationError>(
 brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof matchesSummaryV1BrandsBrandIdMatchesSummaryGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMatchesSummaryV1BrandsBrandIdMatchesSummaryGetQueryOptions(brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListKeywordsV1RankKeywordsGetUrl = () => {




  return `/v1/rank/keywords`
}

/**
 * Every tracked keyword, with how each rank-capable platform's most recent run did.
 *
 * There is no platform parameter. One shared keyword list is the whole point: a term
 * dead on one platform yields ``no_results`` probes there, which is a measurement rather
 * than a gap, and a per-platform list would quietly fork the series a share is computed
 * over. The platform axis lives in ``health``, which reports each platform's last run
 * beside the others.
 * @summary List Keywords
 */
export const listKeywordsV1RankKeywordsGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<KeywordOut[]> => {

  return customFetch<KeywordOut[]>(getListKeywordsV1RankKeywordsGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListKeywordsV1RankKeywordsGetQueryKey = () => {
    return [
    `/v1/rank/keywords`
    ] as const;
    }


export const getListKeywordsV1RankKeywordsGetQueryOptions = <TData = Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListKeywordsV1RankKeywordsGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>> = ({ signal }) => listKeywordsV1RankKeywordsGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListKeywordsV1RankKeywordsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>>
export type ListKeywordsV1RankKeywordsGetQueryError = unknown


export function useListKeywordsV1RankKeywordsGet<TData = Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>,
          TError,
          Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListKeywordsV1RankKeywordsGet<TData = Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>,
          TError,
          Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListKeywordsV1RankKeywordsGet<TData = Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Keywords
 */

export function useListKeywordsV1RankKeywordsGet<TData = Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listKeywordsV1RankKeywordsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListKeywordsV1RankKeywordsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateKeywordV1RankKeywordsPostUrl = () => {




  return `/v1/rank/keywords`
}

/**
 * Add a term, switched OFF. Nothing measures it until somebody turns it on.
 *
 * Adding is not enabling: a keyword costs one probe per store on every run that measures
 * it and shifts the denominator every share is read against, so the switch is where
 * somebody accepts that. Re-adding one that is already tracked is not an error and does
 * not disturb its switch -- normalisation is what makes that safe, since "Maggi " and
 * "maggi" are one key, so a second add replaces the first row instead of forking the
 * series into two.
 * @summary Create Keyword
 */
export const createKeywordV1RankKeywordsPost = async (keywordCreate: KeywordCreate, options?: Parameters<typeof customFetch>[1]): Promise<KeywordOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<KeywordOut>(getCreateKeywordV1RankKeywordsPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(keywordCreate)
  }
);}





export const getCreateKeywordV1RankKeywordsPostMutationKey = () => ['createKeywordV1RankKeywordsPost'] as const;

export const getCreateKeywordV1RankKeywordsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createKeywordV1RankKeywordsPost>>, TError,CreateKeywordV1RankKeywordsPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createKeywordV1RankKeywordsPost>>, TError,CreateKeywordV1RankKeywordsPostMutationVariables, TContext> => {

const mutationKey = getCreateKeywordV1RankKeywordsPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createKeywordV1RankKeywordsPost>>, CreateKeywordV1RankKeywordsPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createKeywordV1RankKeywordsPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateKeywordV1RankKeywordsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createKeywordV1RankKeywordsPost>>>
    export type CreateKeywordV1RankKeywordsPostMutationBody = KeywordCreate
    export type CreateKeywordV1RankKeywordsPostMutationError = HTTPValidationError
    export type CreateKeywordV1RankKeywordsPostMutationVariables = {data: KeywordCreate}

    /**
 * @summary Create Keyword
 */
export const useCreateKeywordV1RankKeywordsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createKeywordV1RankKeywordsPost>>, TError,CreateKeywordV1RankKeywordsPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createKeywordV1RankKeywordsPost>>,
        TError,
        CreateKeywordV1RankKeywordsPostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateKeywordV1RankKeywordsPostMutationOptions(options), queryClient);
    }

export const getUpdateKeywordV1RankKeywordsKeywordPatchUrl = (keyword: string,) => {




  return `/v1/rank/keywords/${keyword}`
}

/**
 * Retire or restore a keyword. The rows it has already measured are untouched.
 * @summary Update Keyword
 */
export const updateKeywordV1RankKeywordsKeywordPatch = async (keyword: string,
    enabledUpdate: EnabledUpdate, options?: Parameters<typeof customFetch>[1]): Promise<KeywordOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<KeywordOut>(getUpdateKeywordV1RankKeywordsKeywordPatchUrl(keyword),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(enabledUpdate)
  }
);}





export const getUpdateKeywordV1RankKeywordsKeywordPatchMutationKey = () => ['updateKeywordV1RankKeywordsKeywordPatch'] as const;

export const getUpdateKeywordV1RankKeywordsKeywordPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateKeywordV1RankKeywordsKeywordPatch>>, TError,UpdateKeywordV1RankKeywordsKeywordPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateKeywordV1RankKeywordsKeywordPatch>>, TError,UpdateKeywordV1RankKeywordsKeywordPatchMutationVariables, TContext> => {

const mutationKey = getUpdateKeywordV1RankKeywordsKeywordPatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateKeywordV1RankKeywordsKeywordPatch>>, UpdateKeywordV1RankKeywordsKeywordPatchMutationVariables> = (props) => {
          const {keyword,data} = props ?? {};

          return  updateKeywordV1RankKeywordsKeywordPatch(keyword,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateKeywordV1RankKeywordsKeywordPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateKeywordV1RankKeywordsKeywordPatch>>>
    export type UpdateKeywordV1RankKeywordsKeywordPatchMutationBody = EnabledUpdate
    export type UpdateKeywordV1RankKeywordsKeywordPatchMutationError = HTTPValidationError
    export type UpdateKeywordV1RankKeywordsKeywordPatchMutationVariables = {keyword: string;data: EnabledUpdate}

    /**
 * @summary Update Keyword
 */
export const useUpdateKeywordV1RankKeywordsKeywordPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateKeywordV1RankKeywordsKeywordPatch>>, TError,UpdateKeywordV1RankKeywordsKeywordPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateKeywordV1RankKeywordsKeywordPatch>>,
        TError,
        UpdateKeywordV1RankKeywordsKeywordPatchMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateKeywordV1RankKeywordsKeywordPatchMutationOptions(options), queryClient);
    }

export const getDeleteKeywordV1RankKeywordsKeywordDeleteUrl = (keyword: string,) => {




  return `/v1/rank/keywords/${keyword}`
}

/**
 * Remove a term from the registry. The rows it has already measured are untouched.
 *
 * For a term that should never have been in the list -- a typo, a duplicate somebody
 * typed differently, an experiment nobody wants to see again. Stopping a term that has
 * a series worth keeping is the enable switch, which leaves the entry visible and says
 * so; this leaves no trace in the registry, so a reader can no longer tell the term from
 * one that was never tracked.
 * @summary Delete Keyword
 */
export const deleteKeywordV1RankKeywordsKeywordDelete = async (keyword: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteKeywordV1RankKeywordsKeywordDeleteUrl(keyword),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteKeywordV1RankKeywordsKeywordDeleteMutationKey = () => ['deleteKeywordV1RankKeywordsKeywordDelete'] as const;

export const getDeleteKeywordV1RankKeywordsKeywordDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteKeywordV1RankKeywordsKeywordDelete>>, TError,DeleteKeywordV1RankKeywordsKeywordDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteKeywordV1RankKeywordsKeywordDelete>>, TError,DeleteKeywordV1RankKeywordsKeywordDeleteMutationVariables, TContext> => {

const mutationKey = getDeleteKeywordV1RankKeywordsKeywordDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteKeywordV1RankKeywordsKeywordDelete>>, DeleteKeywordV1RankKeywordsKeywordDeleteMutationVariables> = (props) => {
          const {keyword} = props ?? {};

          return  deleteKeywordV1RankKeywordsKeywordDelete(keyword,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteKeywordV1RankKeywordsKeywordDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteKeywordV1RankKeywordsKeywordDelete>>>

    export type DeleteKeywordV1RankKeywordsKeywordDeleteMutationError = HTTPValidationError
    export type DeleteKeywordV1RankKeywordsKeywordDeleteMutationVariables = {keyword: string}

    /**
 * @summary Delete Keyword
 */
export const useDeleteKeywordV1RankKeywordsKeywordDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteKeywordV1RankKeywordsKeywordDelete>>, TError,DeleteKeywordV1RankKeywordsKeywordDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteKeywordV1RankKeywordsKeywordDelete>>,
        TError,
        DeleteKeywordV1RankKeywordsKeywordDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteKeywordV1RankKeywordsKeywordDeleteMutationOptions(options), queryClient);
    }

export const getListCategoriesV1RankCategoriesGetUrl = (params?: ListCategoriesV1RankCategoriesGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/rank/categories?${stringifiedParams}` : `/v1/rank/categories`
}

/**
 * Every tracked category for one platform, with its most recent run's health.
 * @summary List Categories
 */
export const listCategoriesV1RankCategoriesGet = async (params?: ListCategoriesV1RankCategoriesGetParams, options?: Parameters<typeof customFetch>[1]): Promise<CategoryOut[]> => {

  return customFetch<CategoryOut[]>(getListCategoriesV1RankCategoriesGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCategoriesV1RankCategoriesGetQueryKey = (params?: ListCategoriesV1RankCategoriesGetParams,) => {
    return [
    `/v1/rank/categories`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCategoriesV1RankCategoriesGetQueryOptions = <TData = Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>, TError = HTTPValidationError>(params?: ListCategoriesV1RankCategoriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCategoriesV1RankCategoriesGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>> = ({ signal }) => listCategoriesV1RankCategoriesGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCategoriesV1RankCategoriesGetQueryResult = NonNullable<Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>>
export type ListCategoriesV1RankCategoriesGetQueryError = HTTPValidationError


export function useListCategoriesV1RankCategoriesGet<TData = Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>, TError = HTTPValidationError>(
 params: undefined |  ListCategoriesV1RankCategoriesGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>,
          TError,
          Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCategoriesV1RankCategoriesGet<TData = Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>, TError = HTTPValidationError>(
 params?: ListCategoriesV1RankCategoriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>,
          TError,
          Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCategoriesV1RankCategoriesGet<TData = Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>, TError = HTTPValidationError>(
 params?: ListCategoriesV1RankCategoriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Categories
 */

export function useListCategoriesV1RankCategoriesGet<TData = Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>, TError = HTTPValidationError>(
 params?: ListCategoriesV1RankCategoriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCategoriesV1RankCategoriesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCategoriesV1RankCategoriesGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateCategoryV1RankCategoriesPlatformCategoryIdPatchUrl = (platform: Platform,
    categoryId: string,) => {




  return `/v1/rank/categories/${platform}/${categoryId}`
}

/**
 * Retire or restore a category.
 *
 * ``category_id`` takes the rest of the path because Blinkit writes a narrowed category
 * as ``l0/l1`` -- one address with a slash in it, not two path segments.
 * @summary Update Category
 */
export const updateCategoryV1RankCategoriesPlatformCategoryIdPatch = async (platform: Platform,
    categoryId: string,
    enabledUpdate: EnabledUpdate, options?: Parameters<typeof customFetch>[1]): Promise<CategoryOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<CategoryOut>(getUpdateCategoryV1RankCategoriesPlatformCategoryIdPatchUrl(platform,categoryId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(enabledUpdate)
  }
);}





export const getUpdateCategoryV1RankCategoriesPlatformCategoryIdPatchMutationKey = () => ['updateCategoryV1RankCategoriesPlatformCategoryIdPatch'] as const;

export const getUpdateCategoryV1RankCategoriesPlatformCategoryIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategoryV1RankCategoriesPlatformCategoryIdPatch>>, TError,UpdateCategoryV1RankCategoriesPlatformCategoryIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCategoryV1RankCategoriesPlatformCategoryIdPatch>>, TError,UpdateCategoryV1RankCategoriesPlatformCategoryIdPatchMutationVariables, TContext> => {

const mutationKey = getUpdateCategoryV1RankCategoriesPlatformCategoryIdPatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCategoryV1RankCategoriesPlatformCategoryIdPatch>>, UpdateCategoryV1RankCategoriesPlatformCategoryIdPatchMutationVariables> = (props) => {
          const {platform,categoryId,data} = props ?? {};

          return  updateCategoryV1RankCategoriesPlatformCategoryIdPatch(platform,categoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCategoryV1RankCategoriesPlatformCategoryIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateCategoryV1RankCategoriesPlatformCategoryIdPatch>>>
    export type UpdateCategoryV1RankCategoriesPlatformCategoryIdPatchMutationBody = EnabledUpdate
    export type UpdateCategoryV1RankCategoriesPlatformCategoryIdPatchMutationError = HTTPValidationError
    export type UpdateCategoryV1RankCategoriesPlatformCategoryIdPatchMutationVariables = {platform: Platform;categoryId: string;data: EnabledUpdate}

    /**
 * @summary Update Category
 */
export const useUpdateCategoryV1RankCategoriesPlatformCategoryIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCategoryV1RankCategoriesPlatformCategoryIdPatch>>, TError,UpdateCategoryV1RankCategoriesPlatformCategoryIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCategoryV1RankCategoriesPlatformCategoryIdPatch>>,
        TError,
        UpdateCategoryV1RankCategoriesPlatformCategoryIdPatchMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCategoryV1RankCategoriesPlatformCategoryIdPatchMutationOptions(options), queryClient);
    }

export const getKeywordShelfRunsV1RankKeywordsKeywordRunsGetUrl = (keyword: string,
    params?: KeywordShelfRunsV1RankKeywordsKeywordRunsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/rank/keywords/${keyword}/runs?${stringifiedParams}` : `/v1/rank/keywords/${keyword}/runs`
}

/**
 * The recent runs that measured this keyword on this platform, newest first.
 * @summary Keyword Shelf Runs
 */
export const keywordShelfRunsV1RankKeywordsKeywordRunsGet = async (keyword: string,
    params?: KeywordShelfRunsV1RankKeywordsKeywordRunsGetParams, options?: Parameters<typeof customFetch>[1]): Promise<ShelfRunOut[]> => {

  return customFetch<ShelfRunOut[]>(getKeywordShelfRunsV1RankKeywordsKeywordRunsGetUrl(keyword,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getKeywordShelfRunsV1RankKeywordsKeywordRunsGetQueryKey = (keyword: string,
    params?: KeywordShelfRunsV1RankKeywordsKeywordRunsGetParams,) => {
    return [
    `/v1/rank/keywords/${keyword}/runs`, ...(params ? [params] : [])
    ] as const;
    }


export const getKeywordShelfRunsV1RankKeywordsKeywordRunsGetQueryOptions = <TData = Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>, TError = HTTPValidationError>(keyword: string,
    params?: KeywordShelfRunsV1RankKeywordsKeywordRunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKeywordShelfRunsV1RankKeywordsKeywordRunsGetQueryKey(keyword,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>> = ({ signal }) => keywordShelfRunsV1RankKeywordsKeywordRunsGet(keyword,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: keyword !== null && keyword !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KeywordShelfRunsV1RankKeywordsKeywordRunsGetQueryResult = NonNullable<Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>>
export type KeywordShelfRunsV1RankKeywordsKeywordRunsGetQueryError = HTTPValidationError


export function useKeywordShelfRunsV1RankKeywordsKeywordRunsGet<TData = Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>, TError = HTTPValidationError>(
 keyword: string,
    params: undefined |  KeywordShelfRunsV1RankKeywordsKeywordRunsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>,
          TError,
          Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKeywordShelfRunsV1RankKeywordsKeywordRunsGet<TData = Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>, TError = HTTPValidationError>(
 keyword: string,
    params?: KeywordShelfRunsV1RankKeywordsKeywordRunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>,
          TError,
          Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKeywordShelfRunsV1RankKeywordsKeywordRunsGet<TData = Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>, TError = HTTPValidationError>(
 keyword: string,
    params?: KeywordShelfRunsV1RankKeywordsKeywordRunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Keyword Shelf Runs
 */

export function useKeywordShelfRunsV1RankKeywordsKeywordRunsGet<TData = Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>, TError = HTTPValidationError>(
 keyword: string,
    params?: KeywordShelfRunsV1RankKeywordsKeywordRunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keywordShelfRunsV1RankKeywordsKeywordRunsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKeywordShelfRunsV1RankKeywordsKeywordRunsGetQueryOptions(keyword,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getKeywordShelfV1RankKeywordsKeywordShelfGetUrl = (keyword: string,
    params?: KeywordShelfV1RankKeywordsKeywordShelfGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/rank/keywords/${keyword}/shelf?${stringifiedParams}` : `/v1/rank/keywords/${keyword}/shelf`
}

/**
 * One keyword's shelf, as one run measured it across every probe point it asked.
 *
 * The keyword is normalised on the way in, so the text an operator has in front of them
 * finds the series it is filed under.
 * @summary Keyword Shelf
 */
export const keywordShelfV1RankKeywordsKeywordShelfGet = async (keyword: string,
    params?: KeywordShelfV1RankKeywordsKeywordShelfGetParams, options?: Parameters<typeof customFetch>[1]): Promise<ShelfOut> => {

  return customFetch<ShelfOut>(getKeywordShelfV1RankKeywordsKeywordShelfGetUrl(keyword,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getKeywordShelfV1RankKeywordsKeywordShelfGetQueryKey = (keyword: string,
    params?: KeywordShelfV1RankKeywordsKeywordShelfGetParams,) => {
    return [
    `/v1/rank/keywords/${keyword}/shelf`, ...(params ? [params] : [])
    ] as const;
    }


export const getKeywordShelfV1RankKeywordsKeywordShelfGetQueryOptions = <TData = Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>, TError = HTTPValidationError>(keyword: string,
    params?: KeywordShelfV1RankKeywordsKeywordShelfGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getKeywordShelfV1RankKeywordsKeywordShelfGetQueryKey(keyword,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>> = ({ signal }) => keywordShelfV1RankKeywordsKeywordShelfGet(keyword,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: keyword !== null && keyword !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type KeywordShelfV1RankKeywordsKeywordShelfGetQueryResult = NonNullable<Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>>
export type KeywordShelfV1RankKeywordsKeywordShelfGetQueryError = HTTPValidationError


export function useKeywordShelfV1RankKeywordsKeywordShelfGet<TData = Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>, TError = HTTPValidationError>(
 keyword: string,
    params: undefined |  KeywordShelfV1RankKeywordsKeywordShelfGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>,
          TError,
          Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKeywordShelfV1RankKeywordsKeywordShelfGet<TData = Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>, TError = HTTPValidationError>(
 keyword: string,
    params?: KeywordShelfV1RankKeywordsKeywordShelfGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>,
          TError,
          Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useKeywordShelfV1RankKeywordsKeywordShelfGet<TData = Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>, TError = HTTPValidationError>(
 keyword: string,
    params?: KeywordShelfV1RankKeywordsKeywordShelfGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Keyword Shelf
 */

export function useKeywordShelfV1RankKeywordsKeywordShelfGet<TData = Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>, TError = HTTPValidationError>(
 keyword: string,
    params?: KeywordShelfV1RankKeywordsKeywordShelfGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof keywordShelfV1RankKeywordsKeywordShelfGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getKeywordShelfV1RankKeywordsKeywordShelfGetQueryOptions(keyword,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetUrl = (platform: Platform,
    params: CategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/rank/categories/${platform}/shelf-runs?${stringifiedParams}` : `/v1/rank/categories/${platform}/shelf-runs`
}

/**
 * The recent runs that measured this category, newest first.
 *
 * ``category_id`` is a QUERY parameter here, where the enable endpoint takes it as the
 * rest of the path. A Blinkit category id contains a slash, and a greedy path converter
 * would swallow any suffix after it, so a path-carried id can be the end of a route or
 * carry a sub-resource, never both.
 * @summary Category Shelf Runs
 */
export const categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet = async (platform: Platform,
    params: CategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetParams, options?: Parameters<typeof customFetch>[1]): Promise<ShelfRunOut[]> => {

  return customFetch<ShelfRunOut[]>(getCategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetUrl(platform,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetQueryKey = (platform: Platform,
    params?: CategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetParams,) => {
    return [
    `/v1/rank/categories/${platform}/shelf-runs`, ...(params ? [params] : [])
    ] as const;
    }


export const getCategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetQueryOptions = <TData = Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>, TError = HTTPValidationError>(platform: Platform,
    params: CategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetQueryKey(platform,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>> = ({ signal }) => categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet(platform,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: platform !== null && platform !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetQueryResult = NonNullable<Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>>
export type CategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetQueryError = HTTPValidationError


export function useCategoryShelfRunsV1RankCategoriesPlatformShelfRunsGet<TData = Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>, TError = HTTPValidationError>(
 platform: Platform,
    params: CategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>,
          TError,
          Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCategoryShelfRunsV1RankCategoriesPlatformShelfRunsGet<TData = Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>, TError = HTTPValidationError>(
 platform: Platform,
    params: CategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>,
          TError,
          Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCategoryShelfRunsV1RankCategoriesPlatformShelfRunsGet<TData = Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>, TError = HTTPValidationError>(
 platform: Platform,
    params: CategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Category Shelf Runs
 */

export function useCategoryShelfRunsV1RankCategoriesPlatformShelfRunsGet<TData = Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>, TError = HTTPValidationError>(
 platform: Platform,
    params: CategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof categoryShelfRunsV1RankCategoriesPlatformShelfRunsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCategoryShelfRunsV1RankCategoriesPlatformShelfRunsGetQueryOptions(platform,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCategoryShelfV1RankCategoriesPlatformShelfGetUrl = (platform: Platform,
    params: CategoryShelfV1RankCategoriesPlatformShelfGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/rank/categories/${platform}/shelf?${stringifiedParams}` : `/v1/rank/categories/${platform}/shelf`
}

/**
 * One tracked category shelf, as one run measured it.
 *
 * ``category_id`` is a query parameter for the same reason the run list takes it as one.
 * @summary Category Shelf
 */
export const categoryShelfV1RankCategoriesPlatformShelfGet = async (platform: Platform,
    params: CategoryShelfV1RankCategoriesPlatformShelfGetParams, options?: Parameters<typeof customFetch>[1]): Promise<ShelfOut> => {

  return customFetch<ShelfOut>(getCategoryShelfV1RankCategoriesPlatformShelfGetUrl(platform,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCategoryShelfV1RankCategoriesPlatformShelfGetQueryKey = (platform: Platform,
    params?: CategoryShelfV1RankCategoriesPlatformShelfGetParams,) => {
    return [
    `/v1/rank/categories/${platform}/shelf`, ...(params ? [params] : [])
    ] as const;
    }


export const getCategoryShelfV1RankCategoriesPlatformShelfGetQueryOptions = <TData = Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>, TError = HTTPValidationError>(platform: Platform,
    params: CategoryShelfV1RankCategoriesPlatformShelfGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCategoryShelfV1RankCategoriesPlatformShelfGetQueryKey(platform,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>> = ({ signal }) => categoryShelfV1RankCategoriesPlatformShelfGet(platform,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: platform !== null && platform !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CategoryShelfV1RankCategoriesPlatformShelfGetQueryResult = NonNullable<Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>>
export type CategoryShelfV1RankCategoriesPlatformShelfGetQueryError = HTTPValidationError


export function useCategoryShelfV1RankCategoriesPlatformShelfGet<TData = Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>, TError = HTTPValidationError>(
 platform: Platform,
    params: CategoryShelfV1RankCategoriesPlatformShelfGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>,
          TError,
          Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCategoryShelfV1RankCategoriesPlatformShelfGet<TData = Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>, TError = HTTPValidationError>(
 platform: Platform,
    params: CategoryShelfV1RankCategoriesPlatformShelfGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>,
          TError,
          Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCategoryShelfV1RankCategoriesPlatformShelfGet<TData = Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>, TError = HTTPValidationError>(
 platform: Platform,
    params: CategoryShelfV1RankCategoriesPlatformShelfGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Category Shelf
 */

export function useCategoryShelfV1RankCategoriesPlatformShelfGet<TData = Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>, TError = HTTPValidationError>(
 platform: Platform,
    params: CategoryShelfV1RankCategoriesPlatformShelfGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof categoryShelfV1RankCategoriesPlatformShelfGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCategoryShelfV1RankCategoriesPlatformShelfGetQueryOptions(platform,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetConfigV1ProbeLocationsConfigGetUrl = () => {




  return `/v1/probe-locations/config`
}

/**
 * @summary Get Config
 */
export const getConfigV1ProbeLocationsConfigGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<ProbeConfigOut> => {

  return customFetch<ProbeConfigOut>(getGetConfigV1ProbeLocationsConfigGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConfigV1ProbeLocationsConfigGetQueryKey = () => {
    return [
    `/v1/probe-locations/config`
    ] as const;
    }


export const getGetConfigV1ProbeLocationsConfigGetQueryOptions = <TData = Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigV1ProbeLocationsConfigGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>> = ({ signal }) => getConfigV1ProbeLocationsConfigGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigV1ProbeLocationsConfigGetQueryResult = NonNullable<Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>>
export type GetConfigV1ProbeLocationsConfigGetQueryError = unknown


export function useGetConfigV1ProbeLocationsConfigGet<TData = Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>,
          TError,
          Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigV1ProbeLocationsConfigGet<TData = Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>,
          TError,
          Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigV1ProbeLocationsConfigGet<TData = Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Config
 */

export function useGetConfigV1ProbeLocationsConfigGet<TData = Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigV1ProbeLocationsConfigGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigV1ProbeLocationsConfigGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateConfigV1ProbeLocationsConfigPutUrl = () => {




  return `/v1/probe-locations/config`
}

/**
 * Upsert the single tuning row (id locked to ``true``).
 * @summary Update Config
 */
export const updateConfigV1ProbeLocationsConfigPut = async (probeConfigUpdate: ProbeConfigUpdate, options?: Parameters<typeof customFetch>[1]): Promise<ProbeConfigOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProbeConfigOut>(getUpdateConfigV1ProbeLocationsConfigPutUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(probeConfigUpdate)
  }
);}





export const getUpdateConfigV1ProbeLocationsConfigPutMutationKey = () => ['updateConfigV1ProbeLocationsConfigPut'] as const;

export const getUpdateConfigV1ProbeLocationsConfigPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConfigV1ProbeLocationsConfigPut>>, TError,UpdateConfigV1ProbeLocationsConfigPutMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateConfigV1ProbeLocationsConfigPut>>, TError,UpdateConfigV1ProbeLocationsConfigPutMutationVariables, TContext> => {

const mutationKey = getUpdateConfigV1ProbeLocationsConfigPutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConfigV1ProbeLocationsConfigPut>>, UpdateConfigV1ProbeLocationsConfigPutMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateConfigV1ProbeLocationsConfigPut(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateConfigV1ProbeLocationsConfigPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateConfigV1ProbeLocationsConfigPut>>>
    export type UpdateConfigV1ProbeLocationsConfigPutMutationBody = ProbeConfigUpdate
    export type UpdateConfigV1ProbeLocationsConfigPutMutationError = HTTPValidationError
    export type UpdateConfigV1ProbeLocationsConfigPutMutationVariables = {data: ProbeConfigUpdate}

    /**
 * @summary Update Config
 */
export const useUpdateConfigV1ProbeLocationsConfigPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConfigV1ProbeLocationsConfigPut>>, TError,UpdateConfigV1ProbeLocationsConfigPutMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateConfigV1ProbeLocationsConfigPut>>,
        TError,
        UpdateConfigV1ProbeLocationsConfigPutMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateConfigV1ProbeLocationsConfigPutMutationOptions(options), queryClient);
    }

export const getListLocationsV1ProbeLocationsGetUrl = () => {




  return `/v1/probe-locations`
}

/**
 * All probe points (incl. disabled), ordered like the walk.
 * @summary List Locations
 */
export const listLocationsV1ProbeLocationsGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<ProbeLocationOut[]> => {

  return customFetch<ProbeLocationOut[]>(getListLocationsV1ProbeLocationsGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLocationsV1ProbeLocationsGetQueryKey = () => {
    return [
    `/v1/probe-locations`
    ] as const;
    }


export const getListLocationsV1ProbeLocationsGetQueryOptions = <TData = Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLocationsV1ProbeLocationsGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>> = ({ signal }) => listLocationsV1ProbeLocationsGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLocationsV1ProbeLocationsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>>
export type ListLocationsV1ProbeLocationsGetQueryError = unknown


export function useListLocationsV1ProbeLocationsGet<TData = Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>,
          TError,
          Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLocationsV1ProbeLocationsGet<TData = Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>,
          TError,
          Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLocationsV1ProbeLocationsGet<TData = Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Locations
 */

export function useListLocationsV1ProbeLocationsGet<TData = Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLocationsV1ProbeLocationsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLocationsV1ProbeLocationsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLocationV1ProbeLocationsPostUrl = () => {




  return `/v1/probe-locations`
}

/**
 * @summary Create Location
 */
export const createLocationV1ProbeLocationsPost = async (probeLocationCreate: ProbeLocationCreate, options?: Parameters<typeof customFetch>[1]): Promise<ProbeLocationOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProbeLocationOut>(getCreateLocationV1ProbeLocationsPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(probeLocationCreate)
  }
);}





export const getCreateLocationV1ProbeLocationsPostMutationKey = () => ['createLocationV1ProbeLocationsPost'] as const;

export const getCreateLocationV1ProbeLocationsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocationV1ProbeLocationsPost>>, TError,CreateLocationV1ProbeLocationsPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLocationV1ProbeLocationsPost>>, TError,CreateLocationV1ProbeLocationsPostMutationVariables, TContext> => {

const mutationKey = getCreateLocationV1ProbeLocationsPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLocationV1ProbeLocationsPost>>, CreateLocationV1ProbeLocationsPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createLocationV1ProbeLocationsPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLocationV1ProbeLocationsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createLocationV1ProbeLocationsPost>>>
    export type CreateLocationV1ProbeLocationsPostMutationBody = ProbeLocationCreate
    export type CreateLocationV1ProbeLocationsPostMutationError = HTTPValidationError
    export type CreateLocationV1ProbeLocationsPostMutationVariables = {data: ProbeLocationCreate}

    /**
 * @summary Create Location
 */
export const useCreateLocationV1ProbeLocationsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocationV1ProbeLocationsPost>>, TError,CreateLocationV1ProbeLocationsPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLocationV1ProbeLocationsPost>>,
        TError,
        CreateLocationV1ProbeLocationsPostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateLocationV1ProbeLocationsPostMutationOptions(options), queryClient);
    }

export const getSetEnabledV1ProbeLocationsSetEnabledPostUrl = () => {




  return `/v1/probe-locations/set-enabled`
}

/**
 * Bulk enable/disable points: selected ``ids``, or all when ``None``.
 * @summary Set Enabled
 */
export const setEnabledV1ProbeLocationsSetEnabledPost = async (probeLocationSetEnabled: ProbeLocationSetEnabled, options?: Parameters<typeof customFetch>[1]): Promise<ProbeLocationOut[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProbeLocationOut[]>(getSetEnabledV1ProbeLocationsSetEnabledPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(probeLocationSetEnabled)
  }
);}





export const getSetEnabledV1ProbeLocationsSetEnabledPostMutationKey = () => ['setEnabledV1ProbeLocationsSetEnabledPost'] as const;

export const getSetEnabledV1ProbeLocationsSetEnabledPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setEnabledV1ProbeLocationsSetEnabledPost>>, TError,SetEnabledV1ProbeLocationsSetEnabledPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setEnabledV1ProbeLocationsSetEnabledPost>>, TError,SetEnabledV1ProbeLocationsSetEnabledPostMutationVariables, TContext> => {

const mutationKey = getSetEnabledV1ProbeLocationsSetEnabledPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setEnabledV1ProbeLocationsSetEnabledPost>>, SetEnabledV1ProbeLocationsSetEnabledPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setEnabledV1ProbeLocationsSetEnabledPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetEnabledV1ProbeLocationsSetEnabledPostMutationResult = NonNullable<Awaited<ReturnType<typeof setEnabledV1ProbeLocationsSetEnabledPost>>>
    export type SetEnabledV1ProbeLocationsSetEnabledPostMutationBody = ProbeLocationSetEnabled
    export type SetEnabledV1ProbeLocationsSetEnabledPostMutationError = HTTPValidationError
    export type SetEnabledV1ProbeLocationsSetEnabledPostMutationVariables = {data: ProbeLocationSetEnabled}

    /**
 * @summary Set Enabled
 */
export const useSetEnabledV1ProbeLocationsSetEnabledPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setEnabledV1ProbeLocationsSetEnabledPost>>, TError,SetEnabledV1ProbeLocationsSetEnabledPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setEnabledV1ProbeLocationsSetEnabledPost>>,
        TError,
        SetEnabledV1ProbeLocationsSetEnabledPostMutationVariables,
        TContext
      > => {
      return useMutation(getSetEnabledV1ProbeLocationsSetEnabledPostMutationOptions(options), queryClient);
    }

export const getMoveCityV1ProbeLocationsMoveCityPostUrl = () => {




  return `/v1/probe-locations/move-city`
}

/**
 * Move a whole city one slot up/down in the walk order.
 *
 * City order is defined by ``city_rank`` (then name). We renumber all cities to a
 * contiguous ``0..n-1`` in their current order, swap the target with its neighbour, and
 * write the new rank onto every point of both cities; the arrows work reliably even
 * if ranks had drifted or tied. A no-op (already at the edge) just returns the list.
 * @summary Move City
 */
export const moveCityV1ProbeLocationsMoveCityPost = async (moveCity: MoveCity, options?: Parameters<typeof customFetch>[1]): Promise<ProbeLocationOut[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProbeLocationOut[]>(getMoveCityV1ProbeLocationsMoveCityPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(moveCity)
  }
);}





export const getMoveCityV1ProbeLocationsMoveCityPostMutationKey = () => ['moveCityV1ProbeLocationsMoveCityPost'] as const;

export const getMoveCityV1ProbeLocationsMoveCityPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveCityV1ProbeLocationsMoveCityPost>>, TError,MoveCityV1ProbeLocationsMoveCityPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof moveCityV1ProbeLocationsMoveCityPost>>, TError,MoveCityV1ProbeLocationsMoveCityPostMutationVariables, TContext> => {

const mutationKey = getMoveCityV1ProbeLocationsMoveCityPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveCityV1ProbeLocationsMoveCityPost>>, MoveCityV1ProbeLocationsMoveCityPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  moveCityV1ProbeLocationsMoveCityPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveCityV1ProbeLocationsMoveCityPostMutationResult = NonNullable<Awaited<ReturnType<typeof moveCityV1ProbeLocationsMoveCityPost>>>
    export type MoveCityV1ProbeLocationsMoveCityPostMutationBody = MoveCity
    export type MoveCityV1ProbeLocationsMoveCityPostMutationError = HTTPValidationError
    export type MoveCityV1ProbeLocationsMoveCityPostMutationVariables = {data: MoveCity}

    /**
 * @summary Move City
 */
export const useMoveCityV1ProbeLocationsMoveCityPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveCityV1ProbeLocationsMoveCityPost>>, TError,MoveCityV1ProbeLocationsMoveCityPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof moveCityV1ProbeLocationsMoveCityPost>>,
        TError,
        MoveCityV1ProbeLocationsMoveCityPostMutationVariables,
        TContext
      > => {
      return useMutation(getMoveCityV1ProbeLocationsMoveCityPostMutationOptions(options), queryClient);
    }

export const getUpdateLocationV1ProbeLocationsLocationIdPatchUrl = (locationId: string,) => {




  return `/v1/probe-locations/${locationId}`
}

/**
 * @summary Update Location
 */
export const updateLocationV1ProbeLocationsLocationIdPatch = async (locationId: string,
    probeLocationUpdate: ProbeLocationUpdate, options?: Parameters<typeof customFetch>[1]): Promise<ProbeLocationOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProbeLocationOut>(getUpdateLocationV1ProbeLocationsLocationIdPatchUrl(locationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(probeLocationUpdate)
  }
);}





export const getUpdateLocationV1ProbeLocationsLocationIdPatchMutationKey = () => ['updateLocationV1ProbeLocationsLocationIdPatch'] as const;

export const getUpdateLocationV1ProbeLocationsLocationIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocationV1ProbeLocationsLocationIdPatch>>, TError,UpdateLocationV1ProbeLocationsLocationIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLocationV1ProbeLocationsLocationIdPatch>>, TError,UpdateLocationV1ProbeLocationsLocationIdPatchMutationVariables, TContext> => {

const mutationKey = getUpdateLocationV1ProbeLocationsLocationIdPatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLocationV1ProbeLocationsLocationIdPatch>>, UpdateLocationV1ProbeLocationsLocationIdPatchMutationVariables> = (props) => {
          const {locationId,data} = props ?? {};

          return  updateLocationV1ProbeLocationsLocationIdPatch(locationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLocationV1ProbeLocationsLocationIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateLocationV1ProbeLocationsLocationIdPatch>>>
    export type UpdateLocationV1ProbeLocationsLocationIdPatchMutationBody = ProbeLocationUpdate
    export type UpdateLocationV1ProbeLocationsLocationIdPatchMutationError = HTTPValidationError
    export type UpdateLocationV1ProbeLocationsLocationIdPatchMutationVariables = {locationId: string;data: ProbeLocationUpdate}

    /**
 * @summary Update Location
 */
export const useUpdateLocationV1ProbeLocationsLocationIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocationV1ProbeLocationsLocationIdPatch>>, TError,UpdateLocationV1ProbeLocationsLocationIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLocationV1ProbeLocationsLocationIdPatch>>,
        TError,
        UpdateLocationV1ProbeLocationsLocationIdPatchMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateLocationV1ProbeLocationsLocationIdPatchMutationOptions(options), queryClient);
    }

export const getDeleteLocationV1ProbeLocationsLocationIdDeleteUrl = (locationId: string,) => {




  return `/v1/probe-locations/${locationId}`
}

/**
 * @summary Delete Location
 */
export const deleteLocationV1ProbeLocationsLocationIdDelete = async (locationId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteLocationV1ProbeLocationsLocationIdDeleteUrl(locationId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteLocationV1ProbeLocationsLocationIdDeleteMutationKey = () => ['deleteLocationV1ProbeLocationsLocationIdDelete'] as const;

export const getDeleteLocationV1ProbeLocationsLocationIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLocationV1ProbeLocationsLocationIdDelete>>, TError,DeleteLocationV1ProbeLocationsLocationIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLocationV1ProbeLocationsLocationIdDelete>>, TError,DeleteLocationV1ProbeLocationsLocationIdDeleteMutationVariables, TContext> => {

const mutationKey = getDeleteLocationV1ProbeLocationsLocationIdDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLocationV1ProbeLocationsLocationIdDelete>>, DeleteLocationV1ProbeLocationsLocationIdDeleteMutationVariables> = (props) => {
          const {locationId} = props ?? {};

          return  deleteLocationV1ProbeLocationsLocationIdDelete(locationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLocationV1ProbeLocationsLocationIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLocationV1ProbeLocationsLocationIdDelete>>>

    export type DeleteLocationV1ProbeLocationsLocationIdDeleteMutationError = HTTPValidationError
    export type DeleteLocationV1ProbeLocationsLocationIdDeleteMutationVariables = {locationId: string}

    /**
 * @summary Delete Location
 */
export const useDeleteLocationV1ProbeLocationsLocationIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLocationV1ProbeLocationsLocationIdDelete>>, TError,DeleteLocationV1ProbeLocationsLocationIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLocationV1ProbeLocationsLocationIdDelete>>,
        TError,
        DeleteLocationV1ProbeLocationsLocationIdDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteLocationV1ProbeLocationsLocationIdDeleteMutationOptions(options), queryClient);
    }

export const getStoresV1StoresGetUrl = (params: StoresV1StoresGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/stores?${stringifiedParams}` : `/v1/stores`
}

/**
 * Current store-dimension rows for a platform (latest, optionally status-filtered).
 *
 * Each row gains a ``tiers`` field - its delivery-tier -> probe-point-count breakdown
 * (:func:`tier_breakdown`) - which the table shows in place of the old single
 * PRIMARY/blank ``tier`` flag.
 *
 * The two geometry blobs the dimension carries (``coverage_cells``, which ``tiers`` is
 * derived from, and ``coverage_boundary``) are dropped before the response, as is the
 * adapter-written ``extra`` JSON (BBNow packs per-store FC evidence into it): the Stores
 * table renders none of the three, but ``_Read``'s ``extra="allow"`` would otherwise ship
 * them - ~75% of a several-MB payload, re-fetched on the page's 20s poll. The map
 * (``/v1/stores/map``) and the detail page serve the geometry to whoever needs it.
 * @summary Stores
 */
export const storesV1StoresGet = async (params: StoresV1StoresGetParams, options?: Parameters<typeof customFetch>[1]): Promise<Store[]> => {

  return customFetch<Store[]>(getStoresV1StoresGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoresV1StoresGetQueryKey = (params?: StoresV1StoresGetParams,) => {
    return [
    `/v1/stores`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoresV1StoresGetQueryOptions = <TData = Awaited<ReturnType<typeof storesV1StoresGet>>, TError = HTTPValidationError>(params: StoresV1StoresGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storesV1StoresGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoresV1StoresGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storesV1StoresGet>>> = ({ signal }) => storesV1StoresGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storesV1StoresGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoresV1StoresGetQueryResult = NonNullable<Awaited<ReturnType<typeof storesV1StoresGet>>>
export type StoresV1StoresGetQueryError = HTTPValidationError


export function useStoresV1StoresGet<TData = Awaited<ReturnType<typeof storesV1StoresGet>>, TError = HTTPValidationError>(
 params: StoresV1StoresGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storesV1StoresGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storesV1StoresGet>>,
          TError,
          Awaited<ReturnType<typeof storesV1StoresGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoresV1StoresGet<TData = Awaited<ReturnType<typeof storesV1StoresGet>>, TError = HTTPValidationError>(
 params: StoresV1StoresGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storesV1StoresGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storesV1StoresGet>>,
          TError,
          Awaited<ReturnType<typeof storesV1StoresGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoresV1StoresGet<TData = Awaited<ReturnType<typeof storesV1StoresGet>>, TError = HTTPValidationError>(
 params: StoresV1StoresGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storesV1StoresGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stores
 */

export function useStoresV1StoresGet<TData = Awaited<ReturnType<typeof storesV1StoresGet>>, TError = HTTPValidationError>(
 params: StoresV1StoresGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storesV1StoresGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoresV1StoresGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getWipeStoresV1StoresDeleteUrl = (params: WipeStoresV1StoresDeleteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/stores?${stringifiedParams}` : `/v1/stores`
}

/**
 * **Destructive.** Drop all of a platform's discovered-store data + cache.
 *
 * Empties the store dimension, sightings, lifecycle events, live coverage feed
 * *and* the serviceability cache. A fresh merchant sweep must rediscover every
 * dark store from scratch. Superuser-only.
 * @summary Wipe Stores
 */
export const wipeStoresV1StoresDelete = async (params: WipeStoresV1StoresDeleteParams, options?: Parameters<typeof customFetch>[1]): Promise<WipeResult> => {

  return customFetch<WipeResult>(getWipeStoresV1StoresDeleteUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getWipeStoresV1StoresDeleteMutationKey = () => ['wipeStoresV1StoresDelete'] as const;

export const getWipeStoresV1StoresDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof wipeStoresV1StoresDelete>>, TError,WipeStoresV1StoresDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof wipeStoresV1StoresDelete>>, TError,WipeStoresV1StoresDeleteMutationVariables, TContext> => {

const mutationKey = getWipeStoresV1StoresDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof wipeStoresV1StoresDelete>>, WipeStoresV1StoresDeleteMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  wipeStoresV1StoresDelete(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WipeStoresV1StoresDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof wipeStoresV1StoresDelete>>>

    export type WipeStoresV1StoresDeleteMutationError = HTTPValidationError
    export type WipeStoresV1StoresDeleteMutationVariables = {params: WipeStoresV1StoresDeleteParams}

    /**
 * @summary Wipe Stores
 */
export const useWipeStoresV1StoresDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof wipeStoresV1StoresDelete>>, TError,WipeStoresV1StoresDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof wipeStoresV1StoresDelete>>,
        TError,
        WipeStoresV1StoresDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getWipeStoresV1StoresDeleteMutationOptions(options), queryClient);
    }

export const getWipeStoreCacheV1StoresCacheDeleteUrl = (params: WipeStoreCacheV1StoresCacheDeleteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/stores/cache?${stringifiedParams}` : `/v1/stores/cache`
}

/**
 * **Destructive.** Drop a platform's serviceability cache only (keeps stores).
 *
 * The next sweep re-probes every cell live instead of reusing cached verdicts.
 * Superuser-only.
 * @summary Wipe Store Cache
 */
export const wipeStoreCacheV1StoresCacheDelete = async (params: WipeStoreCacheV1StoresCacheDeleteParams, options?: Parameters<typeof customFetch>[1]): Promise<WipeResult> => {

  return customFetch<WipeResult>(getWipeStoreCacheV1StoresCacheDeleteUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getWipeStoreCacheV1StoresCacheDeleteMutationKey = () => ['wipeStoreCacheV1StoresCacheDelete'] as const;

export const getWipeStoreCacheV1StoresCacheDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof wipeStoreCacheV1StoresCacheDelete>>, TError,WipeStoreCacheV1StoresCacheDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof wipeStoreCacheV1StoresCacheDelete>>, TError,WipeStoreCacheV1StoresCacheDeleteMutationVariables, TContext> => {

const mutationKey = getWipeStoreCacheV1StoresCacheDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof wipeStoreCacheV1StoresCacheDelete>>, WipeStoreCacheV1StoresCacheDeleteMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  wipeStoreCacheV1StoresCacheDelete(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WipeStoreCacheV1StoresCacheDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof wipeStoreCacheV1StoresCacheDelete>>>

    export type WipeStoreCacheV1StoresCacheDeleteMutationError = HTTPValidationError
    export type WipeStoreCacheV1StoresCacheDeleteMutationVariables = {params: WipeStoreCacheV1StoresCacheDeleteParams}

    /**
 * @summary Wipe Store Cache
 */
export const useWipeStoreCacheV1StoresCacheDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof wipeStoreCacheV1StoresCacheDelete>>, TError,WipeStoreCacheV1StoresCacheDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof wipeStoreCacheV1StoresCacheDelete>>,
        TError,
        WipeStoreCacheV1StoresCacheDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getWipeStoreCacheV1StoresCacheDeleteMutationOptions(options), queryClient);
    }

export const getLifecycleV1StoresLifecycleGetUrl = (params: LifecycleV1StoresLifecycleGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/stores/lifecycle?${stringifiedParams}` : `/v1/stores/lifecycle`
}

/**
 * Current store counts by status (``{active|closed: count}``).
 * @summary Lifecycle
 */
export const lifecycleV1StoresLifecycleGet = async (params: LifecycleV1StoresLifecycleGetParams, options?: Parameters<typeof customFetch>[1]): Promise<LifecycleV1StoresLifecycleGet200> => {

  return customFetch<LifecycleV1StoresLifecycleGet200>(getLifecycleV1StoresLifecycleGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLifecycleV1StoresLifecycleGetQueryKey = (params?: LifecycleV1StoresLifecycleGetParams,) => {
    return [
    `/v1/stores/lifecycle`, ...(params ? [params] : [])
    ] as const;
    }


export const getLifecycleV1StoresLifecycleGetQueryOptions = <TData = Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>, TError = HTTPValidationError>(params: LifecycleV1StoresLifecycleGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLifecycleV1StoresLifecycleGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>> = ({ signal }) => lifecycleV1StoresLifecycleGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LifecycleV1StoresLifecycleGetQueryResult = NonNullable<Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>>
export type LifecycleV1StoresLifecycleGetQueryError = HTTPValidationError


export function useLifecycleV1StoresLifecycleGet<TData = Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>, TError = HTTPValidationError>(
 params: LifecycleV1StoresLifecycleGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>,
          TError,
          Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLifecycleV1StoresLifecycleGet<TData = Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>, TError = HTTPValidationError>(
 params: LifecycleV1StoresLifecycleGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>,
          TError,
          Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLifecycleV1StoresLifecycleGet<TData = Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>, TError = HTTPValidationError>(
 params: LifecycleV1StoresLifecycleGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lifecycle
 */

export function useLifecycleV1StoresLifecycleGet<TData = Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>, TError = HTTPValidationError>(
 params: LifecycleV1StoresLifecycleGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lifecycleV1StoresLifecycleGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLifecycleV1StoresLifecycleGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStoreEventsV1StoreEventsGetUrl = (params: StoreEventsV1StoreEventsGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/store-events?${stringifiedParams}` : `/v1/store-events`
}

/**
 * Recent store lifecycle events (added/removed/reactivated), newest first.
 * @summary Store Events
 */
export const storeEventsV1StoreEventsGet = async (params: StoreEventsV1StoreEventsGetParams, options?: Parameters<typeof customFetch>[1]): Promise<StoreEvent[]> => {

  return customFetch<StoreEvent[]>(getStoreEventsV1StoreEventsGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreEventsV1StoreEventsGetQueryKey = (params?: StoreEventsV1StoreEventsGetParams,) => {
    return [
    `/v1/store-events`, ...(params ? [params] : [])
    ] as const;
    }


export const getStoreEventsV1StoreEventsGetQueryOptions = <TData = Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>, TError = HTTPValidationError>(params: StoreEventsV1StoreEventsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreEventsV1StoreEventsGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>> = ({ signal }) => storeEventsV1StoreEventsGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreEventsV1StoreEventsGetQueryResult = NonNullable<Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>>
export type StoreEventsV1StoreEventsGetQueryError = HTTPValidationError


export function useStoreEventsV1StoreEventsGet<TData = Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>, TError = HTTPValidationError>(
 params: StoreEventsV1StoreEventsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>,
          TError,
          Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreEventsV1StoreEventsGet<TData = Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>, TError = HTTPValidationError>(
 params: StoreEventsV1StoreEventsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>,
          TError,
          Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreEventsV1StoreEventsGet<TData = Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>, TError = HTTPValidationError>(
 params: StoreEventsV1StoreEventsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Store Events
 */

export function useStoreEventsV1StoreEventsGet<TData = Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>, TError = HTTPValidationError>(
 params: StoreEventsV1StoreEventsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeEventsV1StoreEventsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreEventsV1StoreEventsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCombinedCoverageMapV1StoresMapGetUrl = () => {




  return `/v1/stores/map`
}

/**
 * All-platforms coverage data for the Stores map, as JSON the frontend renders.
 *
 * Per platform: the serviceable probe-cell centres (``coverage``) plus the active
 * dark stores, each with its serviceable-area hull (``boundary``) and the actual
 * serviceable probe points (``cells``) decoded to ``[lat, lon, role]`` triples - the
 * role is the routing tier (Instamart/Zepto ``primary``/``secondary``) the store served
 * at that cell, sourced from the latest sweep's ``store_coverage`` blobs, so the map can
 * shade a selected store's probe points by where it acts as primary vs secondary (``""``
 * where the platform has no role split, e.g. Blinkit). Read on the fly from ClickHouse
 * so it always reflects the latest sweep; degrades to an empty list when ClickHouse
 * isn't configured or no sweep has run.
 *
 * Carries an ``ETag``: this is a multi-MB body the Stores page re-polls every 30s, but
 * it only changes when a sweep writes, so a matching ``If-None-Match`` gets a bodyless
 * 304 (:func:`_etag_response`). The browser revalidates and serves its cached copy, so
 * an idle page costs one round trip instead of the whole map.
 * @summary Combined Coverage Map
 */
export const combinedCoverageMapV1StoresMapGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<StoresMap> => {

  return customFetch<StoresMap>(getCombinedCoverageMapV1StoresMapGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCombinedCoverageMapV1StoresMapGetQueryKey = () => {
    return [
    `/v1/stores/map`
    ] as const;
    }


export const getCombinedCoverageMapV1StoresMapGetQueryOptions = <TData = Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCombinedCoverageMapV1StoresMapGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>> = ({ signal }) => combinedCoverageMapV1StoresMapGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CombinedCoverageMapV1StoresMapGetQueryResult = NonNullable<Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>>
export type CombinedCoverageMapV1StoresMapGetQueryError = unknown


export function useCombinedCoverageMapV1StoresMapGet<TData = Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>,
          TError,
          Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCombinedCoverageMapV1StoresMapGet<TData = Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>,
          TError,
          Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCombinedCoverageMapV1StoresMapGet<TData = Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Combined Coverage Map
 */

export function useCombinedCoverageMapV1StoresMapGet<TData = Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof combinedCoverageMapV1StoresMapGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCombinedCoverageMapV1StoresMapGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStoreDetailV1StoresPlatformStoreIdGetUrl = (platform: Platform,
    storeId: string,) => {




  return `/v1/stores/${platform}/${storeId}`
}

/**
 * Full detail for one dark store; every column the merchant sweep persists.
 *
 * The serviceable-area hull (``boundary``) is decoded to ``[lat, lon]`` pairs and the
 * probe points (``cells``) to ``[lat, lon, tier]`` (the tier the store served at that
 * cell) ready for Leaflet; ``tiers`` is the store's tier -> probe-point-count mix
 * (:func:`tier_breakdown`); ``eta_map``/``geofence``/``extra`` are returned as the
 * raw JSON strings the platform reported. Also bundles the store's own lifecycle
 * timeline. 404 when the store isn't in the current dimension.
 * @summary Store Detail
 */
export const storeDetailV1StoresPlatformStoreIdGet = async (platform: Platform,
    storeId: string, options?: Parameters<typeof customFetch>[1]): Promise<StoreDetail> => {

  return customFetch<StoreDetail>(getStoreDetailV1StoresPlatformStoreIdGetUrl(platform,storeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getStoreDetailV1StoresPlatformStoreIdGetQueryKey = (platform: Platform,
    storeId: string,) => {
    return [
    `/v1/stores/${platform}/${storeId}`
    ] as const;
    }


export const getStoreDetailV1StoresPlatformStoreIdGetQueryOptions = <TData = Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>, TError = HTTPValidationError>(platform: Platform,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStoreDetailV1StoresPlatformStoreIdGetQueryKey(platform,storeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>> = ({ signal }) => storeDetailV1StoresPlatformStoreIdGet(platform,storeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: platform !== null && platform !== undefined && storeId !== null && storeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StoreDetailV1StoresPlatformStoreIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>>
export type StoreDetailV1StoresPlatformStoreIdGetQueryError = HTTPValidationError


export function useStoreDetailV1StoresPlatformStoreIdGet<TData = Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    storeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>,
          TError,
          Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreDetailV1StoresPlatformStoreIdGet<TData = Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>,
          TError,
          Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStoreDetailV1StoresPlatformStoreIdGet<TData = Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Store Detail
 */

export function useStoreDetailV1StoresPlatformStoreIdGet<TData = Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    storeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof storeDetailV1StoresPlatformStoreIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStoreDetailV1StoresPlatformStoreIdGetQueryOptions(platform,storeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExcludeStoreV1StoresPlatformStoreIdExcludePostUrl = (platform: Platform,
    storeId: string,) => {




  return `/v1/stores/${platform}/${storeId}/exclude`
}

/**
 * Stop counting one store: set the sticky exclusion flag on its dimension row.
 *
 * Superuser-only. It is reversible and audited, but it silently changes what every
 * availability and price number on the site means, so it sits with the other actions
 * that reshape a platform's data rather than with day-to-day operator work.
 *
 * From the next query onward the store is out of every run scope and every market-level
 * rollup, while its dimension row stays and keeps refreshing -- so the merchant sweep
 * still tracks whether it is open, and this page still shows it with its reason. Not a
 * lifecycle change: ``status`` is untouched. See
 * :mod:`qcs.core.storage.clickhouse.store_exclusion`.
 *
 * 409 when the store is already excluded, so a double-click cannot silently overwrite
 * the reason recorded the first time.
 * @summary Exclude Store
 */
export const excludeStoreV1StoresPlatformStoreIdExcludePost = async (platform: Platform,
    storeId: string,
    storeExcludeRequest: StoreExcludeRequest, options?: Parameters<typeof customFetch>[1]): Promise<StoreExclusionResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<StoreExclusionResult>(getExcludeStoreV1StoresPlatformStoreIdExcludePostUrl(platform,storeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(storeExcludeRequest)
  }
);}





export const getExcludeStoreV1StoresPlatformStoreIdExcludePostMutationKey = () => ['excludeStoreV1StoresPlatformStoreIdExcludePost'] as const;

export const getExcludeStoreV1StoresPlatformStoreIdExcludePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof excludeStoreV1StoresPlatformStoreIdExcludePost>>, TError,ExcludeStoreV1StoresPlatformStoreIdExcludePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof excludeStoreV1StoresPlatformStoreIdExcludePost>>, TError,ExcludeStoreV1StoresPlatformStoreIdExcludePostMutationVariables, TContext> => {

const mutationKey = getExcludeStoreV1StoresPlatformStoreIdExcludePostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof excludeStoreV1StoresPlatformStoreIdExcludePost>>, ExcludeStoreV1StoresPlatformStoreIdExcludePostMutationVariables> = (props) => {
          const {platform,storeId,data} = props ?? {};

          return  excludeStoreV1StoresPlatformStoreIdExcludePost(platform,storeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExcludeStoreV1StoresPlatformStoreIdExcludePostMutationResult = NonNullable<Awaited<ReturnType<typeof excludeStoreV1StoresPlatformStoreIdExcludePost>>>
    export type ExcludeStoreV1StoresPlatformStoreIdExcludePostMutationBody = StoreExcludeRequest
    export type ExcludeStoreV1StoresPlatformStoreIdExcludePostMutationError = HTTPValidationError
    export type ExcludeStoreV1StoresPlatformStoreIdExcludePostMutationVariables = {platform: Platform;storeId: string;data: StoreExcludeRequest}

    /**
 * @summary Exclude Store
 */
export const useExcludeStoreV1StoresPlatformStoreIdExcludePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof excludeStoreV1StoresPlatformStoreIdExcludePost>>, TError,ExcludeStoreV1StoresPlatformStoreIdExcludePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof excludeStoreV1StoresPlatformStoreIdExcludePost>>,
        TError,
        ExcludeStoreV1StoresPlatformStoreIdExcludePostMutationVariables,
        TContext
      > => {
      return useMutation(getExcludeStoreV1StoresPlatformStoreIdExcludePostMutationOptions(options), queryClient);
    }

export const getReadmitStoreV1StoresPlatformStoreIdReadmitPostUrl = (platform: Platform,
    storeId: string,) => {




  return `/v1/stores/${platform}/${storeId}/readmit`
}

/**
 * Undo :func:`exclude_store`; count this store's readings again.
 *
 * Clears the reason along with the flag. 409 when the store was not excluded.
 * @summary Readmit Store
 */
export const readmitStoreV1StoresPlatformStoreIdReadmitPost = async (platform: Platform,
    storeId: string, options?: Parameters<typeof customFetch>[1]): Promise<StoreExclusionResult> => {

  return customFetch<StoreExclusionResult>(getReadmitStoreV1StoresPlatformStoreIdReadmitPostUrl(platform,storeId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReadmitStoreV1StoresPlatformStoreIdReadmitPostMutationKey = () => ['readmitStoreV1StoresPlatformStoreIdReadmitPost'] as const;

export const getReadmitStoreV1StoresPlatformStoreIdReadmitPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readmitStoreV1StoresPlatformStoreIdReadmitPost>>, TError,ReadmitStoreV1StoresPlatformStoreIdReadmitPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof readmitStoreV1StoresPlatformStoreIdReadmitPost>>, TError,ReadmitStoreV1StoresPlatformStoreIdReadmitPostMutationVariables, TContext> => {

const mutationKey = getReadmitStoreV1StoresPlatformStoreIdReadmitPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof readmitStoreV1StoresPlatformStoreIdReadmitPost>>, ReadmitStoreV1StoresPlatformStoreIdReadmitPostMutationVariables> = (props) => {
          const {platform,storeId} = props ?? {};

          return  readmitStoreV1StoresPlatformStoreIdReadmitPost(platform,storeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReadmitStoreV1StoresPlatformStoreIdReadmitPostMutationResult = NonNullable<Awaited<ReturnType<typeof readmitStoreV1StoresPlatformStoreIdReadmitPost>>>

    export type ReadmitStoreV1StoresPlatformStoreIdReadmitPostMutationError = HTTPValidationError
    export type ReadmitStoreV1StoresPlatformStoreIdReadmitPostMutationVariables = {platform: Platform;storeId: string}

    /**
 * @summary Readmit Store
 */
export const useReadmitStoreV1StoresPlatformStoreIdReadmitPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readmitStoreV1StoresPlatformStoreIdReadmitPost>>, TError,ReadmitStoreV1StoresPlatformStoreIdReadmitPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof readmitStoreV1StoresPlatformStoreIdReadmitPost>>,
        TError,
        ReadmitStoreV1StoresPlatformStoreIdReadmitPostMutationVariables,
        TContext
      > => {
      return useMutation(getReadmitStoreV1StoresPlatformStoreIdReadmitPostMutationOptions(options), queryClient);
    }

export const getLaunchTaxonomyClassifyV1TaxonomyClassifyPostUrl = () => {




  return `/v1/taxonomy/classify`
}

/**
 * Launch an ad-hoc taxonomy classify run (planning/47).
 *
 * ``platform`` omitted => fan out one run per platform. Four operator job types map onto this
 * one endpoint: classify-missing/stale-now (``mode=missing``), full-reclassify (``mode=all``),
 * reclassify-one-brand (``brand``), and reclassify-a-node-subtree (``emphasis_node_id``,
 * ``mode=all`` -- a full pass, the node is a prompt hint not a candidate filter). A busy
 * platform (a run already live for that scope) is a per-platform skip, never a hard failure.
 * @summary Launch Taxonomy Classify
 */
export const launchTaxonomyClassifyV1TaxonomyClassifyPost = async (taxonomyClassifyLaunch: TaxonomyClassifyLaunch, options?: Parameters<typeof customFetch>[1]): Promise<TaxonomyClassifyLaunchResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<TaxonomyClassifyLaunchResult>(getLaunchTaxonomyClassifyV1TaxonomyClassifyPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(taxonomyClassifyLaunch)
  }
);}





export const getLaunchTaxonomyClassifyV1TaxonomyClassifyPostMutationKey = () => ['launchTaxonomyClassifyV1TaxonomyClassifyPost'] as const;

export const getLaunchTaxonomyClassifyV1TaxonomyClassifyPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchTaxonomyClassifyV1TaxonomyClassifyPost>>, TError,LaunchTaxonomyClassifyV1TaxonomyClassifyPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof launchTaxonomyClassifyV1TaxonomyClassifyPost>>, TError,LaunchTaxonomyClassifyV1TaxonomyClassifyPostMutationVariables, TContext> => {

const mutationKey = getLaunchTaxonomyClassifyV1TaxonomyClassifyPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof launchTaxonomyClassifyV1TaxonomyClassifyPost>>, LaunchTaxonomyClassifyV1TaxonomyClassifyPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  launchTaxonomyClassifyV1TaxonomyClassifyPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LaunchTaxonomyClassifyV1TaxonomyClassifyPostMutationResult = NonNullable<Awaited<ReturnType<typeof launchTaxonomyClassifyV1TaxonomyClassifyPost>>>
    export type LaunchTaxonomyClassifyV1TaxonomyClassifyPostMutationBody = TaxonomyClassifyLaunch
    export type LaunchTaxonomyClassifyV1TaxonomyClassifyPostMutationError = HTTPValidationError
    export type LaunchTaxonomyClassifyV1TaxonomyClassifyPostMutationVariables = {data: TaxonomyClassifyLaunch}

    /**
 * @summary Launch Taxonomy Classify
 */
export const useLaunchTaxonomyClassifyV1TaxonomyClassifyPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchTaxonomyClassifyV1TaxonomyClassifyPost>>, TError,LaunchTaxonomyClassifyV1TaxonomyClassifyPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof launchTaxonomyClassifyV1TaxonomyClassifyPost>>,
        TError,
        LaunchTaxonomyClassifyV1TaxonomyClassifyPostMutationVariables,
        TContext
      > => {
      return useMutation(getLaunchTaxonomyClassifyV1TaxonomyClassifyPostMutationOptions(options), queryClient);
    }

export const getGetVersionV1TaxonomyVersionGetUrl = () => {




  return `/v1/taxonomy/version`
}

/**
 * @summary Get Version
 */
export const getVersionV1TaxonomyVersionGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<TaxonomyVersionOut> => {

  return customFetch<TaxonomyVersionOut>(getGetVersionV1TaxonomyVersionGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVersionV1TaxonomyVersionGetQueryKey = () => {
    return [
    `/v1/taxonomy/version`
    ] as const;
    }


export const getGetVersionV1TaxonomyVersionGetQueryOptions = <TData = Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVersionV1TaxonomyVersionGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>> = ({ signal }) => getVersionV1TaxonomyVersionGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVersionV1TaxonomyVersionGetQueryResult = NonNullable<Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>>
export type GetVersionV1TaxonomyVersionGetQueryError = unknown


export function useGetVersionV1TaxonomyVersionGet<TData = Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>,
          TError,
          Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersionV1TaxonomyVersionGet<TData = Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>,
          TError,
          Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersionV1TaxonomyVersionGet<TData = Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Version
 */

export function useGetVersionV1TaxonomyVersionGet<TData = Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersionV1TaxonomyVersionGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVersionV1TaxonomyVersionGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListNodesV1TaxonomyNodesGetUrl = () => {




  return `/v1/taxonomy/nodes`
}

/**
 * Flat node list (the frontend nests by ``parent_id``), stable tree order.
 * @summary List Nodes
 */
export const listNodesV1TaxonomyNodesGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<TaxonomyNodeOut[]> => {

  return customFetch<TaxonomyNodeOut[]>(getListNodesV1TaxonomyNodesGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNodesV1TaxonomyNodesGetQueryKey = () => {
    return [
    `/v1/taxonomy/nodes`
    ] as const;
    }


export const getListNodesV1TaxonomyNodesGetQueryOptions = <TData = Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNodesV1TaxonomyNodesGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>> = ({ signal }) => listNodesV1TaxonomyNodesGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNodesV1TaxonomyNodesGetQueryResult = NonNullable<Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>>
export type ListNodesV1TaxonomyNodesGetQueryError = unknown


export function useListNodesV1TaxonomyNodesGet<TData = Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>,
          TError,
          Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNodesV1TaxonomyNodesGet<TData = Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>,
          TError,
          Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNodesV1TaxonomyNodesGet<TData = Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Nodes
 */

export function useListNodesV1TaxonomyNodesGet<TData = Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNodesV1TaxonomyNodesGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNodesV1TaxonomyNodesGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateNodeV1TaxonomyNodesPostUrl = () => {




  return `/v1/taxonomy/nodes`
}

/**
 * @summary Create Node
 */
export const createNodeV1TaxonomyNodesPost = async (taxonomyNodeCreate: TaxonomyNodeCreate, options?: Parameters<typeof customFetch>[1]): Promise<TaxonomyNodeOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<TaxonomyNodeOut>(getCreateNodeV1TaxonomyNodesPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(taxonomyNodeCreate)
  }
);}





export const getCreateNodeV1TaxonomyNodesPostMutationKey = () => ['createNodeV1TaxonomyNodesPost'] as const;

export const getCreateNodeV1TaxonomyNodesPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNodeV1TaxonomyNodesPost>>, TError,CreateNodeV1TaxonomyNodesPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createNodeV1TaxonomyNodesPost>>, TError,CreateNodeV1TaxonomyNodesPostMutationVariables, TContext> => {

const mutationKey = getCreateNodeV1TaxonomyNodesPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNodeV1TaxonomyNodesPost>>, CreateNodeV1TaxonomyNodesPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createNodeV1TaxonomyNodesPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNodeV1TaxonomyNodesPostMutationResult = NonNullable<Awaited<ReturnType<typeof createNodeV1TaxonomyNodesPost>>>
    export type CreateNodeV1TaxonomyNodesPostMutationBody = TaxonomyNodeCreate
    export type CreateNodeV1TaxonomyNodesPostMutationError = HTTPValidationError
    export type CreateNodeV1TaxonomyNodesPostMutationVariables = {data: TaxonomyNodeCreate}

    /**
 * @summary Create Node
 */
export const useCreateNodeV1TaxonomyNodesPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNodeV1TaxonomyNodesPost>>, TError,CreateNodeV1TaxonomyNodesPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createNodeV1TaxonomyNodesPost>>,
        TError,
        CreateNodeV1TaxonomyNodesPostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateNodeV1TaxonomyNodesPostMutationOptions(options), queryClient);
    }

export const getUpdateNodeV1TaxonomyNodesNodeIdPatchUrl = (nodeId: string,) => {




  return `/v1/taxonomy/nodes/${nodeId}`
}

/**
 * @summary Update Node
 */
export const updateNodeV1TaxonomyNodesNodeIdPatch = async (nodeId: string,
    taxonomyNodePatch: TaxonomyNodePatch, options?: Parameters<typeof customFetch>[1]): Promise<TaxonomyNodeOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<TaxonomyNodeOut>(getUpdateNodeV1TaxonomyNodesNodeIdPatchUrl(nodeId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(taxonomyNodePatch)
  }
);}





export const getUpdateNodeV1TaxonomyNodesNodeIdPatchMutationKey = () => ['updateNodeV1TaxonomyNodesNodeIdPatch'] as const;

export const getUpdateNodeV1TaxonomyNodesNodeIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNodeV1TaxonomyNodesNodeIdPatch>>, TError,UpdateNodeV1TaxonomyNodesNodeIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNodeV1TaxonomyNodesNodeIdPatch>>, TError,UpdateNodeV1TaxonomyNodesNodeIdPatchMutationVariables, TContext> => {

const mutationKey = getUpdateNodeV1TaxonomyNodesNodeIdPatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNodeV1TaxonomyNodesNodeIdPatch>>, UpdateNodeV1TaxonomyNodesNodeIdPatchMutationVariables> = (props) => {
          const {nodeId,data} = props ?? {};

          return  updateNodeV1TaxonomyNodesNodeIdPatch(nodeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNodeV1TaxonomyNodesNodeIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateNodeV1TaxonomyNodesNodeIdPatch>>>
    export type UpdateNodeV1TaxonomyNodesNodeIdPatchMutationBody = TaxonomyNodePatch
    export type UpdateNodeV1TaxonomyNodesNodeIdPatchMutationError = HTTPValidationError
    export type UpdateNodeV1TaxonomyNodesNodeIdPatchMutationVariables = {nodeId: string;data: TaxonomyNodePatch}

    /**
 * @summary Update Node
 */
export const useUpdateNodeV1TaxonomyNodesNodeIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNodeV1TaxonomyNodesNodeIdPatch>>, TError,UpdateNodeV1TaxonomyNodesNodeIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateNodeV1TaxonomyNodesNodeIdPatch>>,
        TError,
        UpdateNodeV1TaxonomyNodesNodeIdPatchMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateNodeV1TaxonomyNodesNodeIdPatchMutationOptions(options), queryClient);
    }

export const getDeleteNodeV1TaxonomyNodesNodeIdDeleteUrl = (nodeId: string,
    params?: DeleteNodeV1TaxonomyNodesNodeIdDeleteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/taxonomy/nodes/${nodeId}?${stringifiedParams}` : `/v1/taxonomy/nodes/${nodeId}`
}

/**
 * @summary Delete Node
 */
export const deleteNodeV1TaxonomyNodesNodeIdDelete = async (nodeId: string,
    params?: DeleteNodeV1TaxonomyNodesNodeIdDeleteParams, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteNodeV1TaxonomyNodesNodeIdDeleteUrl(nodeId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteNodeV1TaxonomyNodesNodeIdDeleteMutationKey = () => ['deleteNodeV1TaxonomyNodesNodeIdDelete'] as const;

export const getDeleteNodeV1TaxonomyNodesNodeIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNodeV1TaxonomyNodesNodeIdDelete>>, TError,DeleteNodeV1TaxonomyNodesNodeIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNodeV1TaxonomyNodesNodeIdDelete>>, TError,DeleteNodeV1TaxonomyNodesNodeIdDeleteMutationVariables, TContext> => {

const mutationKey = getDeleteNodeV1TaxonomyNodesNodeIdDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNodeV1TaxonomyNodesNodeIdDelete>>, DeleteNodeV1TaxonomyNodesNodeIdDeleteMutationVariables> = (props) => {
          const {nodeId,params} = props ?? {};

          return  deleteNodeV1TaxonomyNodesNodeIdDelete(nodeId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteNodeV1TaxonomyNodesNodeIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNodeV1TaxonomyNodesNodeIdDelete>>>

    export type DeleteNodeV1TaxonomyNodesNodeIdDeleteMutationError = HTTPValidationError
    export type DeleteNodeV1TaxonomyNodesNodeIdDeleteMutationVariables = {nodeId: string;params?: DeleteNodeV1TaxonomyNodesNodeIdDeleteParams}

    /**
 * @summary Delete Node
 */
export const useDeleteNodeV1TaxonomyNodesNodeIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNodeV1TaxonomyNodesNodeIdDelete>>, TError,DeleteNodeV1TaxonomyNodesNodeIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNodeV1TaxonomyNodesNodeIdDelete>>,
        TError,
        DeleteNodeV1TaxonomyNodesNodeIdDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteNodeV1TaxonomyNodesNodeIdDeleteMutationOptions(options), queryClient);
    }

export const getExportTreeV1TaxonomyExportGetUrl = () => {




  return `/v1/taxonomy/export`
}

/**
 * @summary Export Tree
 */
export const exportTreeV1TaxonomyExportGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {

  return customFetch<unknown>(getExportTreeV1TaxonomyExportGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportTreeV1TaxonomyExportGetQueryKey = () => {
    return [
    `/v1/taxonomy/export`
    ] as const;
    }


export const getExportTreeV1TaxonomyExportGetQueryOptions = <TData = Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportTreeV1TaxonomyExportGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>> = ({ signal }) => exportTreeV1TaxonomyExportGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportTreeV1TaxonomyExportGetQueryResult = NonNullable<Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>>
export type ExportTreeV1TaxonomyExportGetQueryError = unknown


export function useExportTreeV1TaxonomyExportGet<TData = Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>,
          TError,
          Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportTreeV1TaxonomyExportGet<TData = Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>,
          TError,
          Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportTreeV1TaxonomyExportGet<TData = Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export Tree
 */

export function useExportTreeV1TaxonomyExportGet<TData = Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTreeV1TaxonomyExportGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportTreeV1TaxonomyExportGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getImportTreeV1TaxonomyImportPostUrl = (params?: ImportTreeV1TaxonomyImportPostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/taxonomy/import?${stringifiedParams}` : `/v1/taxonomy/import`
}

/**
 * Upsert nodes from a CSV, matched on the full path (ancestors auto-created).
 *
 * Accepts a ``path`` column (``" > "``-joined) or a legacy
 * ``section/category/subcategory`` triple. Existing paths are updated in place
 * (UUID preserved); missing paths are created. Never deletes. ``dry_run`` (default)
 * reports the diff without writing.
 * @summary Import Tree
 */
export const importTreeV1TaxonomyImportPost = async (bodyImportTreeV1TaxonomyImportPost: BodyImportTreeV1TaxonomyImportPost,
    params?: ImportTreeV1TaxonomyImportPostParams, options?: Parameters<typeof customFetch>[1]): Promise<TaxonomyImportResult> => {
    const formData = new FormData();
formData.append(`file`, bodyImportTreeV1TaxonomyImportPost.file);

  return customFetch<TaxonomyImportResult>(getImportTreeV1TaxonomyImportPostUrl(params),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getImportTreeV1TaxonomyImportPostMutationKey = () => ['importTreeV1TaxonomyImportPost'] as const;

export const getImportTreeV1TaxonomyImportPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTreeV1TaxonomyImportPost>>, TError,ImportTreeV1TaxonomyImportPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importTreeV1TaxonomyImportPost>>, TError,ImportTreeV1TaxonomyImportPostMutationVariables, TContext> => {

const mutationKey = getImportTreeV1TaxonomyImportPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importTreeV1TaxonomyImportPost>>, ImportTreeV1TaxonomyImportPostMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  importTreeV1TaxonomyImportPost(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportTreeV1TaxonomyImportPostMutationResult = NonNullable<Awaited<ReturnType<typeof importTreeV1TaxonomyImportPost>>>
    export type ImportTreeV1TaxonomyImportPostMutationBody = BodyImportTreeV1TaxonomyImportPost
    export type ImportTreeV1TaxonomyImportPostMutationError = HTTPValidationError
    export type ImportTreeV1TaxonomyImportPostMutationVariables = {data: BodyImportTreeV1TaxonomyImportPost;params?: ImportTreeV1TaxonomyImportPostParams}

    /**
 * @summary Import Tree
 */
export const useImportTreeV1TaxonomyImportPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTreeV1TaxonomyImportPost>>, TError,ImportTreeV1TaxonomyImportPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importTreeV1TaxonomyImportPost>>,
        TError,
        ImportTreeV1TaxonomyImportPostMutationVariables,
        TContext
      > => {
      return useMutation(getImportTreeV1TaxonomyImportPostMutationOptions(options), queryClient);
    }

export const getTaxonomySummaryV1TaxonomySummaryGetUrl = () => {




  return `/v1/taxonomy/summary`
}

/**
 * Per-platform + combined SKU counts per root (ClickHouse; degrades to empty).
 * @summary Taxonomy Summary
 */
export const taxonomySummaryV1TaxonomySummaryGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<TaxonomySummaryOut> => {

  return customFetch<TaxonomySummaryOut>(getTaxonomySummaryV1TaxonomySummaryGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTaxonomySummaryV1TaxonomySummaryGetQueryKey = () => {
    return [
    `/v1/taxonomy/summary`
    ] as const;
    }


export const getTaxonomySummaryV1TaxonomySummaryGetQueryOptions = <TData = Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTaxonomySummaryV1TaxonomySummaryGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>> = ({ signal }) => taxonomySummaryV1TaxonomySummaryGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TaxonomySummaryV1TaxonomySummaryGetQueryResult = NonNullable<Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>>
export type TaxonomySummaryV1TaxonomySummaryGetQueryError = unknown


export function useTaxonomySummaryV1TaxonomySummaryGet<TData = Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>,
          TError,
          Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaxonomySummaryV1TaxonomySummaryGet<TData = Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>,
          TError,
          Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTaxonomySummaryV1TaxonomySummaryGet<TData = Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Taxonomy Summary
 */

export function useTaxonomySummaryV1TaxonomySummaryGet<TData = Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof taxonomySummaryV1TaxonomySummaryGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTaxonomySummaryV1TaxonomySummaryGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReviewSkusV1TaxonomySkusGetUrl = (params: ReviewSkusV1TaxonomySkusGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/taxonomy/skus?${stringifiedParams}` : `/v1/taxonomy/skus`
}

/**
 * The review queue: labelled SKUs, lowest-confidence first (ClickHouse).
 * @summary Review Skus
 */
export const reviewSkusV1TaxonomySkusGet = async (params: ReviewSkusV1TaxonomySkusGetParams, options?: Parameters<typeof customFetch>[1]): Promise<TaxonomyReviewRow[]> => {

  return customFetch<TaxonomyReviewRow[]>(getReviewSkusV1TaxonomySkusGetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReviewSkusV1TaxonomySkusGetQueryKey = (params?: ReviewSkusV1TaxonomySkusGetParams,) => {
    return [
    `/v1/taxonomy/skus`, ...(params ? [params] : [])
    ] as const;
    }


export const getReviewSkusV1TaxonomySkusGetQueryOptions = <TData = Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>, TError = HTTPValidationError>(params: ReviewSkusV1TaxonomySkusGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReviewSkusV1TaxonomySkusGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>> = ({ signal }) => reviewSkusV1TaxonomySkusGet(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReviewSkusV1TaxonomySkusGetQueryResult = NonNullable<Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>>
export type ReviewSkusV1TaxonomySkusGetQueryError = HTTPValidationError


export function useReviewSkusV1TaxonomySkusGet<TData = Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>, TError = HTTPValidationError>(
 params: ReviewSkusV1TaxonomySkusGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>,
          TError,
          Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReviewSkusV1TaxonomySkusGet<TData = Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>, TError = HTTPValidationError>(
 params: ReviewSkusV1TaxonomySkusGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>,
          TError,
          Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReviewSkusV1TaxonomySkusGet<TData = Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>, TError = HTTPValidationError>(
 params: ReviewSkusV1TaxonomySkusGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Review Skus
 */

export function useReviewSkusV1TaxonomySkusGet<TData = Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>, TError = HTTPValidationError>(
 params: ReviewSkusV1TaxonomySkusGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reviewSkusV1TaxonomySkusGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReviewSkusV1TaxonomySkusGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSkuLabelV1TaxonomySkusPlatformProductIdGetUrl = (platform: Platform,
    productId: string,) => {




  return `/v1/taxonomy/skus/${platform}/${productId}`
}

/**
 * The current taxonomy label for one SKU (override wins).
 * @summary Get Sku Label
 */
export const getSkuLabelV1TaxonomySkusPlatformProductIdGet = async (platform: Platform,
    productId: string, options?: Parameters<typeof customFetch>[1]): Promise<TaxonomyLabelOut> => {

  return customFetch<TaxonomyLabelOut>(getGetSkuLabelV1TaxonomySkusPlatformProductIdGetUrl(platform,productId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSkuLabelV1TaxonomySkusPlatformProductIdGetQueryKey = (platform: Platform,
    productId: string,) => {
    return [
    `/v1/taxonomy/skus/${platform}/${productId}`
    ] as const;
    }


export const getGetSkuLabelV1TaxonomySkusPlatformProductIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>, TError = HTTPValidationError>(platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSkuLabelV1TaxonomySkusPlatformProductIdGetQueryKey(platform,productId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>> = ({ signal }) => getSkuLabelV1TaxonomySkusPlatformProductIdGet(platform,productId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: platform !== null && platform !== undefined && productId !== null && productId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSkuLabelV1TaxonomySkusPlatformProductIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>>
export type GetSkuLabelV1TaxonomySkusPlatformProductIdGetQueryError = HTTPValidationError


export function useGetSkuLabelV1TaxonomySkusPlatformProductIdGet<TData = Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>,
          TError,
          Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSkuLabelV1TaxonomySkusPlatformProductIdGet<TData = Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>,
          TError,
          Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSkuLabelV1TaxonomySkusPlatformProductIdGet<TData = Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Sku Label
 */

export function useGetSkuLabelV1TaxonomySkusPlatformProductIdGet<TData = Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>, TError = HTTPValidationError>(
 platform: Platform,
    productId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSkuLabelV1TaxonomySkusPlatformProductIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSkuLabelV1TaxonomySkusPlatformProductIdGetQueryOptions(platform,productId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetOverrideV1TaxonomySkusPlatformProductIdOverridePostUrl = (platform: Platform,
    productId: string,) => {




  return `/v1/taxonomy/skus/${platform}/${productId}/override`
}

/**
 * Set a sticky human override (Postgres) + mirror it to ClickHouse (dominating version).
 * @summary Set Override
 */
export const setOverrideV1TaxonomySkusPlatformProductIdOverridePost = async (platform: Platform,
    productId: string,
    taxonomyOverrideIn: TaxonomyOverrideIn, options?: Parameters<typeof customFetch>[1]): Promise<TaxonomyLabelOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<TaxonomyLabelOut>(getSetOverrideV1TaxonomySkusPlatformProductIdOverridePostUrl(platform,productId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(taxonomyOverrideIn)
  }
);}





export const getSetOverrideV1TaxonomySkusPlatformProductIdOverridePostMutationKey = () => ['setOverrideV1TaxonomySkusPlatformProductIdOverridePost'] as const;

export const getSetOverrideV1TaxonomySkusPlatformProductIdOverridePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOverrideV1TaxonomySkusPlatformProductIdOverridePost>>, TError,SetOverrideV1TaxonomySkusPlatformProductIdOverridePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setOverrideV1TaxonomySkusPlatformProductIdOverridePost>>, TError,SetOverrideV1TaxonomySkusPlatformProductIdOverridePostMutationVariables, TContext> => {

const mutationKey = getSetOverrideV1TaxonomySkusPlatformProductIdOverridePostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setOverrideV1TaxonomySkusPlatformProductIdOverridePost>>, SetOverrideV1TaxonomySkusPlatformProductIdOverridePostMutationVariables> = (props) => {
          const {platform,productId,data} = props ?? {};

          return  setOverrideV1TaxonomySkusPlatformProductIdOverridePost(platform,productId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetOverrideV1TaxonomySkusPlatformProductIdOverridePostMutationResult = NonNullable<Awaited<ReturnType<typeof setOverrideV1TaxonomySkusPlatformProductIdOverridePost>>>
    export type SetOverrideV1TaxonomySkusPlatformProductIdOverridePostMutationBody = TaxonomyOverrideIn
    export type SetOverrideV1TaxonomySkusPlatformProductIdOverridePostMutationError = HTTPValidationError
    export type SetOverrideV1TaxonomySkusPlatformProductIdOverridePostMutationVariables = {platform: Platform;productId: string;data: TaxonomyOverrideIn}

    /**
 * @summary Set Override
 */
export const useSetOverrideV1TaxonomySkusPlatformProductIdOverridePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOverrideV1TaxonomySkusPlatformProductIdOverridePost>>, TError,SetOverrideV1TaxonomySkusPlatformProductIdOverridePostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setOverrideV1TaxonomySkusPlatformProductIdOverridePost>>,
        TError,
        SetOverrideV1TaxonomySkusPlatformProductIdOverridePostMutationVariables,
        TContext
      > => {
      return useMutation(getSetOverrideV1TaxonomySkusPlatformProductIdOverridePostMutationOptions(options), queryClient);
    }

export const getClearOverrideV1TaxonomySkusPlatformProductIdOverrideDeleteUrl = (platform: Platform,
    productId: string,) => {




  return `/v1/taxonomy/skus/${platform}/${productId}/override`
}

/**
 * Clear a human override (delete the PG row + the dominating CH row), then reclassify.
 * @summary Clear Override
 */
export const clearOverrideV1TaxonomySkusPlatformProductIdOverrideDelete = async (platform: Platform,
    productId: string, options?: Parameters<typeof customFetch>[1]): Promise<TaxonomyLabelOut> => {

  return customFetch<TaxonomyLabelOut>(getClearOverrideV1TaxonomySkusPlatformProductIdOverrideDeleteUrl(platform,productId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearOverrideV1TaxonomySkusPlatformProductIdOverrideDeleteMutationKey = () => ['clearOverrideV1TaxonomySkusPlatformProductIdOverrideDelete'] as const;

export const getClearOverrideV1TaxonomySkusPlatformProductIdOverrideDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearOverrideV1TaxonomySkusPlatformProductIdOverrideDelete>>, TError,ClearOverrideV1TaxonomySkusPlatformProductIdOverrideDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof clearOverrideV1TaxonomySkusPlatformProductIdOverrideDelete>>, TError,ClearOverrideV1TaxonomySkusPlatformProductIdOverrideDeleteMutationVariables, TContext> => {

const mutationKey = getClearOverrideV1TaxonomySkusPlatformProductIdOverrideDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearOverrideV1TaxonomySkusPlatformProductIdOverrideDelete>>, ClearOverrideV1TaxonomySkusPlatformProductIdOverrideDeleteMutationVariables> = (props) => {
          const {platform,productId} = props ?? {};

          return  clearOverrideV1TaxonomySkusPlatformProductIdOverrideDelete(platform,productId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearOverrideV1TaxonomySkusPlatformProductIdOverrideDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof clearOverrideV1TaxonomySkusPlatformProductIdOverrideDelete>>>

    export type ClearOverrideV1TaxonomySkusPlatformProductIdOverrideDeleteMutationError = HTTPValidationError
    export type ClearOverrideV1TaxonomySkusPlatformProductIdOverrideDeleteMutationVariables = {platform: Platform;productId: string}

    /**
 * @summary Clear Override
 */
export const useClearOverrideV1TaxonomySkusPlatformProductIdOverrideDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearOverrideV1TaxonomySkusPlatformProductIdOverrideDelete>>, TError,ClearOverrideV1TaxonomySkusPlatformProductIdOverrideDeleteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearOverrideV1TaxonomySkusPlatformProductIdOverrideDelete>>,
        TError,
        ClearOverrideV1TaxonomySkusPlatformProductIdOverrideDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getClearOverrideV1TaxonomySkusPlatformProductIdOverrideDeleteMutationOptions(options), queryClient);
    }

export const getReclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPostUrl = (platform: Platform,
    productId: string,) => {




  return `/v1/taxonomy/skus/${platform}/${productId}/reclassify`
}

/**
 * Reclassify a single SKU with the LLM now (rejected while an override is set).
 * @summary Reclassify Sku
 */
export const reclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPost = async (platform: Platform,
    productId: string, options?: Parameters<typeof customFetch>[1]): Promise<TaxonomyLabelOut> => {

  return customFetch<TaxonomyLabelOut>(getReclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPostUrl(platform,productId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPostMutationKey = () => ['reclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPost'] as const;

export const getReclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPost>>, TError,ReclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPost>>, TError,ReclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPostMutationVariables, TContext> => {

const mutationKey = getReclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPost>>, ReclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPostMutationVariables> = (props) => {
          const {platform,productId} = props ?? {};

          return  reclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPost(platform,productId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPostMutationResult = NonNullable<Awaited<ReturnType<typeof reclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPost>>>

    export type ReclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPostMutationError = HTTPValidationError
    export type ReclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPostMutationVariables = {platform: Platform;productId: string}

    /**
 * @summary Reclassify Sku
 */
export const useReclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPost>>, TError,ReclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPost>>,
        TError,
        ReclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPostMutationVariables,
        TContext
      > => {
      return useMutation(getReclassifySkuV1TaxonomySkusPlatformProductIdReclassifyPostMutationOptions(options), queryClient);
    }

export const getCatalogV1SnapshotsCatalogGetUrl = () => {




  return `/v1/snapshots/catalog`
}

/**
 * The dataset catalog + presets (drives the Export panel's checkboxes).
 * @summary Catalog
 */
export const catalogV1SnapshotsCatalogGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<CatalogOut> => {

  return customFetch<CatalogOut>(getCatalogV1SnapshotsCatalogGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogV1SnapshotsCatalogGetQueryKey = () => {
    return [
    `/v1/snapshots/catalog`
    ] as const;
    }


export const getCatalogV1SnapshotsCatalogGetQueryOptions = <TData = Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogV1SnapshotsCatalogGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>> = ({ signal }) => catalogV1SnapshotsCatalogGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogV1SnapshotsCatalogGetQueryResult = NonNullable<Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>>
export type CatalogV1SnapshotsCatalogGetQueryError = unknown


export function useCatalogV1SnapshotsCatalogGet<TData = Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>,
          TError,
          Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogV1SnapshotsCatalogGet<TData = Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>,
          TError,
          Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogV1SnapshotsCatalogGet<TData = Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Catalog
 */

export function useCatalogV1SnapshotsCatalogGet<TData = Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogV1SnapshotsCatalogGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogV1SnapshotsCatalogGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSnapshotsV1SnapshotsGetUrl = () => {




  return `/v1/snapshots`
}

/**
 * History: every export/import job, newest first (the audit trail).
 * @summary List Snapshots
 */
export const listSnapshotsV1SnapshotsGet = async ( options?: Parameters<typeof customFetch>[1]): Promise<SnapshotOut[]> => {

  return customFetch<SnapshotOut[]>(getListSnapshotsV1SnapshotsGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSnapshotsV1SnapshotsGetQueryKey = () => {
    return [
    `/v1/snapshots`
    ] as const;
    }


export const getListSnapshotsV1SnapshotsGetQueryOptions = <TData = Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSnapshotsV1SnapshotsGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>> = ({ signal }) => listSnapshotsV1SnapshotsGet({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSnapshotsV1SnapshotsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>>
export type ListSnapshotsV1SnapshotsGetQueryError = unknown


export function useListSnapshotsV1SnapshotsGet<TData = Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>,
          TError,
          Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSnapshotsV1SnapshotsGet<TData = Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>,
          TError,
          Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSnapshotsV1SnapshotsGet<TData = Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Snapshots
 */

export function useListSnapshotsV1SnapshotsGet<TData = Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSnapshotsV1SnapshotsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSnapshotsV1SnapshotsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetSnapshotV1SnapshotsSnapshotIdGetUrl = (snapshotId: string,) => {




  return `/v1/snapshots/${snapshotId}`
}

/**
 * @summary Get Snapshot
 */
export const getSnapshotV1SnapshotsSnapshotIdGet = async (snapshotId: string, options?: Parameters<typeof customFetch>[1]): Promise<SnapshotOut> => {

  return customFetch<SnapshotOut>(getGetSnapshotV1SnapshotsSnapshotIdGetUrl(snapshotId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSnapshotV1SnapshotsSnapshotIdGetQueryKey = (snapshotId: string,) => {
    return [
    `/v1/snapshots/${snapshotId}`
    ] as const;
    }


export const getGetSnapshotV1SnapshotsSnapshotIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>, TError = HTTPValidationError>(snapshotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSnapshotV1SnapshotsSnapshotIdGetQueryKey(snapshotId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>> = ({ signal }) => getSnapshotV1SnapshotsSnapshotIdGet(snapshotId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: snapshotId !== null && snapshotId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSnapshotV1SnapshotsSnapshotIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>>
export type GetSnapshotV1SnapshotsSnapshotIdGetQueryError = HTTPValidationError


export function useGetSnapshotV1SnapshotsSnapshotIdGet<TData = Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>, TError = HTTPValidationError>(
 snapshotId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>,
          TError,
          Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSnapshotV1SnapshotsSnapshotIdGet<TData = Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>, TError = HTTPValidationError>(
 snapshotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>,
          TError,
          Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSnapshotV1SnapshotsSnapshotIdGet<TData = Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>, TError = HTTPValidationError>(
 snapshotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Snapshot
 */

export function useGetSnapshotV1SnapshotsSnapshotIdGet<TData = Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>, TError = HTTPValidationError>(
 snapshotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSnapshotV1SnapshotsSnapshotIdGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSnapshotV1SnapshotsSnapshotIdGetQueryOptions(snapshotId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSnapshotEventsV1SnapshotsSnapshotIdEventsGetUrl = (snapshotId: string,) => {




  return `/v1/snapshots/${snapshotId}/events`
}

/**
 * Live status/progress stream (SSE), like a run.
 * @summary Snapshot Events
 */
export const snapshotEventsV1SnapshotsSnapshotIdEventsGet = async (snapshotId: string, options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {

  return customFetch<unknown>(getSnapshotEventsV1SnapshotsSnapshotIdEventsGetUrl(snapshotId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSnapshotEventsV1SnapshotsSnapshotIdEventsGetQueryKey = (snapshotId: string,) => {
    return [
    `/v1/snapshots/${snapshotId}/events`
    ] as const;
    }


export const getSnapshotEventsV1SnapshotsSnapshotIdEventsGetQueryOptions = <TData = Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>, TError = HTTPValidationError>(snapshotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSnapshotEventsV1SnapshotsSnapshotIdEventsGetQueryKey(snapshotId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>> = ({ signal }) => snapshotEventsV1SnapshotsSnapshotIdEventsGet(snapshotId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: snapshotId !== null && snapshotId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SnapshotEventsV1SnapshotsSnapshotIdEventsGetQueryResult = NonNullable<Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>>
export type SnapshotEventsV1SnapshotsSnapshotIdEventsGetQueryError = HTTPValidationError


export function useSnapshotEventsV1SnapshotsSnapshotIdEventsGet<TData = Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>, TError = HTTPValidationError>(
 snapshotId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>,
          TError,
          Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSnapshotEventsV1SnapshotsSnapshotIdEventsGet<TData = Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>, TError = HTTPValidationError>(
 snapshotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>,
          TError,
          Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSnapshotEventsV1SnapshotsSnapshotIdEventsGet<TData = Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>, TError = HTTPValidationError>(
 snapshotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Snapshot Events
 */

export function useSnapshotEventsV1SnapshotsSnapshotIdEventsGet<TData = Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>, TError = HTTPValidationError>(
 snapshotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof snapshotEventsV1SnapshotsSnapshotIdEventsGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSnapshotEventsV1SnapshotsSnapshotIdEventsGetQueryOptions(snapshotId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateExportV1SnapshotsExportsPostUrl = () => {




  return `/v1/snapshots/exports`
}

/**
 * Start a server-side export build; poll the returned id (+ SSE) for progress.
 * @summary Create Export
 */
export const createExportV1SnapshotsExportsPost = async (exportRequest: ExportRequest, options?: Parameters<typeof customFetch>[1]): Promise<SnapshotOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<SnapshotOut>(getCreateExportV1SnapshotsExportsPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(exportRequest)
  }
);}





export const getCreateExportV1SnapshotsExportsPostMutationKey = () => ['createExportV1SnapshotsExportsPost'] as const;

export const getCreateExportV1SnapshotsExportsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExportV1SnapshotsExportsPost>>, TError,CreateExportV1SnapshotsExportsPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createExportV1SnapshotsExportsPost>>, TError,CreateExportV1SnapshotsExportsPostMutationVariables, TContext> => {

const mutationKey = getCreateExportV1SnapshotsExportsPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExportV1SnapshotsExportsPost>>, CreateExportV1SnapshotsExportsPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createExportV1SnapshotsExportsPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateExportV1SnapshotsExportsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createExportV1SnapshotsExportsPost>>>
    export type CreateExportV1SnapshotsExportsPostMutationBody = ExportRequest
    export type CreateExportV1SnapshotsExportsPostMutationError = HTTPValidationError
    export type CreateExportV1SnapshotsExportsPostMutationVariables = {data: ExportRequest}

    /**
 * @summary Create Export
 */
export const useCreateExportV1SnapshotsExportsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExportV1SnapshotsExportsPost>>, TError,CreateExportV1SnapshotsExportsPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createExportV1SnapshotsExportsPost>>,
        TError,
        CreateExportV1SnapshotsExportsPostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateExportV1SnapshotsExportsPostMutationOptions(options), queryClient);
    }

export const getDownloadV1SnapshotsSnapshotIdDownloadGetUrl = (snapshotId: string,) => {




  return `/v1/snapshots/${snapshotId}/download`
}

/**
 * Stream a built export bundle to the browser (chunked; never read into RAM).
 * @summary Download
 */
export const downloadV1SnapshotsSnapshotIdDownloadGet = async (snapshotId: string, options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {

  return customFetch<unknown>(getDownloadV1SnapshotsSnapshotIdDownloadGetUrl(snapshotId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadV1SnapshotsSnapshotIdDownloadGetQueryKey = (snapshotId: string,) => {
    return [
    `/v1/snapshots/${snapshotId}/download`
    ] as const;
    }


export const getDownloadV1SnapshotsSnapshotIdDownloadGetQueryOptions = <TData = Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>, TError = HTTPValidationError>(snapshotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadV1SnapshotsSnapshotIdDownloadGetQueryKey(snapshotId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>> = ({ signal }) => downloadV1SnapshotsSnapshotIdDownloadGet(snapshotId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: snapshotId !== null && snapshotId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadV1SnapshotsSnapshotIdDownloadGetQueryResult = NonNullable<Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>>
export type DownloadV1SnapshotsSnapshotIdDownloadGetQueryError = HTTPValidationError


export function useDownloadV1SnapshotsSnapshotIdDownloadGet<TData = Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>, TError = HTTPValidationError>(
 snapshotId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>,
          TError,
          Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadV1SnapshotsSnapshotIdDownloadGet<TData = Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>, TError = HTTPValidationError>(
 snapshotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>,
          TError,
          Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadV1SnapshotsSnapshotIdDownloadGet<TData = Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>, TError = HTTPValidationError>(
 snapshotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download
 */

export function useDownloadV1SnapshotsSnapshotIdDownloadGet<TData = Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>, TError = HTTPValidationError>(
 snapshotId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadV1SnapshotsSnapshotIdDownloadGet>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadV1SnapshotsSnapshotIdDownloadGetQueryOptions(snapshotId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getImportPreflightV1SnapshotsImportsPreflightPostUrl = () => {




  return `/v1/snapshots/imports/preflight`
}

/**
 * Validate a bundle against this target and return the plan BEFORE any write.
 * @summary Import Preflight
 */
export const importPreflightV1SnapshotsImportsPreflightPost = async (bodyImportPreflightV1SnapshotsImportsPreflightPost?: BodyImportPreflightV1SnapshotsImportsPreflightPost, options?: Parameters<typeof customFetch>[1]): Promise<PreflightOut> => {
    const formData = new FormData();
if(bodyImportPreflightV1SnapshotsImportsPreflightPost?.payload !== undefined) {
 formData.append(`payload`, bodyImportPreflightV1SnapshotsImportsPreflightPost.payload);
 }
if(bodyImportPreflightV1SnapshotsImportsPreflightPost?.file !== undefined && bodyImportPreflightV1SnapshotsImportsPreflightPost.file !== null) {
 formData.append(`file`, bodyImportPreflightV1SnapshotsImportsPreflightPost.file);
 }

  return customFetch<PreflightOut>(getImportPreflightV1SnapshotsImportsPreflightPostUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getImportPreflightV1SnapshotsImportsPreflightPostMutationKey = () => ['importPreflightV1SnapshotsImportsPreflightPost'] as const;

export const getImportPreflightV1SnapshotsImportsPreflightPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importPreflightV1SnapshotsImportsPreflightPost>>, TError,ImportPreflightV1SnapshotsImportsPreflightPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importPreflightV1SnapshotsImportsPreflightPost>>, TError,ImportPreflightV1SnapshotsImportsPreflightPostMutationVariables, TContext> => {

const mutationKey = getImportPreflightV1SnapshotsImportsPreflightPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importPreflightV1SnapshotsImportsPreflightPost>>, ImportPreflightV1SnapshotsImportsPreflightPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  importPreflightV1SnapshotsImportsPreflightPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportPreflightV1SnapshotsImportsPreflightPostMutationResult = NonNullable<Awaited<ReturnType<typeof importPreflightV1SnapshotsImportsPreflightPost>>>
    export type ImportPreflightV1SnapshotsImportsPreflightPostMutationBody = BodyImportPreflightV1SnapshotsImportsPreflightPost | undefined
    export type ImportPreflightV1SnapshotsImportsPreflightPostMutationError = HTTPValidationError
    export type ImportPreflightV1SnapshotsImportsPreflightPostMutationVariables = {data?: BodyImportPreflightV1SnapshotsImportsPreflightPost}

    /**
 * @summary Import Preflight
 */
export const useImportPreflightV1SnapshotsImportsPreflightPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importPreflightV1SnapshotsImportsPreflightPost>>, TError,ImportPreflightV1SnapshotsImportsPreflightPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importPreflightV1SnapshotsImportsPreflightPost>>,
        TError,
        ImportPreflightV1SnapshotsImportsPreflightPostMutationVariables,
        TContext
      > => {
      return useMutation(getImportPreflightV1SnapshotsImportsPreflightPostMutationOptions(options), queryClient);
    }

export const getCreateImportV1SnapshotsImportsPostUrl = () => {




  return `/v1/snapshots/imports`
}

/**
 * Import a bundle into this deployment (superuser). Runs preflight, then imports.
 * @summary Create Import
 */
export const createImportV1SnapshotsImportsPost = async (bodyCreateImportV1SnapshotsImportsPost?: BodyCreateImportV1SnapshotsImportsPost, options?: Parameters<typeof customFetch>[1]): Promise<SnapshotOut> => {
    const formData = new FormData();
if(bodyCreateImportV1SnapshotsImportsPost?.payload !== undefined) {
 formData.append(`payload`, bodyCreateImportV1SnapshotsImportsPost.payload);
 }
if(bodyCreateImportV1SnapshotsImportsPost?.file !== undefined && bodyCreateImportV1SnapshotsImportsPost.file !== null) {
 formData.append(`file`, bodyCreateImportV1SnapshotsImportsPost.file);
 }

  return customFetch<SnapshotOut>(getCreateImportV1SnapshotsImportsPostUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getCreateImportV1SnapshotsImportsPostMutationKey = () => ['createImportV1SnapshotsImportsPost'] as const;

export const getCreateImportV1SnapshotsImportsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImportV1SnapshotsImportsPost>>, TError,CreateImportV1SnapshotsImportsPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createImportV1SnapshotsImportsPost>>, TError,CreateImportV1SnapshotsImportsPostMutationVariables, TContext> => {

const mutationKey = getCreateImportV1SnapshotsImportsPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImportV1SnapshotsImportsPost>>, CreateImportV1SnapshotsImportsPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createImportV1SnapshotsImportsPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateImportV1SnapshotsImportsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createImportV1SnapshotsImportsPost>>>
    export type CreateImportV1SnapshotsImportsPostMutationBody = BodyCreateImportV1SnapshotsImportsPost | undefined
    export type CreateImportV1SnapshotsImportsPostMutationError = HTTPValidationError
    export type CreateImportV1SnapshotsImportsPostMutationVariables = {data?: BodyCreateImportV1SnapshotsImportsPost}

    /**
 * @summary Create Import
 */
export const useCreateImportV1SnapshotsImportsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImportV1SnapshotsImportsPost>>, TError,CreateImportV1SnapshotsImportsPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createImportV1SnapshotsImportsPost>>,
        TError,
        CreateImportV1SnapshotsImportsPostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateImportV1SnapshotsImportsPostMutationOptions(options), queryClient);
    }

export const getPinV1SnapshotsSnapshotIdPinPostUrl = (snapshotId: string,) => {




  return `/v1/snapshots/${snapshotId}/pin`
}

/**
 * Pin a bundle so the TTL reaper never deletes it (long-lived fixture).
 * @summary Pin
 */
export const pinV1SnapshotsSnapshotIdPinPost = async (snapshotId: string, options?: Parameters<typeof customFetch>[1]): Promise<SnapshotOut> => {

  return customFetch<SnapshotOut>(getPinV1SnapshotsSnapshotIdPinPostUrl(snapshotId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPinV1SnapshotsSnapshotIdPinPostMutationKey = () => ['pinV1SnapshotsSnapshotIdPinPost'] as const;

export const getPinV1SnapshotsSnapshotIdPinPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pinV1SnapshotsSnapshotIdPinPost>>, TError,PinV1SnapshotsSnapshotIdPinPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pinV1SnapshotsSnapshotIdPinPost>>, TError,PinV1SnapshotsSnapshotIdPinPostMutationVariables, TContext> => {

const mutationKey = getPinV1SnapshotsSnapshotIdPinPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pinV1SnapshotsSnapshotIdPinPost>>, PinV1SnapshotsSnapshotIdPinPostMutationVariables> = (props) => {
          const {snapshotId} = props ?? {};

          return  pinV1SnapshotsSnapshotIdPinPost(snapshotId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PinV1SnapshotsSnapshotIdPinPostMutationResult = NonNullable<Awaited<ReturnType<typeof pinV1SnapshotsSnapshotIdPinPost>>>

    export type PinV1SnapshotsSnapshotIdPinPostMutationError = HTTPValidationError
    export type PinV1SnapshotsSnapshotIdPinPostMutationVariables = {snapshotId: string}

    /**
 * @summary Pin
 */
export const usePinV1SnapshotsSnapshotIdPinPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pinV1SnapshotsSnapshotIdPinPost>>, TError,PinV1SnapshotsSnapshotIdPinPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pinV1SnapshotsSnapshotIdPinPost>>,
        TError,
        PinV1SnapshotsSnapshotIdPinPostMutationVariables,
        TContext
      > => {
      return useMutation(getPinV1SnapshotsSnapshotIdPinPostMutationOptions(options), queryClient);
    }

export const getUnpinV1SnapshotsSnapshotIdUnpinPostUrl = (snapshotId: string,) => {




  return `/v1/snapshots/${snapshotId}/unpin`
}

/**
 * @summary Unpin
 */
export const unpinV1SnapshotsSnapshotIdUnpinPost = async (snapshotId: string, options?: Parameters<typeof customFetch>[1]): Promise<SnapshotOut> => {

  return customFetch<SnapshotOut>(getUnpinV1SnapshotsSnapshotIdUnpinPostUrl(snapshotId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUnpinV1SnapshotsSnapshotIdUnpinPostMutationKey = () => ['unpinV1SnapshotsSnapshotIdUnpinPost'] as const;

export const getUnpinV1SnapshotsSnapshotIdUnpinPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unpinV1SnapshotsSnapshotIdUnpinPost>>, TError,UnpinV1SnapshotsSnapshotIdUnpinPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unpinV1SnapshotsSnapshotIdUnpinPost>>, TError,UnpinV1SnapshotsSnapshotIdUnpinPostMutationVariables, TContext> => {

const mutationKey = getUnpinV1SnapshotsSnapshotIdUnpinPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unpinV1SnapshotsSnapshotIdUnpinPost>>, UnpinV1SnapshotsSnapshotIdUnpinPostMutationVariables> = (props) => {
          const {snapshotId} = props ?? {};

          return  unpinV1SnapshotsSnapshotIdUnpinPost(snapshotId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnpinV1SnapshotsSnapshotIdUnpinPostMutationResult = NonNullable<Awaited<ReturnType<typeof unpinV1SnapshotsSnapshotIdUnpinPost>>>

    export type UnpinV1SnapshotsSnapshotIdUnpinPostMutationError = HTTPValidationError
    export type UnpinV1SnapshotsSnapshotIdUnpinPostMutationVariables = {snapshotId: string}

    /**
 * @summary Unpin
 */
export const useUnpinV1SnapshotsSnapshotIdUnpinPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unpinV1SnapshotsSnapshotIdUnpinPost>>, TError,UnpinV1SnapshotsSnapshotIdUnpinPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unpinV1SnapshotsSnapshotIdUnpinPost>>,
        TError,
        UnpinV1SnapshotsSnapshotIdUnpinPostMutationVariables,
        TContext
      > => {
      return useMutation(getUnpinV1SnapshotsSnapshotIdUnpinPostMutationOptions(options), queryClient);
    }

